// (function ($) {
//     var $body = $('body'),
//         $doc = $(document),
//         $html = $('html'),
//         $win = $(window),
//         sliderNavHTML;

//     $doc.ready(() => {
//         $doc.ajaxStart(() => {
//             halo.isAjaxLoading = true;
//         });

//         $doc.ajaxStop(() => {
//             halo.isAjaxLoading = false;
//         });

//         halo.ready();
//     });

//     document.addEventListener("DOMContentLoaded", function () {
//         halo.init();
//     });

//     window.onload = function() { 
//         halo.initProductPage();
//     }

//     var halo = {
//         haloTimeout: null,
//         isAjaxLoading: false,

//         ready: function (){
//             this.loaderScript();
//             this.loaderProductBlock();
            
//             if (navigator.userAgent.match(/Mac OS X.*(?:Safari|Chrome)/) && ! navigator.userAgent.match(/Chrome/)) {
//                 document.body.classList.add('safari')
//             } else {
//                 document.body.classList.add('chrome')
//             }

//             if (typeof InstallTrigger !== 'undefined') document.body.classList.add('firefox');

//             const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//             if (isIOS) document.body.classList.add('iOS')

//             if($body.hasClass('template-product')) {
//                 this.loaderRecommendationsBlock();
//             }

//             if($('[data-product-tab-block]').length) {
//                 this.clickedActiveProductTabs();
//             }

//             if ($body.hasClass('product-card-layout-07') || $body.hasClass('product-card-layout-08') ) {
//                 this.calculateTranslateYHeight()
//             }
            
//             window.sharedFunctions = {
//                 setLocalStorageProductForWishlist: this.setLocalStorageProductForWishlist,
//                 checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
//                 productBlockSilder: this.productBlockSilder,    
//                 calculateTranslateYHeight: this.calculateTranslateYHeight,
//                 productCountdownCard: halo.productCountdownCard,
//                 swapHoverVideoProductCard: halo.swapHoverVideoProductCard,
//                 updateSidebarCart: halo.updateSidebarCart,
//             }
//         },
        
//         init: function () {
//             this.initMultiTab();
//             this.initMultiTabMobile();
//             this.productBlockInfiniteScroll();
//             this.initGlobalCheckbox();
//             this.initColorSwatch();
//             this.initAddToCart();
//             this.initBuyNow();
//             this.initQuickShop();
//             this.initQuickCart();
//             this.initNotifyInStock();
//             this.initCompareProduct();
//             this.initWishlist();
//             this.initAskAnExpert();
//             this.initHeader();
//             this.headerLanguageCurrency();
//             this.headerMasonry();
//             this.initLiveChat();
//             this.headerSidebarSearch();
//             this.headerStickySearchForm();
//             this.initCountdown();
//             this.collectionCountdown();
//             this.handleScrollDown();
//             this.initVideoPopup();
//             this.swapHoverVideoProductCard();
//             this.initDynamicBrowserTabTitle();
//             this.initWarningPopup();
//             this.clickIconScrollSection();
//             this.specialBanner();
//             this.formMessage();
//             this.typingAnimation();
//             this.spotlightproductSlider();
//             this.doBeforeMegaMenuProductBlock();

//             if ($('.lookbook-carousel').length) {
//                 this.lookbookCarousel();
//             }

//             // Init Quick View 
//             if (window.quick_view.show || window.quick_view.show_mb) {
//                 this.initQuickView();
//             }

//             // Init Mobile Menu 
//             if (window.innerWidth < 1025) {
//                 this.menuSidebarMobile();
//                 this.menuSidebarMobileToggle();
//             }

//             // Check Lazyload Done
//             const loadingImages = document.querySelectorAll('.media--loading-effect img')
//             const productGrid = document.getElementById('main-collection-product-grid')

//             if (loadingImages.length > 0 || productGrid) {
//                 this.initLazyloadObserver(loadingImages, productGrid);
//             }

//             if($body.hasClass('show_effect_close')) {
//                 this.backgroundOverlayHoverEffect();
//                 this.backgroundOverlayHoverEffect1();
//             }

//             if($body.hasClass('template-cart')) {
//                 this.updateGiftWrapper();
//                 this.activeCheckboxStickyCartMobile();
//             }

//             if($body.hasClass('template-product') || $('.product-details').hasClass('featured-product')) {
//                 this.initProductBundle();
//                 this.articleGallery();
//                 this.toggleSidebarMobile(); 
//                 this.initCollapseSidebarBlock();    
//                 this.initCategoryActive();
//                 this.productCustomInformation();
//                 this.iconZoomClickMobile();
//                 this.productBlockSilderSidebar();
//             }

//             if($body.hasClass('template-blog') || $body.hasClass('template-article')) {
//                 this.initCollapseSidebarBlock();
//                 this.initCategoryActive();
//                 this.toggleSidebarMobile();
//                 this.initBlogMasonry();
//                 this.productBlockSilderSidebar();
//                 this.productBlockSilderArticle();
//             }

//             if($body.hasClass('template-article')) {
//                 this.articleGallery();
//             }

//             if($body.hasClass('template-collection') || $body.hasClass('template-search')) {
//                 this.initCollapseSidebarBlock();
//                 this.initCategoryActive();
//                 this.toggleSidebarMobile();
//                 this.productBlockSilderSidebar();
//                 this.initInfiniteScrolling();
//                 this.initQuickShopProductList();
//             }

//             if($body.hasClass('template-list-collections')) {
//                 this.toggleSidebarMobile();
//                 this.productBlockSilderSidebar();
//                 this.initCategoryActive();
//             }

//             if($body.hasClass('template-collection') && $('.collection-express-order').length) {
//                 this.toggleVariantsForExpressOrder();
//                 this.initExpressOrderAddToCart();
//             }

//             if($body.hasClass('product-card-layout-08')) {
//                 halo.productCountdownCard();
//             }
            
//             halo.checkScrollLayoutForRecenlyViewed();
            

//             let checkMenuMobile;
//             window.innerWidth > 1024 ? checkMenuMobile = true : checkMenuMobile = false;

//             $win.on('resize', () => {
//                 this.headerSidebarSearch();
//                 this.specialBanner();
//                 this.specialBannerSlider();
//                 this.unsymmetricalSlider();
//                 this.doBeforeMegaMenuProductBlock();
//                 if (window.innerWidth > 1024) {
//                     document.body.classList.remove('menu_open')
//                 } else if (checkMenuMobile) {
//                     checkMenuMobile = false;
//                     this.menuSidebarMobile()
//                     this.menuSidebarMobileToggle()
//                     this.initMultiTab()
//                     this.initMultiTabMobile()
//                 }
//             });
//         },

//         initProductPage: function () {
//             if($('.template-product .product-details:not(.featured-product)')) {
//                 this.initProductView($('.product-details:not(.featured-product) .halo-productView'));
//             }
//             if($('.product-details.featured-product')) {
//                 this.initProductView($('.product-details.featured-product .halo-productView'));
//             }
//         },
        
//         checkNeedToConvertCurrency: function () {
//             var currencyItem = $('.dropdown-item[data-currency]');
//             if (currencyItem.length) {
//                 return (window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
//             } else {
//                 return;
//             }
//         },

//         loaderScript: function() {
//             var load = function(){
//                 var script = $('[data-loader-script]');

//                 if (script.length > 0) {
//                     script.each((index, element) => {
//                         var $this = $(element),
//                             link = $this.data('loader-script'),
//                             top = element.getBoundingClientRect().top;

//                         if (!$this.hasClass('is-load')){
//                             if (top < window.innerHeight + 100) {
//                                 halo.buildScript(link);
//                                 $('[data-loader-script="' + link + '"]').addClass('is-load');
//                             }
//                         }
//                     })
//                 }
//             }
            
//             load();
//             window.addEventListener('scroll', load);
//         },

//         buildScript: function(name) {
//             var loadScript = document.createElement("script");
//             loadScript.src = name;
//             document.body.appendChild(loadScript);
//         },

//         buildStyleSheet: function(name, $this) {
//             if (name == '') return;
//             const loadStyleSheet = document.createElement("link");
//             loadStyleSheet.rel = 'stylesheet';
//             loadStyleSheet.type = 'text/css';
//             loadStyleSheet.href = name;
//             $this.parentNode.insertBefore(loadStyleSheet, $this);
//         },

//         loaderProductBlock: function() {
//             var isAjaxLoading = false;

//             $doc.ajaxStart(() => {
//                 isAjaxLoading = true;
//             });

//             $doc.ajaxStop(() => {
//                 isAjaxLoading = false;
//             });

//             const handler = (entries, observer) => {
//                 entries.forEach(entry => {
//                     if (entry.isIntersecting) {
//                         const $block = $(entry.target);
//                         if ($block.hasClass('ajax-loaded')) return;

//                         var url = $block.data('collection'),
//                             layout = $block.data('layout'),
//                             limit = $block.data('limit'),
//                             image_ratio = $block.data('image-ratio'),
//                             swipe = $block.data('swipe'),
//                             sectionId = $block.attr('sectionId'),
//                             hasCountdown = $block.attr('hasCountdown');

//                         if(url != null && url != undefined) {
//                             $.ajax({
//                                 type: 'get',
//                                 url: window.routes.root + '/collections/' + url,
//                                 cache: false,
//                                 data: {
//                                     view: 'ajax_product_block',
//                                     constraint: 'limit=' + limit + '+layout=' + layout + '+sectionId=' + sectionId + '+imageRatio=' + image_ratio + '+swipe=' + swipe + '+hasCountdown=' + hasCountdown
//                                 },
//                                 beforeSend: function () {
//                                     $block.addClass('ajax-loaded');
//                                 },
//                                 success: function (data) {
//                                     if (url != '') {
//                                         const res = halo.handleResponse($(data), 0, limit);
//                                         if (layout == 'grid') {
//                                             $block.find('.products-grid').html(res);
//                                         } else if (layout == 'slider'){
//                                             $block.find('.products-carousel').html(res);
//                                         } else if (layout == 'scroll') {
//                                             $block.find('.products-flex').html(res);
//                                         }
                                       
//                                         $block.find('.card .variants-popup-content .selector-wrapper .swatch-element').each(function() {
//                                             const $input = $(this).find('input');
//                                             const $label = $(this).find('label');

//                                             $input.attr({
//                                                 id: ($input.attr('id') || '') + sectionId,
//                                                 name: ($input.attr('name') || '') + sectionId
//                                             });
//                                             $label.attr('for', ($label.attr('for') || '') + sectionId);
//                                         });

//                                         $block.find('.card').each(function() {
//                                             const $qsForm = $(this).find('.variants-popup-content form');
//                                             const $acForm = $(this).find('.card-action form');
//                                             const $select = $(this).find('.variants-popup-content select');
//                                             const $acButton = $(this).find('.card-action form button');
//                                             const $qsButton = $(this).find('.variants-popup-content .product-card__button2 button');

//                                             $qsForm.attr('id', ($qsForm.attr('id') || '') + sectionId);
//                                             $acForm.attr('id', ($acForm.attr('id') || '') + sectionId);
//                                             $select.attr('id', ($select.attr('id') || '') + sectionId);
//                                             $acButton.attr('data-form-id', ($acButton.attr('data-form-id') || '') + sectionId);
//                                             $qsButton.attr('data-form-id', ($qsButton.attr('data-form-id') || '') + sectionId);
//                                         });

//                                     }
//                                 },
//                                 complete: function () {
//                                     if (layout == 'slider') {
//                                         halo.productBlockSilder($block);
//                                     }

//                                     if ($block.hasClass('special-banner__product') && layout == 'grid' && window.innerWidth < 1200) {
//                                         $block.find('.special-banner__products--grid').addClass('products-carousel');
//                                         halo.productBlockSilder($block);
//                                     }

//                                     if ($block.hasClass("halo-block-unsymmetrical") && layout == 'grid' && window.innerWidth < 1200) {
//                                         halo.unsymmetricalSlider($block);
//                                     }
                                    
//                                     if(window.compare.show){
//                                         var $compareLink = $('[data-compare-link]');

//                                         halo.setLocalStorageProductForCompare($compareLink);
//                                     }

//                                     halo.swapHoverVideoProductCard();

//                                     if(window.wishlist.show){
//                                         halo.setLocalStorageProductForWishlist();
//                                     }

//                                     if (halo.checkNeedToConvertCurrency()) {
//                                         Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                                     };

//                                     if ($('body').hasClass('cursor-fixed__show')){
//                                         window.sharedFunctionsAnimation.onEnterButton();
//                                         window.sharedFunctionsAnimation.onLeaveButton();
//                                     }

//                                     if($body.hasClass('product-card-layout-08')) {
//                                         halo.productCountdownCard();
//                                     }

//                                     if ($body.hasClass('product-card-layout-07') || $body.hasClass('product-card-layout-08')) {
//                                         halo.calculateTranslateYHeight()
//                                     }
//                                 }
//                             });
//                         } else {
//                             $block.addClass('ajax-loaded');

//                             if (layout == 'slider') {
//                                 halo.productBlockSilder($block);
//                             }

//                             if (halo.checkNeedToConvertCurrency()) {
//                                 Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                             };
//                         }
//                     }
//                 })
//             }

//             this.productBlock = document.querySelectorAll('[data-product-block]');

//             const config = {
//                 rootMargin: '0px 0px 200px 0px',
//             }

//             this.observer = new IntersectionObserver(handler, config);
//             this.productBlock.forEach(block => {
//                 this.observer.observe(block);
//             });
//         },

//         handleResponse($res, productToShow, limit) {
//             $res = $res.splice(productToShow, limit);
//             return $res
//         },

//         loaderRecommendationsBlock: function(){
//             halo.buildRecommendationBlock();
//         },

//         headerMasonry: function(){
//             $('.menu-dropdown__wrapper [data-masonry]').masonry({
//               columnWidth: '.grid-sizer',
//               itemSelector: '[data-gridItem]'
//             });
//         },

//         initLiveChat: function () {
//             var $item_globe = $('.live-wrapper-icon');
//             $item_globe.on('click', function (e) {
//                 $(this).parent().toggleClass('live_help--active');          
//             });

//             $body.on('click', function (e) {
//                 if(($('.live_help').hasClass('live_help--active')) && ($(event.target).closest('.live_help').length === 0)){
//                     e.preventDefault();
//                     $('.live_help').removeClass('live_help--active');
//                 }
//             });
//         },

//         initHeader: function() {
//             const headerAll = document.querySelectorAll('[class*="section-header"]')
//             if (headerAll) {
//                 let index = headerAll.length + 20;
//                 headerAll.forEach((element) => {
//                     if (element.classList.contains('section-header-mobile')) return;
//                     element.setAttribute('data-index', index);
//                     element.style.zIndex = index;
//                     index--
//                 })

//                 const headerBasicTransparent = document.querySelector('.header-basic--transparent')
//                 if (headerBasicTransparent && document.body.classList.contains('template-index')) {
//                     const height = headerBasicTransparent.offsetHeight,
//                         navTransparent = document.querySelector('.header-navigation[class*="--transparent"]')
//                     if (navTransparent) {
//                         navTransparent.style.top = `${height}px`
//                         navTransparent.classList.add('has-top')
//                     }
//                 }
//             }
//         },

//         headerLanguageCurrency: function() {
//             if (!document.querySelector('.header-language_currency')) return;
//             const header = document.querySelectorAll('[class*="section-header-"]')

//             document.addEventListener('click', (event) => {
//                 const $target = event.target;
//                 const $headerLanguageCurrency = $target.closest('.header-language_currency');
//                 const languageCurrency = $headerLanguageCurrency?.querySelector('.top-language-currency');
//                 const dropdownCurrency = $headerLanguageCurrency?.querySelector('.dropdown-currency');
//                 const dropdownLanguage = $headerLanguageCurrency?.querySelector('.dropdown-language');

//                 if ($target.matches('.header-language_currency') || $target.closest('.header-language_currency')) {
//                     if ($target.matches('.icon-languageCurrency') || $target.closest('.icon-languageCurrency')) {
//                         languageCurrency?.classList.toggle('show')
//                     }
//                     else if (($target.matches('.top-language-currency') || $target.closest('.top-language-currency')) && !document.querySelector('.icon-languageCurrency')) {
//                         languageCurrency?.classList.toggle('show')
//                     }

//                     if ($target.matches('.halo-top-currency') || $target.closest('.halo-top-currency')) {
//                         dropdownLanguage?.classList.remove('show')
//                         dropdownCurrency?.classList.toggle('show')
//                     }
                    
//                     if ($target.matches('.halo-top-language') || $target.closest('.halo-top-language')) {
//                         dropdownCurrency?.classList.remove('show')
//                         dropdownLanguage?.classList.toggle('show')
//                     }

//                     if ($target.matches('.dropdown-menu .dropdown-item')) {
//                         dropdownCurrency?.classList.remove('show')
//                         dropdownLanguage?.classList.remove('show')
//                     }
//                 }
//                 else {
//                     header.forEach(element => {
//                         element.querySelector('.top-language-currency')?.classList.remove('show')
//                         element.querySelector('.dropdown-currency')?.classList.remove('show')
//                         element.querySelector('.dropdown-language')?.classList.remove('show')
//                     })
//                 }
//             })
//         },

//         headerSidebarSearch: function() {
//             var headerSearchPC = $('.header-top .header__search .search_details'),
//                 headerSearchMB = $('#search-form-mobile .halo-sidebar-wrapper .search_details'),
//                 headerwraperSearchPC = $('.header-top .header__search'),
//                 headerwraperSearchMB = $('#search-form-mobile .halo-sidebar-wrapper'),
//                 searchDetails = $('.search_details'),
//                 predictiveSearchPC =  $('.header-top .header__search predictive-search'),
//                 predictiveSearchMB = $('#search-form-mobile .halo-sidebar-wrapper predictive-search');
 
//              if (predictiveSearchPC.length === 0) predictiveSearchPC =  $('.header-top .header__search .search_details');
//              if (predictiveSearchMB.length === 0) predictiveSearchMB =  $('#search-form-mobile .halo-sidebar-wrapper .search_details');
//             if (window.innerWidth < 1025) {
//                 if($('.header').hasClass('header-01')){
//                     predictiveSearchPC.appendTo(headerwraperSearchMB);
//                 }
//                 searchDetails.attr('open','true');
//                 $('[data-search-mobile]').on('click', (event) => {
//                     event.preventDefault();
//                     $('body').addClass('open_search_mobile');
//                 });
//                 $('[data-search-close-sidebar], .background-overlay').on('click', (event) => {
//                     event.preventDefault();
//                     $('body').removeClass('open_search_mobile');
//                 });
//             }else{
//                 if($('.header').hasClass('header-01')){
//                     predictiveSearchMB.appendTo(headerwraperSearchPC);
//                 }
//                 searchDetails.removeAttr('open');

//                 $('.search-modal__close-button').on('click', (event) => {
//                     $('.search_details').removeAttr('open');
//                     $('body').removeClass('open_search_menu');
//                 });

//                 // Click Search Icon On Header Nav And Sticky Menu
//                 $('[data-search-menu]').on('click', (event) => {
//                     event.preventDefault();
//                     $('body').addClass('open_search_menu');
//                 });
//             }
//         },

//         headerStickySearchForm: function() {
//             var iconSearchSlt = '[data-search-sticky-form]';
//             var iconSearchMenu = '[data-search-menu-sticky-form] .icon-search';
//             var iconSearchMenuCustom = '[data-search-menu-sticky-form] .icon-search-custom';

//             if ($(window).width() > 1025) {
//                 $(document).off('click.toggleSearch', iconSearchSlt).on('click.toggleSearch', iconSearchSlt, function(event) {
//                     event.preventDefault();
//                     event.stopPropagation();
//                     $('body').addClass('sticky-search-open');
//                     $('.search_details').attr('open','true');
//                 });

//                 $(document).off('click.hideSearch').on('click.hideSearch', function(event) {
//                     var formSearch = $('.search-modal__form'),
//                         quickSearch = $('.quickSearchResultsWrap');
//                     if ($('body').hasClass('sticky-search-open') && !formSearch.has(event.target).length && !quickSearch.has(event.target).length && !$(event.target).hasClass('search-modal__content') && $(event.target).closest('.search-modal__content').length == 0) {
//                         $('body').removeClass('sticky-search-open');
//                         $('[class*="section-header-"]').removeClass('sticky-search-menu-open');
//                         $('.search_details').removeAttr('open');
//                     }
//                 });

//                 // Click Search Icon On Header Nav And Sticky Menu
//                 $(document).off('click.toggleSearch', iconSearchMenu).on('click.toggleSearch', iconSearchMenu, function(event) {
//                     event.preventDefault();
//                     event.stopPropagation();
//                     $(event.target).closest('[class*="section-header-"]').addClass('sticky-search-menu-open');
//                     $(event.target).closest('.section-header-navigation').css('z-index', '101');
//                     $('.search_details').attr('open','true');
//                 });

//                 // Click Search Icon On Header Hamburger - Search Dropdown Style Layout Custom
//                 $(document).off('click.toggleSearch', iconSearchMenuCustom).on('click.toggleSearch', iconSearchMenuCustom, function(event) {
//                     $(event.target).closest('[class*="section-header-"]').addClass('sticky-search-menu-custom-open');
//                 });

//                 $(document).off('click.hideSearchSticky').on('click.hideSearchSticky', function(event) {
//                     var formSearch = $('.header-navigation .search-modal__form'),
//                         quickSearch = $('.header-navigation .quickSearchResultsWrap');
//                     if ($('[class*="section-header-"]').hasClass('sticky-search-menu-open') && !formSearch.has(event.target).length && !quickSearch.has(event.target).length && !$(event.target).hasClass('search-modal__content') && $(event.target).closest('.search-modal__content').length == 0) {
//                         const header = $(iconSearchMenu).closest('.section-header-navigation');
//                         const index = header.data('index');

//                         $('[class*="section-header-"]').removeClass('sticky-search-menu-open');
                        
//                         header.css('z-index', index);
//                         $('.header-navigation .search_details').removeAttr('open');
//                         if(quickSearch.hasClass('is-show')) {
//                             quickSearch.removeClass('is-show').addClass('hidden')
//                         }
//                     }
//                     if (($(event.target).closest('.search-modal__content').length === 0)){
//                         $('body').removeClass('open_search_menu');
//                         $('[class*="section-header-"]').removeClass('sticky-search-menu-custom-open');
//                     }
//                 });
//             }
//         },

//         menuSidebarMobile: function() {
//             var buttonIconOpen = $('.mobileMenu-toggle'),
//                 buttonClose = $('.halo-sidebar-close, .background-overlay');

//             const menuSidebarMobileOpen = () => {
//                 $body.addClass('menu_open');
//                 $('.list-menu-loading').remove();
//                 if(window.mobile_menu == 'default'){
//                     if(!$('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').length){
//                         $('.header .header__inline-menu').appendTo('#navigation-mobile .site-nav-mobile.nav');
//                     }
//                 }
//                 if(!$('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').length){
//                     $('.header-top--wrapper .header-top--right .free-shipping-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
//                 }
//                 if(!$('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').length){
//                     $('.header-top--wrapper .header-top--right .customer-service-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
//                 }
//                 if(!$('#navigation-mobile .site-nav-mobile.nav-account .header__location').length){
//                     $('.header-top--wrapper .header-top--right .header__location').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
//                 }
//                 if(!$('#navigation-mobile .top-language-currency').length){
//                     if($('.header').hasClass('header-03')){
//                         $('.header .header-bottom-right .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
//                     }else if($('.header').hasClass('header-05')){
//                         $('.header .header-top--left .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
//                     }else{
//                         $('.header .header-language_currency .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
//                     }
//                 }
//             }

//             if (document.body.matches('.menu_open')) {
//                 menuSidebarMobileOpen();
//             }

//             buttonIconOpen.off('click.toggleCurrencyLanguage').on('click.toggleCurrencyLanguage', (event) =>{
//                 event.preventDefault();
//                 menuSidebarMobileOpen();
//             });

//             buttonClose.off('click.toggleCloseCurrencyLanguage').on('click.toggleCloseCurrencyLanguage', () =>{
//                 $body.removeClass('menu_open');
//                 $('#navigation-mobile').off('transitionend.toggleCloseMenu').on('transitionend.toggleCloseMenu', () => {
//                     if (!$body.hasClass('menu_open')) {

//                         if(!$('.header .header__inline-menu').length){
//                             if($('.header').hasClass('header-03') || $('.header').hasClass('header-04') || $('.header').hasClass('header-07') || $('.header').hasClass('header-08')){
//                                 $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').appendTo('.header .header-bottom--wrapper .header-bottom-left');
//                             }else{
//                                 $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').appendTo('.header .header-bottom--wrapper');
//                             }
//                         }
//                         if(!$('.header-top--wrapper .header-top--right .free-shipping-text').length){
//                             if(!$('.header-04').hasClass('style_2')){
//                                 $('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').insertBefore('.header-top--wrapper .header-top--right .header__group');
//                             }
//                         }
//                         if(!$('.header-top--wrapper .header-top--right .header__location').length){
//                             $('#navigation-mobile .site-nav-mobile.nav-account .header__location').insertBefore('.header-top--wrapper .header-top--right .header__group');
//                         }
//                         if(!$('.header-top--wrapper .header-top--right .customer-service-text').length){
//                             if($('.header').hasClass('header-03')){
//                                 $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .header__group .header__icon--wishlist');
//                             }else{
//                                 $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .top-language-currency');
//                             }
//                         }
//                         if(!$('.header-language_currency .top-language-currency').length){
//                             if($('.header').hasClass('header-03')){
//                                 $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
//                             }else if($('.header').hasClass('header-04')){
//                                 $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
//                             }else if($('.header').hasClass('header-05')){
//                                 $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-top--wrapper .header-top--left .header-language_currency');
//                             }else{
//                                 $('#navigation-mobile .site-nav-mobile .top-language-currency').insertBefore('.header .header-language_currency .header__search');
//                             }
//                         }
//                     }
//                 })
                    
//             });

//             $doc.on('click', '.halo-sidebar-close', function (e) {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 $body.removeClass('menu_open');
//             });
//         },

//         menuSidebarMobileToggle: function() {
//             $body.on('click', '.site-nav-mobile .list-menu .menu_mobile_link', function (e) {
//                 if(!e.currentTarget.classList.contains('list-menu__item--end')){
//                     e.preventDefault();
//                     e.stopPropagation();
//                     var $target = $(this);
//                     var $parent = $target.parent();
//                     var $menuDislosure1 = $target.parent().find('ul.list-menu--disclosure-1');

//                     $parent.removeClass('is-hidden').addClass('is-open').removeClass('d-none');
//                     $menuDislosure1.off('transitionend.toggleMenuLink1').on('transitionend.toggleMenuLink1', () => {
//                         if ($parent.hasClass('is-open') && !$parent.hasClass('is-hidden') && !$parent.hasClass('d-none')) {
//                             // $parent.addClass('d-none')
//                             $parent.siblings().removeClass('is-open').addClass('is-hidden').removeClass('d-none');
//                         }
//                     })

//                     // $target.parent().siblings().removeClass('is-open').addClass('is-hidden');
//                     // $target.parent().removeClass('is-hidden').addClass('is-open');
//                 }
//             });

//             $body.on('click', '.site-nav-mobile .list-menu .menu_mobile_link_2', function (e) {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 var $target = $(this);
//                 var $target = $(this);
//                 var $parent = $target.parent().parent();
//                 var $menuDislosure2 = $target.parent().find('ul.list-menu--disclosure-2');
//                 var $parentToScroll = $target.parent().parent().parent().parent().parent().parent();

//                 $parent.removeClass('is-hidden').addClass('is-open').removeClass('d-none');
//                 $menuDislosure2.off('transitionend.toggleMenuLink2').on('transitionend.toggleMenuLink2', () => {
//                     if ($parent.hasClass('is-open') && !$parent.hasClass('is-hidden') && !$parent.hasClass('d-none')) {
//                         $parent.addClass('d-none')
//                         $parent.siblings().removeClass('is-open').addClass('is-hidden').removeClass('d-none');
//                         $parentToScroll.animate({
//                             scrollTop: 0
//                         }, 0);
//                     }
//                 })

//                 // if($('.header').hasClass('header-04') || $('.header').hasClass('header-01') || $('.header').hasClass('header-02')){
//                     // $target.parent().parent().siblings().removeClass('is-open').addClass('is-hidden');
//                     // $target.parent().parent().removeClass('is-hidden').addClass('is-open');
//                     // $target.parent().parent().parent().parent().parent().parent().animate({
//                     //     scrollTop: 0
//                     // }, 0);
//                 // } else{
//                 //     $target.parents('.site-nav').siblings().removeClass('is-open').addClass('is-hidden');
//                 //     $target.parents('.site-nav').removeClass('is-hidden').addClass('is-open');
//                 //     $target.parents('.menu-dropdown__wrapper').animate({
//                 //         scrollTop: 0
//                 //     }, 0);
//                 // }

//                 if($('.menu-dropdown').hasClass('megamenu_style_5') || $('.menu-dropdown').hasClass('megamenu_style_4') || $('.menu-dropdown').hasClass('megamenu_style_3') || $('.menu-dropdown').hasClass('megamenu_style_2') || $('.menu-dropdown').hasClass('megamenu_style_1')){
//                     $target.parents('.menu-dropdown').animate({
//                         scrollTop: 0
//                     }, 0);
//                 }

//                 $target.parents('.menu-dropdown').addClass('is-overflow');
//             });

//             $body.on('click', '.nav-title-mobile', function (e) {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 var $target = $(this),
//                     $parentLv1 = $target.parent().parent().parent().parent('.is-open'),
//                     $parentLv2 = $target.parent().parent().parent('.is-open'),
//                     $parentLv3 = $target.parent().parent('.is-open');

//                 $parentLv1.siblings().removeClass('is-hidden');
//                 $parentLv1.removeClass('is-open').removeClass('d-none');
//                 $parentLv2.siblings().removeClass('is-hidden');
//                 $parentLv2.removeClass('is-open').removeClass('d-none');
//                 $parentLv3.siblings().removeClass('is-hidden');
//                 $parentLv3.removeClass('is-open').removeClass('d-none');
//                 $('.menu-dropdown').removeClass('is-overflow');
//             });

//             if(window.mobile_menu != 'default'){
//                 $doc.on('click', '[data-mobile-menu-tab]', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();

//                     var tabItem = event.currentTarget.closest('li'),
//                         tabTarget = event.currentTarget.dataset.target;

//                     if(!tabItem.classList.contains('is-active')){

//                         document.querySelector('[data-navigation-tab-mobile]').querySelectorAll('li').forEach((element) =>{
//                             if(element != tabItem){
//                                 element.classList.remove('is-active');
//                             } else {
//                                 element.classList.add('is-active');

//                                 document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((tab) =>{
//                                     if(tab.getAttribute('id') == tabTarget) {
//                                         tab.classList.remove('is-hidden');
//                                         tab.classList.add('is-visible');
//                                     } else {
//                                         tab.classList.remove('is-visible');
//                                         tab.classList.add('is-hidden');
//                                     }
//                                 });
//                             }
//                         });
//                     }
//                 });
//             };

//             $(document).on('click', '[data-navigation-mobile] .no-megamenu .menu-lv-1__action', (event) => {
//                 const hash = $(event.currentTarget).attr('href').split('#')[1];

//                 if (hash != undefined && hash != '' && $(`#${hash}`).length) {
//                     $('body').removeClass('menu_open');
//                     $('html, body').animate({
//                         scrollTop: $(`#${hash}`).offset().top
//                     }, 700);
//                 }
//             })
//         },

//         setCookie(cname, cvalue, exdays){
//             const d = new Date();
//             d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//             const expires = 'expires=' + d.toUTCString();
//             document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
//         },

//         initMultiTab: function() {
//             let designMode, showMenu, check = true;
//             document.body.matches('.shopify-design-mode') ? designMode = true : designMode = false;
//             document.body.matches('.menu_open') ? showMenu = true : showMenu = false;
                
//             const loadMenuDefault = () => {
//                 if (check) {
//                     check = false;
//                     halo.initMobileMenuDefault(url)
//                 }
//             }

//             const loadMenuTab = () => {
//                 if (check) {
//                     check = false;
//                     halo.initMultiTabMobile()
//                 }
//             }
            
//             if($('[data-menu-tab]').length > 0){
                
//                 var active = $('[data-menu-tab] li.is-active').data('load-page'),
//                     url = window.routes.root + `/search?type=product&q=${active}&view=ajax_mega_menu`;
              
//                 if($body.hasClass('template-index')){
//                     if ($win.width() < 1025) {
//                         if(window.mobile_menu == 'default'){
//                             window.addEventListener('load', () => {
//                                 if (designMode || showMenu) {
//                                     loadMenuDefault();
//                                 }
//                                 else {
//                                     document.body.addEventListener('click', () => {
//                                         loadMenuDefault();
//                                     }, false)
//                                 }
//                             }, false)
//                         } else {
//                             window.addEventListener('load', () => {
//                                 if (designMode || showMenu) {
//                                     loadMenuTab();
//                                 }
//                                 else {
//                                     document.body.addEventListener('click', () => {
//                                         loadMenuTab();
//                                     }, false)
//                                 }
//                             }, false)
//                         }
//                     }
//                 } else {
//                     if ($win.width() < 1025) {
//                         if(window.mobile_menu == 'default'){
//                             window.addEventListener('load', () => {
//                                 if (designMode || showMenu) {
//                                     loadMenuDefault();
//                                 }
//                                 else {
//                                     document.body.addEventListener('click', () => {
//                                         loadMenuDefault();
//                                     }, false)
//                                 }
//                              }, false)
//                         } else {
//                             window.addEventListener('load', () => {
//                                 if (designMode || showMenu) {
//                                     loadMenuTab();
//                                 }
//                                 else {
//                                     document.body.addEventListener('click', () => {
//                                         loadMenuTab();
//                                     }, false)
//                                 }
//                             }, false)
//                         }
//                     }
//                 }
//             } else {
//                 var url = window.routes.root + '/search?view=ajax_mega_menu';

//                 if ($win.width() < 1025) {
//                     if (window.mobile_menu == "default") {
//                         if (designMode || showMenu) {
//                             loadMenuDefault();
//                         }
//                         else {
//                             document.body.addEventListener("click",() => {
//                                 loadMenuDefault();
//                             }, false)
//                         }
//                     } else {
//                         window.addEventListener("load",() => {
//                             if (designMode || showMenu) {
//                                 loadMenuTab();
//                             }
//                             else {
//                                 document.body.addEventListener("click",() => {
//                                     loadMenuTab();
//                                 }, false)
//                             }
//                         }, false)
//                     }
//                 }
//             }
//         },

//         initMobileMenuDefault: function(url) {
//             const menuMobile = $('[data-navigation-mobile]');
//             const nav = $('#HeaderNavigation [data-navigation]');
//             const style = nav.attr('style') != undefined ? nav.attr('style') : nav.closest('#HeaderNavigation').attr('style');
//             $('.list-menu-loading').remove();
//             menuMobile.append(`<nav class="header__inline-menu" data-navigation role="navigation" style="${style != undefined ? style : ''}">${nav.html() != undefined ? nav.html() : ''}</nav>`);

//             const topLanCur = $('.top-language-currency');
//             const lanCurMobile = $('#navigation-mobile .nav-currency-language');
//             if (lanCurMobile.text().trim() == '' && topLanCur.length > 0) lanCurMobile.append(`<div class="top-language-currency">${topLanCur.html()}</div>`)

//             // Menu Mobile Tab on Header Vertical
//             const menuVertical = document.querySelector('.header-nav-vertical-menu .vertical-menu .header__menu-vertical')
//             if(menuVertical){
//               document.querySelector('.halo-sidebar.halo-sidebar_menu').classList.add('has-menu-vertical')

//               const menuVerticalTitle = document.querySelector('.header-nav-vertical-menu .vertical-menu .categories-title__button .title').innerHTML
//               const navMobile =  document.querySelector('.site-nav-mobile.nav')
//               const navMobileTitle =  navMobile.querySelector('.menu-heading-mobile')
//               const span = document.createElement('span')
//               span.classList.add('title')
//               span.innerHTML = menuVerticalTitle;
//               navMobileTitle.appendChild(span);
//               navMobile.appendChild(menuVertical);
            
//               const menuVerticalNav = document.querySelector('.site-nav-mobile.nav .header__menu-vertical')
//               menuVerticalNav.classList.add('header__inline-menu')
            
//               const tabTitle = document.querySelectorAll('.site-nav-mobile.nav .menu-heading-mobile .title')
//               const mobileMenu = document.querySelectorAll('.site-nav-mobile.nav .header__inline-menu')
//               tabTitle[0].classList.add('is-active')
//               mobileMenu[0].classList.add('is-active')
              
//               tabTitle.forEach((item,index) => {
//                 item.addEventListener('click', ()=> {
//                   tabTitle.forEach(e => e.classList.remove('is-active'))
//                   item.classList.add('is-active')
//                   mobileMenu.forEach(e => e.classList.remove('is-active'))
//                   mobileMenu[index].classList.add('is-active')
//                 })
//               })
//             }

//             if (window.innerWidth < 1025) {
//                 var menuItemMega = $('.menu-lv-item.has-megamenu');

//                 if (menuItemMega.length > 0) {
//                     menuItemMega.on('click', function (e) {
//                         var block = $(this).find('.menu-dropdown__block--content .products-carousel');
//                         var handle = block.data('product');
//                         var url = block.data('collection');
//                         var url_handle;

//                         if (block.hasClass('megamenu_1')) {
//                             if (handle) {
//                                 url_handle = window.routes.root + '/products/' + handle;
//                             }
//                         } else if (block.hasClass('megamenu_5')) {
//                             if (url) {
//                                 url_handle = window.routes.root + '/collections/' + url;
//                             }
//                         }

//                         if (url_handle) {
//                             halo.renderMegaMenuProductBlock(block, url_handle);
//                         }
//                     });
//                 }
//             }
//         },

//         initMultiTabMobile: function() {
//             if ($win.width() < 1025) {
//                 if(window.mobile_menu == 'custom'){
//                     var chk = true,
//                         menuElement = $('[data-section-type="menu"]'),
//                         menuMobile = $('[data-navigation-mobile]'),
//                         menuTabMobile = $('[data-navigation-tab-mobile]');

//                     const loadMenu = () => {
//                         if (chk) {
//                             chk = false;
//                             const content = document.createElement('div');
//                             const tab = document.createElement('ul');
                            
//                             Object.assign(tab, {
//                                 className: 'menu-tab list-unstyled'
//                             });
                            
//                             tab.setAttribute('role', 'menu');
                            
//                             menuElement.each((index, element) => {
//                                 var currentMenu = element.querySelector('template').content.firstElementChild.cloneNode(true);
                                
//                                 if(index == 0){
//                                     currentMenu.classList.add('is-visible'); 
//                                 } else {
//                                     currentMenu.classList.add('is-hidden');
//                                 }
                                
//                                 content.appendChild(currentMenu);
//                             });

//                             content.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((element, index) => {
//                                 var tabTitle = element.dataset.heading,
//                                     tabId = element.getAttribute('id'),
//                                     tabElement = document.createElement('li');

//                                 Object.assign(tabElement, {
//                                     className: 'item'
//                                 });

//                                 tabElement.setAttribute('role', 'menuitem');

//                                 if (index == 0) {
//                                     tabElement.classList.add('is-active');
//                                 }

//                                 tabElement.innerHTML = `<a role="link" aria-disabled="true" class="link" data-mobile-menu-tab data-target="${tabId}">${tabTitle}</a>`;

//                                 tab.appendChild(tabElement);
//                             });

//                             $('.list-menu-loading').remove();
//                             menuTabMobile.html(tab);
//                             menuMobile.html(content.innerHTML);
//                         }

//                     }

//                     if ($('.header-nav-plain .header-language_currency').length > 0){
//                         const topLanCur = $('.top-language-currency');
//                         const lanCurMobile = $('#navigation-mobile .nav-currency-language');
//                         if (lanCurMobile.text().trim() == '' && topLanCur.length > 0) lanCurMobile.append(`<div class="top-language-currency">${topLanCur.html()}</div>`)
//                     }

//                     if (document.body.matches('.menu_open')) {
//                         loadMenu();
//                     }

//                     document.body.addEventListener('click', () => {
//                         loadMenu();
//                     });                    
//                 }
//             }

//             if (window.innerWidth < 1025) {
//                 var menuItemMega = $('.menu-lv-item.has-megamenu');

//                 if (menuItemMega.length > 0) {
//                     menuItemMega.on('click', function (e) {
//                         var block = $(this).find('.menu-dropdown__block--content .products-carousel');
//                         var handle = block.data('product');
//                         var url = block.data('collection');
//                         var url_handle;

//                         if (block.hasClass('megamenu_1')) {
//                             if (handle) {
//                                 url_handle = window.routes.root + '/products/' + handle;
//                             }
//                         } else if (block.hasClass('megamenu_5')) {
//                             if (url) {
//                                 url_handle = window.routes.root + '/collections/' + url;
//                             }
//                         }

//                         if (url_handle) {
//                             halo.renderMegaMenuProductBlock(block, url_handle);
//                         }
//                     });
//                 }
//             }
//         },
        
//         clickedActiveProductTabs: function() {
//             const handler = (entries, observer) => {
//                 entries.forEach(entry => {
//                     if (entry.isIntersecting) {
//                         const $block = $(entry.target);
//                         if ($block.hasClass('ajax-loaded')) return;

//                         var listTabs = $block.find('ul.list-product-tabs'),
//                             tabLink = listTabs.find('[data-product-tabTop]'),
//                             tabContent = $block.find('[data-product-TabContent]'),
//                             limit = $block.data('limit');

//                         var linkActive = listTabs.find('.tab-links.active'),
//                             activeTab = $block.find('.product-tabs-content .tab-content.active');
                            
//                         if (!$block.hasClass('ajax-loaded')) {
//                             halo.doAjaxProductTabs(
//                                 linkActive.data('href'), 
//                                 activeTab.find('.loading'), 
//                                 activeTab.find('.products-load'), 
//                                 $block.find("button.tab-links.active").attr('data-section-index'), 
//                                 limit,
//                                 $block
//                             );
//                         }
                        
//                         tabLink.off('click').on('click', function (e) {
//                             e.preventDefault();
//                             e.stopPropagation();

//                             if (!$(this).hasClass('active')) {

//                                 $('.list-tabs-popup.show-dropdown')?.removeClass('show-dropdown');
//                                 $(this).closest('.dropdown').find('.label-active .tab-links').text($(this).text());

//                                 const curTab = $(this),
//                                     curTabContent = $(curTab.data('target'));

//                                 tabLink.removeClass('active');
//                                 tabContent.removeClass('active');

//                                 if (!curTabContent.hasClass('loaded')) halo.doAjaxProductTabs(curTab.data('href'), curTabContent.find('.loading'), curTabContent.find('.products-load'), $block.find("button.tab-links.active").attr('data-section-index'), limit);
                                
//                                 curTab.addClass('active');
//                                 curTabContent.addClass('active');
//                                 curTabContent.find('.slick-slider').slick('refresh');
//                             };
//                         });
                        
//                         $('.product-tab-block .dropdown .label-active .list-product-tabs').off('click').on('click', function (e) {
//                             document.querySelector(".list-tabs-popup").classList.toggle("show-dropdown");
//                         });
//                     }
//                 })
//             }

//             this.productBlock = document.querySelectorAll('[data-product-tab-block]');

//             const config = {
//                 threshold: 0.1,
//             }

//             this.observer = new IntersectionObserver(handler, config);
//             this.productBlock.forEach(block => {
//                 this.observer.observe(block);
//             });
//         },

//         doAjaxProductTabs: function (handle, loadingElm, curTabContent, sectionId, limit, self) {
//             $.ajax({
//                 type: "get",
//                 url: handle,
//                 data: {
//                     constraint: `sectionId=${handle}+limit=${limit}`
//                 },

//                 beforeSend: function () {
//                     if (self != undefined) self.addClass('ajax-loaded');
//                 },

//                 success: function (data) {
//                     curTabContent.parent().addClass('loaded');
//                     if (handle == '?view=ajax_product_block') return;
                    
//                     if ($(data).text().trim() === '') {
//                         noProduct(curTabContent);
//                     }
//                     else {
//                         const res = halo.handleResponse($(data), 0, limit);
//                         curTabContent.html(res);

//                         if(window.wishlist.show){
//                             halo.setLocalStorageProductForWishlist();
//                         }

//                         if (halo.checkNeedToConvertCurrency()) {
//                             Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                         };
                                       
//                         curTabContent.parent().find('.card .variants-popup-content .selector-wrapper .swatch-element').each(function() {
//                             const $input = $(this).find('input');
//                             const $label = $(this).find('label');

//                             $input.attr({
//                                 id: ($input.attr('id') || '') + sectionId,
//                                 name: ($input.attr('name') || '') + sectionId
//                             });
//                             $label.attr('for', ($label.attr('for') || '') + sectionId);
//                         });
//                     }

//                     halo.swapHoverVideoProductCard();
//                 },
//                 complete: function () {
//                     if (curTabContent.hasClass('products-carousel')) {
//                         halo.productBlockSilder(curTabContent.parent());
//                     }

//                     if ($('body').hasClass('cursor-fixed__show')){
//                         window.sharedFunctionsAnimation.onEnterButton();
//                         window.sharedFunctionsAnimation.onLeaveButton();
//                     }

//                     if ($body.hasClass('product-card-layout-07') || $body.hasClass('product-card-layout-08')) {
//                         halo.calculateTranslateYHeight()
//                     }

//                     if($body.hasClass('product-card-layout-08')) {
//                         halo.productCountdownCard();
//                     }
//                 },
//                 error: function (xhr, text) {
//                     noProduct(curTabContent);
//                 }
//             });
            
//             const noProduct = (curTabContent) => {
//                 curTabContent.html(`<p class="loading center">Sorry, there are no products in this collection</p>`);
//             }
//         },
//         lookbookCarousel: function() {
//             var lookbookCarousel = $('.lookbook-carousel'),
//                 itemToShow = lookbookCarousel.data('item-to-show'),
//                 itemDots = lookbookCarousel.data('item-dots'),
//                 itemDotsMb = lookbookCarousel.data('item-dots-mb'),
//                 itemArrows = lookbookCarousel.data('item-arrows'),
//                 itemArrowsMb = lookbookCarousel.data('item-arrows-mb');

//             if(lookbookCarousel.length > 0) {
//                 if(lookbookCarousel.not('.slick-initialized')) {
//                     lookbookCarousel.slick({
//                         mobileFirst: true,
//                         adaptiveHeight: true,
//                         vertical: false,
//                         infinite: true,
//                         slidesToShow: itemToShow,
//                         slidesToScroll: itemToShow,
//                         arrows: itemArrowsMb,
//                         dots: itemDotsMb,
//                         autoplay: false,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: 
//                         [
//                             {
//                                 breakpoint: 1024,
//                                 settings: {
//                                     arrows: itemArrows,
//                                     dots: itemDots
//                                 }
//                             }
//                         ]
//                     });
//                 }
//             }

//             if (lookbookCarousel.hasClass('enable_counter_number')) {
//                 var slickNext = lookbookCarousel.find('.slick-next');
//                 lookbookCarousel.closest('.special-banner__item--lookbook_banner').find('.products-counter-number').appendTo(slickNext);
//                 lookbookCarousel.on('afterChange', (event) => {
//                     var slickIndex = lookbookCarousel.find('.slick-current').data('slick-index');
//                     lookbookCarousel.find("#count-image").text(slickIndex + 1);
//                 });
//             }

//             if ($('body').hasClass('cursor-fixed__show')){
//                 window.sharedFunctionsAnimation.onEnterButton();
//                 window.sharedFunctionsAnimation.onLeaveButton();
//             }
//         },
//         productBlockSilder: function(wrapper) {
//             var productGrid = wrapper.find('.products-carousel'),
//                 itemToShow = productGrid.data('item-to-show'),
//                 itemDots = productGrid.data('item-dots'),
//                 itemDotsMb = productGrid.data('item-dots-mb'),
//                 itemArrows = productGrid.data('item-arrows'),
//                 itemArrowsMb = productGrid.data('item-arrows-mb'),
//                 itemInfinite = productGrid.data('infinite'),
//                 itemAutoplay = productGrid.data('autoplay'),
//                 swatchLabel = productGrid.find('.swatch .swatch-label'),
//                 isProductCard06 = document.body.classList.contains('product-card-layout-06');

//             if(productGrid.length > 0) {
//                 if(productGrid.hasClass('slick-initialized')) return;
//                 if(productGrid.not('.slick-initialized')) {
//                     if (isProductCard06) {
//                         productGrid.on('init', () => {
//                             const selectOptionsHeight = productGrid.find('.product .card-action').eq(0).height();
//                             productGrid.find('.slick-list').css('padding-bottom', selectOptionsHeight + 'px');
//                             productGrid.attr('data-slider-padding-bottom', selectOptionsHeight)
//                         })
//                     }

//                     if (productGrid.hasClass('enable_progress_bar')) {
//                         var progressBar = wrapper.find('.scrollbar-thumb');
//                         productGrid.on('init', (event, slick) => {
//                             var percent = ((slick.currentSlide / (slick.slideCount - itemToShow)) * 100) + '%';
//                             progressBar.css('--percent', percent);
//                         });
//                     }
                  
//                     productGrid.slick({
//                         mobileFirst: true,
//                         adaptiveHeight: true,
//                         vertical: false,
//                         infinite: itemInfinite,
//                         autoplay: itemAutoplay,
//                         speed: 1000,
//                         slidesToShow: 1,
//                         slidesToScroll: 1,
//                         arrows: itemArrowsMb,
//                         dots: itemDotsMb,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: 
//                         [
//                             {
//                                 breakpoint: 1599,
//                                 settings: {
//                                     arrows: itemArrows,
//                                     dots: itemDots,
//                                     autoplay: false,
//                                     get slidesToShow() {
//                                         if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
//                                             return this.slidesToShow = itemToShow;
//                                         } else {
//                                             return this.slidesToShow = 1;
//                                         }
//                                     },
//                                     get slidesToScroll() {
//                                         if(itemToShow !== undefined && itemToShow !== null && itemToShow !== '' && itemToShow !== 2.5 && itemToShow !== 3.5 && itemToShow !== 4.5 && itemToShow !== 5.5){
//                                             return this.slidesToScroll = itemToShow;
//                                         } else {
//                                             return this.slidesToScroll = 1;
//                                         }
//                                     },
//                                     get initialSlide() {
//                                         if(itemToShow == 5.5) {
//                                             return this.initialSlide = 0.5;
//                                         } else {
//                                             return this.initialSlide = 0;
//                                         }
//                                     }
//                                 }
//                             },
//                             {
//                                 breakpoint: 1024,
//                                 settings: {
//                                     arrows: itemArrows,
//                                     dots: itemDots,
//                                     autoplay: false,
//                                     get slidesToShow() {
//                                         if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
//                                             if(itemToShow == 5 || itemToShow == 6){
//                                                 return this.slidesToShow = itemToShow - 1;
//                                             } else {
//                                                 if (productGrid.parents('.collection-column-2').length){
//                                                     return this.slidesToShow = 2;
//                                                 } else{
//                                                     return this.slidesToShow = itemToShow;
//                                                 }
                                               
//                                             }
//                                         } else {
//                                             return this.slidesToShow = 1;
//                                         }
//                                     },
//                                     get slidesToScroll() {
//                                         if(itemToShow !== undefined && itemToShow !== null && itemToShow !== '' && itemToShow !== 2.5 && itemToShow !== 3.5 && itemToShow !== 4.5 && itemToShow !== 5.5){
//                                             if(itemToShow == 5 || itemToShow == 6){
//                                                 return this.slidesToScroll = itemToShow - 1;
//                                             } else {
//                                                 if (productGrid.parents('.collection-column-2').length){
//                                                     return this.slidesToScroll = 2;
//                                                 } else{
//                                                     return this.slidesToScroll = itemToShow;
//                                                 }
                                               
//                                             }
//                                         } else {
//                                             return this.slidesToScroll = 1;
//                                         }
//                                     },
//                                     get initialSlide() {
//                                         if(itemToShow == 5.5) {
//                                             return this.initialSlide = 0.5;
//                                         } else {
//                                             return this.initialSlide = 0;
//                                         }
//                                     }
//                                 }
//                             },
//                             {
//                                 breakpoint: 991,
//                                 settings: {
//                                     arrows: itemArrowsMb,
//                                     dots: itemDotsMb,
//                                     autoplay: false,
//                                     get slidesToShow(){
//                                         if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
//                                             if (productGrid.parents('.product-block-has__banner').length && productGrid.parents('.product-block-has__banner').data('width-banner') > 40) {
//                                                 return this.slidesToShow = 2;
//                                             }
//                                             else {
//                                                 if(itemToShow == 2.5) {
//                                                     return this.slidesToShow = 2;
//                                                 } else {
//                                                     return this.slidesToShow = 3;
//                                                 }
//                                             }
//                                         }
//                                         else{
//                                             if (productGrid.parents('.collection-column-2').length){
//                                                 return this.slidesToShow = 2;
//                                             }
//                                             else if (itemToShow == 1) {
//                                                 return this.slidesToShow = itemToShow;
//                                             }
//                                             else{
//                                                 if(itemToShow == 3.5 || itemToShow == 4.5) {
//                                                     return this.slidesToShow = 3;
//                                                 } else {
//                                                     return this.slidesToShow = 4;
//                                                 }
//                                             }
//                                         }
//                                     },
//                                     get slidesToScroll(){
//                                         if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
//                                             if (productGrid.parents('.product-block-has__banner').length && productGrid.parents('.product-block-has__banner').data('width-banner') > 40) {
//                                                 return this.slidesToScroll = 2;
//                                             }
//                                             else {
//                                                 if(itemToShow == 2.5) {
//                                                     return this.slidesToScroll = 2;
//                                                 } else {
//                                                     return this.slidesToScroll = 3;
//                                                 }
//                                             }
//                                         }
//                                         else{
//                                             if (productGrid.parents('.collection-column-2').length){
//                                                 return this.slidesToScroll = 2;
//                                             }
//                                             else if (itemToShow == 1) {
//                                                 return this.slidesToScroll = itemToShow;
//                                             }
//                                             else{
//                                                 if(itemToShow == 3.5 || itemToShow == 4.5) {
//                                                     return this.slidesToScroll = 3;
//                                                 } else {
//                                                     return this.slidesToScroll = 4;
//                                                 }
//                                             }
//                                         }
//                                     },
//                                     get initialSlide() {
//                                         if(itemToShow == 5.5) {
//                                             return this.initialSlide = 0.5;
//                                         } else {
//                                             return this.initialSlide = 0;
//                                         }
//                                     }
//                                 }
//                             },
//                             {
//                                 breakpoint: 767,
//                                 arrows: itemArrowsMb,
//                                 dots: itemDotsMb,
//                                 autoplay: false,
//                                 settings: {
//                                     get slidesToShow(){
//                                         if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
//                                             return this.slidesToShow = 2;
//                                         }
//                                         else if (itemToShow == 1) {
//                                             return this.slidesToShow = itemToShow;
//                                         }
//                                         else{
//                                             if(itemToShow == 3.5 || itemToShow == 4.5) {
//                                                 return this.slidesToShow = 2;
//                                             } else {
//                                                 return this.slidesToShow = 3;
//                                             }
//                                         }
//                                     },
//                                     get slidesToScroll(){
//                                         if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
//                                             return this.slidesToScroll = 2;
//                                         }
//                                         else if (itemToShow == 1) {
//                                             return this.slidesToScroll = itemToShow;
//                                         }
//                                         else{
//                                             if(itemToShow == 3.5 || itemToShow == 4.5) {
//                                                 return this.slidesToScroll = 2;
//                                             } else {
//                                                 return this.slidesToScroll = 3;
//                                             }
//                                         }
//                                     },
//                                     get initialSlide() {
//                                         if(itemToShow == 5.5) {
//                                             return this.initialSlide = 0.5;
//                                         } else {
//                                             return this.initialSlide = 0;
//                                         }
//                                     }
//                                 }
//                             },
//                             {
//                                 breakpoint: 320,
//                                 arrows: itemArrowsMb,
//                                 dots: itemDotsMb,
//                                 autoplay: itemAutoplay,
//                                 settings: {
//                                     get slidesToShow(){
//                                         if (itemToShow == 1) {
//                                             if (productGrid.hasClass('special-banner__products--slider') || productGrid.hasClass('special-banner__products--grid')) {
//                                                 return this.slidesToShow = 2;
//                                             } else {
//                                                 return this.slidesToShow = itemToShow;
//                                             }
//                                         }
//                                         else {
//                                             if(itemToShow == 2.5 || itemToShow == 3.5 || itemToShow == 4.5) {
//                                                 return this.slidesToShow = 1;
//                                             } else {
//                                                 return this.slidesToShow = 2;
//                                             }
//                                         }

//                                     },
//                                     get slidesToScroll(){
//                                         if (itemToShow == 1) {
//                                             return this.slidesToScroll = itemToShow;
//                                         }
//                                         else {
//                                             if(itemToShow == 2.5 || itemToShow == 3.5 || itemToShow == 4.5) {
//                                                 return this.slidesToScroll = 1;
//                                             } else {
//                                                 return this.slidesToScroll = 2;
//                                             }
//                                         }
//                                     }
//                                 }
//                             }
//                         ]
//                     });

//                     if (productGrid.hasClass('enable_progress_bar')) {
//                         productGrid.on('afterChange', (event, slick, nextSlide) => {
//                             var percent = ((nextSlide / (slick.slideCount - itemToShow)) * 100) + '%';
//                             progressBar.css('--percent', percent);
//                         });
//                     }
//                     if (productGrid.hasClass('enable_counter_number')) {
//                         var slickNext = productGrid.find('.slick-next');
//                         productGrid.closest('.halo-block, .special-banner__product, .cust-prod-widget__product').find('.products-counter-number').appendTo(slickNext);
//                         productGrid.on('afterChange', (event) => {
//                             var slickIndex = productGrid.find('.slick-current').data('slick-index');
//                             var displayCount = slickIndex + itemToShow;
//                             var totalItems = wrapper.data('limit');

//                             if (displayCount > totalItems) {
//                                 displayCount = totalItems;
//                             }
//                             productGrid.find("#count-image").text(displayCount);
//                         });
//                     }

//                     if ($('body').hasClass('cursor-fixed__show')){
//                         window.sharedFunctionsAnimation.onEnterButton();
//                         window.sharedFunctionsAnimation.onLeaveButton();
//                     }
//                 }
//             }

//             if (swatchLabel.length) {
//                 function getMaxHeight() {
//                     var maxHeight = 0;

//                     productGrid.find('.slick-slide').each(function () {
//                         var slideHeight = $(this).outerHeight();
//                         if (slideHeight > maxHeight) {
//                             maxHeight = slideHeight;
//                         }
//                     });
//                     return maxHeight;
//                 }

//                 productGrid.on('click', '.swatch .swatch-label', function () {
//                     setTimeout(() => {
//                         var maxHeight = getMaxHeight();
//                         productGrid.find(".slick-list").css({ height: maxHeight + 'px', transition: "500ms ease", })
//                     }, 50);
//                 });
//             }
//         },

//         productBlockInfiniteScroll: function() {
//             var productBlock = $('[data-product-block], [data-product-tab-block]');

//             productBlock.each((index, element) => {
//                 var $block = $(element),
//                     showMore = $block.find('[data-product-infinite]');
            
//                 if (showMore.length > 0) {
//                     showMore.find('.button').on('click', (event) => {
//                         var showMoreButton = $(event.target);

//                         if (!showMoreButton.hasClass('view-all')) {
//                             event.preventDefault();
//                             event.stopPropagation();

//                             // var text = window.button_load_more.loading;

//                             showMoreButton.addClass('is-loading');
//                             // showMoreButton.text(text);

//                             var url = showMoreButton.attr('data-collection'),
//                                 limit = showMoreButton.attr('data-limit'),
//                                 swipe = showMoreButton.attr('data-swipe'),
//                                 total = showMoreButton.attr('data-total'),
//                                 image_ratio = showMoreButton.attr('data-image-ratio'),
//                                 sectionId = showMoreButton.attr('sectionId'),
//                                 page = parseInt(showMoreButton.attr('data-page'));

//                             halo.doProductBlockInfiniteScroll(url, total, limit, swipe, image_ratio, sectionId, page, showMoreButton, $block);
//                         } else {
//                             window.location = showMoreButton.data('href');
//                         }
//                     });
//                 }
//             });
//         },

//         doProductBlockInfiniteScroll: function(url, total, limit, swipe, image_ratio, sectionId, page, showMoreButton, $block){
//             $.ajax({
//                 type: 'get',
//                 url: window.routes.root + '/collections/' + url,
//                 cache: false,
//                 data: {
//                     view: 'ajax_product_block',
//                     constraint: 'limit=' + limit + '+page=' + page + '+sectionId=' + sectionId + '+imageRatio=' + image_ratio + '+swipe=' + swipe
//                 },
//                 beforeSend: function () {
//                     // halo.showLoading();
//                 },
//                 success: function (data) {
//                     const $productGrid = showMoreButton.closest('.tab-content').length ? showMoreButton.closest('.tab-content').find('.products-grid') : showMoreButton.closest('.halo-block-content').find('.products-grid');
//                     let length = $productGrid.find('.product').length;
//                     const res = halo.handleResponse($(data), length, $productGrid.data('products-to-show'));
//                     $productGrid.append(res);

//                     if(length + res.length < $(data).length) {
//                         var text = window.button_load_more.default;

//                         showMoreButton.removeClass('is-loading');
//                         showMoreButton.attr('data-page', page + 1);
//                         showMoreButton.find('span').text(text);
//                     } else {
//                         if (Number(total) > $(data).length && $(data).length <= length + res.length) {
//                             var text = window.button_load_more.view_all;

//                             showMoreButton.find('span').text(text);
//                             showMoreButton.removeClass('is-loading');
//                             showMoreButton.attr('data-href', window.routes.root + '/collections/' + url).addClass('view-all');
//                         } else {
//                             var text = window.button_load_more.no_more;

//                             showMoreButton.find('span').text(text);
//                             showMoreButton.removeClass('is-loading');
//                             showMoreButton.attr('disabled', 'disabled');
//                         }
//                     }
//                 },
//                 complete: function () {
//                     // halo.hideLoading();
//                     if (halo.checkNeedToConvertCurrency()) {
//                         Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                     };
//                 }
//             });
//         },

//         doBeforeMegaMenuProductBlock: function () {
//             var menuItemMega = $('.menu-lv-item.has-megamenu');

//             if (menuItemMega.length > 0 && window.innerWidth > 1025) {
//                 menuItemMega.mouseenter(function () {
//                     var block = $(this).find('.menu-dropdown__block--content .products-carousel');
//                     var handle = block.data('product');
//                     var url = block.data('collection');
//                     var url_handle;

//                     if (block.hasClass('megamenu_1')) {
//                         if (handle) {
//                             url_handle = window.routes.root + '/products/' + handle;
//                         }
//                     } else if (block.hasClass('megamenu_5')) {
//                         if (url) {
//                             url_handle = window.routes.root + '/collections/' + url;
//                         }
//                     }

//                     if (url_handle) {
//                         halo.renderMegaMenuProductBlock(block, url_handle);
//                     }
//                 });
//             }
//         },


//         renderMegaMenuProductBlock: function(wrapper, url_handle) {
//             var block = wrapper;

//             if (block.hasClass('ajax-loaded')) return;

//             var limit = block.data('row'),
//                 sectionId = 'list-result-block';

//             $.ajax({
//                 type: 'GET',
//                 url: url_handle,
//                 cache: false,
//                 data: {
//                     view: 'ajax_product_card_mega_menu',
//                     constraint: `limit=${limit}+sectionId=${sectionId}`
//                 },
//                 beforeSend: () => {
//                     block.addClass('ajax-loaded');
//                 },
//                 success: (data) => {
//                     if (block.hasClass('megamenu_1')) {
//                         block.html(data);
//                     } else if (block.hasClass('megamenu_5')) {
//                         const dataRes = halo.handleResponse($(data), 0, limit);
//                         block.html(dataRes);
//                         halo.productMenuSlider(block);
//                     }

//                     if (halo.checkNeedToConvertCurrency()) {
//                         Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                     }
//                 },
//                 complete: () => {
//                     if (halo.checkNeedToConvertCurrency()) {
//                         Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                     }
//                 }
//             });
//         },

//         productMenuSlider: function(wrapper){
//             var productGrid = wrapper,
//                 _dataRows = productGrid.data('row');
//             if(productGrid.length > 0) {
//                 if(productGrid.not('.slick-initialized')) {
//                     productGrid.slick({
//                         mobileFirst: true,
//                         adaptiveHeight: true,
//                         vertical: false,
//                         infinite: false,
//                         slidesToShow: 2,
//                         slidesToScroll: 1,
//                         arrows: false,
//                         dots: true,
//                         rtl: window.rtl_slick,
//                         responsive: 
//                         [
//                             {
//                                 breakpoint: 1024,
//                                 settings: {
//                                     slidesToShow: 3,
//                                     slidesToScroll: 1,
//                                 }
//                             },
//                             {
//                                 breakpoint: 1500,
//                                 settings: {
//                                     slidesToShow: _dataRows,
//                                     slidesToScroll: 1,
//                                     dots: false
//                                 }
//                             }
//                         ]
//                     });
//                 }
//             }
//         },

//         buildRecommendationBlock: function(){
//             if (document.querySelector('[data-recommendations-block]') == null) return;

//             var $this = document.querySelector('[data-recommendations-block]'),
//                 layout = $this.dataset.layout;
//                 swipe = $this.dataset.swipe;

//             const config = {
//                 threshold: 0,
//             }

//             const handleIntersection = (entries, observer) => {
//                 const recommendationsContainer = $this.querySelector('.wrapper-container');
//                 if (!entries[0].isIntersecting) return;
//                 if ($this.innerHTML.trim() != '' && !recommendationsContainer.classList.contains('product-recommendations-loading') && !recommendationsContainer.classList.contains('has-product')) return;
//                 recommendationsContainer.classList.add('has-product');

//                 fetch($this.dataset.url)
//                 .then(response => response.text())
//                 .then(text => {
//                     const html = document.createElement('div');
//                     html.innerHTML = text;
//                     const recommendations = html.querySelector('[data-recommendations-block]');
//                     if (recommendations && recommendations.innerHTML.trim().length) {
//                         $this.innerHTML = recommendations.innerHTML;

//                         var productItems = $($this).find('.product-item')
//                         var firstProductData = productItems.eq(0).data('json-product')
//                         if (!firstProductData) return $($this).remove();

//                         if (layout == 'slider') {
//                             halo.productBlockSilder($($this));
//                         }

//                         var productItems = $($this).find('.product-item')
//                         productItems.each(async (index, rawProduct) => {
//                             var product = $(rawProduct);
//                             var productId = product.data('product-id');
//                             var productJson = product.data('json-product');
//                             var handle = productJson.handle
                            
//                             await  $.ajax({
//                                 type: 'get',
//                                 url: window.routes.root + '/products/' + handle + '?view=ajax_variant_quantity',
//                                 beforeSend: function () {},
//                                 success: function (data) {
//                                     const element = new DOMParser().parseFromString(data, 'text/html')
//                                     if (element.querySelector(`[data-quantity-product-id="${productId}"]`)) {
//                                         const quantityInfo = JSON.parse(element.querySelector(`[data-quantity-product-id="${productId}"]`).innerHTML)
//                                         window[`quick_view_inven_array_${productId}`] = quantityInfo
//                                     }
//                                 },      
//                                 error: function (xhr, text) {
//                                     halo.showWarning($.parseJSON(xhr.responseText).description);
//                                 },
//                                 complete: function () {}
//                             });
//                         }) 

//                         const loadingImages = $this.querySelectorAll('.media--loading-effect img');
//                         this.observeImageLazyloaded(loadingImages);

//                         if(window.compare.show){
//                             var $compareLink = $('[data-compare-link]');

//                             halo.setLocalStorageProductForCompare($compareLink);
//                         }

//                         if(window.wishlist.show){
//                             halo.setLocalStorageProductForWishlist();
//                         }

//                         if ($('body').hasClass('cursor-fixed__show')){
//                             window.sharedFunctionsAnimation.onEnterButton();
//                             window.sharedFunctionsAnimation.onLeaveButton();
//                         }

//                         if($body.hasClass('product-card-layout-08')) {
//                             halo.productCountdownCard();
//                         }

//                         this.calculateTranslateYHeight()
//                     }
//                 })
//                 .catch(e => {
//                     console.error(e);
//                 });
//             }

//             new IntersectionObserver(handleIntersection.bind($this), ({}, config)).observe($this);
//         },

//         initVideoPopup: function (){
//             if (!$(".video-open-popup").length) return;
//             $('.video-open-popup .video-button').off('click').on('click',function(){
//                 let video_type = $(this).attr('data-type'),
//                     video_src = $(this).attr('data-src'),
//                     aspect_ratio = $(this).attr('aspect_ratio'),
//                     modal = $('[data-popup-video]');

//                 const $content = `<div class="fluid-width-video-wrapper" style="padding-top: ${aspect_ratio}">
//                                     ${video_type == 'youtube' ? 
//                                         `<iframe
//                                             id="player"
//                                             type="text/html"
//                                             width="100%"
//                                             frameborder="0"
//                                             webkitAllowFullScreen
//                                             mozallowfullscreen
//                                             allowFullScreen
//                                             src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
//                                         </iframe>`
//                                         :
//                                         `<iframe 
//                                             src="https://player.vimeo.com/video/${video_src}?autoplay=1&mute=1" 
//                                             class="js-vimeo" 
//                                             allow="autoplay; 
//                                             encrypted-media" 
//                                             webkitallowfullscreen 
//                                             mozallowfullscreen 
//                                             allowfullscreen">
//                                         </iframe>`
//                                     }
//                                 </div>`;
//                 modal.find('.halo-popup-content').html($content);
//                 $body.addClass('video-show');
//             });

//             $('[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay').on('click', function (e) {
//                 // e.preventDefault();
//                 // e.stopPropagation();
//                 let modalContent = $('[data-popup-video] .halo-popup-content');
//                 if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
//                     $body.removeClass('video-show');
//                     $('[data-popup-video] iframe').remove();
//                 };
//             });
//         },

//         swapHoverVideoProductCard: function () {
//             if (window.innerWidth > 1200) {
//                 $('.product-item .card:not(.has-first-video)').mouseenter(function () {
//                     var chil = $(this).find('video');
//                     var _chil = $(this).find('video').get(0);
//                     if (chil.length > 0) {
//                         _chil.play();
//                     }
//                 });
//                 $('.product-item .card:not(.has-first-video)').mouseleave(function () {
//                     var chil = $(this).find('video');
//                     var _chil = $(this).find('video').get(0);
//                     if (chil.length > 0) {
//                         _chil.pause();
//                     }
//                 })
//             }

//             $.fn.isInViewport = function () {
//                 let elementTop = $(this).offset().top,
//                     elementBottom = elementTop + $(this).outerHeight(),

//                     viewportTop = $(window).scrollTop(),
//                     viewportBottom = viewportTop + $(window).height();

//                 return elementBottom > viewportTop && elementTop < viewportBottom;
//             };

//             $(".product-item .card.has-first-video").each(function () {
//                 let chil = $(this).find('video');
//                 let firstImg = $(this).find("img:first-child");
//                 let _chil = $(this).find('video').get(0);

//                 const playVideoCard = () => {
//                     if (firstImg.length > 0) firstImg.css("opacity", "0");

//                     if (chil.length > 0) {
//                         chil.css("opacity", "1")
//                         _chil.play()
//                     };
//                 }

//                 const pauseVideoCard = () => {
//                     if (chil.length > 0) _chil.pause();
//                 }

//                 if ($(this).isInViewport()) {
//                     playVideoCard()
//                 } else {
//                     pauseVideoCard()
//                 }

//                 window.addEventListener('scroll', () => {
//                     if ($(this).isInViewport()) {
//                         playVideoCard()
//                     } else {
//                         pauseVideoCard()
//                     }
//                 });
//             });
//         },

//         initGlobalCheckbox: function() {
//             $doc.on('change', '.global-checkbox--input', (event) => {
//                 var targetId = event.target.getAttribute('data-target');

//                 if(event.target.checked){
//                     $(targetId).attr('disabled', false);
//                 } else{
//                     $(targetId).attr('disabled', true);
//                 }
//             });

//             $doc.on('click', '[data-term-condition]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();
//                 $body.addClass('term-condition-show');
//             });

//             $doc.on('click', '[data-close-term-condition-popup]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();
//                 $body.removeClass('term-condition-show');
//             });

//             $doc.on('click', (event) => {
//                 setTimeout(() => {
//                     if ($body.hasClass('cart-sidebar-show')) {
//                         if (($(event.target).closest('[data-term-condition-popup]').length === 0)){
//                             $body.removeClass('term-condition-show');
//                         }
//                     }
//                     if ($body.hasClass('term-condition-show')) {
//                         if ($(event.target).closest('[data-term-condition-popup]').length === 0){
//                             $body.removeClass('term-condition-show');
//                         }
//                     }
//                 }, 10);
//             });
//         },
        
//         initColorSwatch: function() {
//             $doc.ready(function() {
//                 $('.card .swatch-label.is-active').trigger('click');
//             });
            
//             $doc.on('click', '.card .swatch-label', (event) => {
//                 var $target = $(event.currentTarget),
//                     title = $target.attr('title').replace(/^\s+|\s+$/g, ''),
//                     product = $target.closest('.product-item'),
//                     productJson = product.data('json-product'),
//                     productTitle = product.find('.card-title'),
//                     productAction = product.find('[data-btn-addtocart]'),
//                     productAction2 = product.find('.card-product [data-btn-addtocart]'),
//                     variantId = $target.data('variant-id'),
//                     productHref = product.find('a').attr('href'),
//                     oneOption = $target.data('with-one-option'),
//                     newImage = $target.data('variant-img'),
//                     mediaList = [];



//                 const $iconAddtocart = '<svg class="icon icon-cart" viewBox="0 0 286.74 356.73">\
//                   <g data-name="Layer 1">\
//                     <path d="m286.33,277.03l-.17-3.91c-.81-18.73-1.83-37.7-2.83-56.05l-.79-14.51c-.43-8.13-.9-16.26-1.37-24.4l-.24-4.18c-.84-14.79-1.71-30.08-2.35-45.1-.93-21.43-14.62-35.84-34.07-35.86h-20.65c-.42-20.33-5.78-38.81-15.94-54.94C189.14,8.27,157.22-5.8,126.6,2.23c-27.48,7.21-46.98,26.7-57.96,57.94-3.5,9.98-5.33,20.76-5.56,32.86h-9.52c-4.59,0-9.05-.01-12.39,0-16.64.12-30.01,12.35-31.79,29.06-1.42,13.39-2.1,27.29-2.7,39.55-.24,4.97-.5,9.95-.77,14.91-1.22,21.28-2.24,39.94-3.13,57.07-.29,5.45-.6,10.9-.92,16.36l-.02.3c-.82,13.9-1.67,28.28-1.82,42.5-.18,16.51,5.81,32.31,16.86,44.5,11.15,12.29,26.39,19.35,41.81,19.37,22.45.05,49.37.08,82.32.08s60.43-.02,87.24-.08c28.28-.04,53.63-23.49,57.72-53.39,1.19-8.74.78-17.61.37-26.23ZM63.13,130.98c.09,7.97,4.99,13.59,11.92,13.67h.12c6.97,0,11.9-5.57,11.99-13.53.04-3.2.04-6.33.04-9.63v-2.53s112.59,0,112.59,0v10.76c0,4.95,1.26,8.81,3.76,11.51,2.07,2.2,4.95,3.4,8.33,3.45h.11c5.72-.08,11.83-4.11,11.85-15.16v-10.77c.83-.01,1.68-.03,2.55-.04h.62c7.1-.1,15.15-.2,20.48.19,3.7.28,6.59,4.2,6.87,9.32.68,12.51,1.41,26.28,2.28,43.33l.1,2.01c.67,12.86,1.34,25.72,2.04,38.59.31,5.58.6,11.17.87,16.76.91,17.56,1.84,35.72,3.19,53.79,1.49,20.32-4.18,34.05-17.84,43.2-5.16,3.45-10.88,5.2-17.01,5.2h-15.06c-45.58.05-104.28.1-154.01-.02-9.16-.02-18.22-4.27-24.85-11.68-6.63-7.39-10.18-16.92-10-26.83.28-14.29,1.14-29.09,1.9-42.15.31-5.37.62-10.74.91-16.1.54-10.41,1.12-20.81,1.69-31.22l.07-1.28c.21-3.92.43-7.85.65-11.77.22-3.94.44-7.88.65-11.82.15-2.9.3-5.8.45-8.7.15-2.9.3-5.79.45-8.7.51-10.04,1.11-21.71,1.81-33.09.33-5.43,3.75-8.98,8.7-9.05,2.69-.04,6.15-.06,10-.06h11.79v3.83c0,1.68-.01,3.34,0,5h-.06l.04,3.54Zm24.05-38.1c.01-6.61,1.06-13.49,3.19-20.92,4.62-16.13,13.13-28.65,25.29-37.21,18.23-12.86,40.54-12.15,58.21,1.84,15.57,12.32,25.91,35.07,25.84,56.29h-112.53Z"></path>\
//                   </g>\
//                 </svg>';

//                 $target.parents('.swatch').find('.swatch-label').removeClass('is-active');
//                 $target.addClass('is-active');
                
//                 if(productTitle.hasClass('card-title-change')){
//                     if($body.hasClass('style_2_text_color_varriant')){
//                         productTitle.find('[data-change-title]').text(title);
//                     }else{
//                         productTitle.find('[data-change-title]').text(' - ' + title);
//                     }
//                 } else {
//                     if($body.hasClass('style_2_text_color_varriant')){
//                         productTitle.addClass('card-title-change').append('<span data-change-title>' + title + '</span>');
//                     }else{
//                         productTitle.addClass('card-title-change').append('<span data-change-title> - ' + title + '</span>');
//                     }
//                 }

//                 const selectedVariant = productJson.variants.find(variant => variant.id === variantId)

//                 if (selectedVariant.compare_at_price > selectedVariant.price) {
//                     product.find('.price').addClass('price--on-sale');
//                     product.find('.price__sale .price-item--regular').html(Shopify.formatMoney(selectedVariant.compare_at_price, window.money_format));
//                     product.find('.price__sale .price-item--sale').html(Shopify.formatMoney(selectedVariant.price, window.money_format));
//                     const labelSale = `(-${Math.round((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price)}%)`;
//                     product.find('.price__label_sale .label_sale').html(labelSale);
//                 } else {
//                     product.find('.price__regular .price-item').html(Shopify.formatMoney(selectedVariant.price, window.money_format));

//                     if (selectedVariant.compare_at_price == null) {
//                         product.find('.price').removeClass('price--on-sale');
//                         product.find('.price__sale .price-item--regular').html('');
//                     }
//                 }
  
//                 product.find('a:not(.single-action):not(.number-showmore):not(.vendor-text)').attr('href', productHref.split('?variant=')[0]+'?variant='+ variantId);

//                 if (oneOption != undefined) {
//                     var quantity = $target.data('quantity');

//                     product.find('[name="id"]').val(oneOption);
  
//                     if (quantity > 0) {
//                         if(window.notify_me.show){
//                             productAction
//                                 .removeClass('is-notify-me')
//                                 .addClass('is-visible');
//                         } else {
//                             productAction
//                                 .removeClass('is-soldout')
//                                 .addClass('is-visible');
//                         }
//                     } else {
//                        if(window.notify_me.show){
//                             productAction
//                                 .removeClass('is-visible')
//                                 .addClass('is-notify-me');
//                         } else {
//                             productAction
//                                 .removeClass('is-visible')
//                                 .addClass('is-soldout');
//                         }
//                     }

//                     if(productAction.hasClass('is-soldout') || productAction.hasClass('is-notify-me')){
//                         if(productAction.hasClass('is-notify-me')){
//                             if ($body.hasClass('product-card-layout-08')) {
//                                 productAction2
//                                     .html($iconAddtocart)
//                                     .prop('disabled', false);
//                             } else {
//                                 productAction.text(window.notify_me.button);
//                             }
//                         } else {
//                             if ($body.hasClass('product-card-layout-08')) {
//                                 productAction2
//                                     .html($iconAddtocart)
//                                     .prop('disabled', true);
//                             } else {
//                                 productAction
//                                     .text(window.variantStrings.soldOut)
//                                     .prop('disabled', true);
//                             }
//                         }
//                     } else {
//                         if ($body.hasClass('product-card-layout-08')) {
//                             productAction2
//                                 .html($iconAddtocart)
//                                 .prop('disabled', false);
//                         } else {
//                             productAction
//                                 .text(window.variantStrings.addToCart)
//                                 .prop('disabled', false);
//                         }
//                     }
//                 } else {
//                     if (productJson != undefined) {
//                         if(window.quick_shop.show){
//                             halo.checkStatusSwatchQuickShop(product, productJson);
//                         }
//                     }

//                     product.find('.swatch-element[data-value="' + title + '"]').find('.single-label').trigger('click');
//                 }

//                 if (productJson.media != undefined) {
//                     var mediaList = productJson.media.filter((index, element) => {
//                         return element.alt === title;
//                     });
//                 }

//                 if (mediaList.length > 0) {
//                     if (mediaList.length > 1) {
//                         var length = 2;
//                     } else {
//                         var length = mediaList.length;
//                     }
                    
//                     for (var i = 0; i < length; i++) {
//                         product.find('.card-media img:eq('+ i +')').attr('srcset', mediaList[i].src);
//                     }
//                 } else {
//                     if (newImage) {
//                         product.find('.card-media img:nth-child(1)')
//                         .attr('srcset', newImage)
//                         .attr('data-srcset', newImage);
//                     }
//                 }
  
//                 // halo.checkPreOrderOfVariant(selectedVariant, productAction, productJson)
//                 if (halo.checkNeedToConvertCurrency()) {
//                     Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                 }
//             });
              
//             $doc.on('click', '.item-swatch-more .number-showmore', (event) => {
//                 if ($(event.target).closest('.swatch').hasClass('show--more')) {
//                     $(event.target).closest('.swatch').removeClass('show--more');
//                     $(event.target).find('span:eq(0)').text('+');
//                 } else {
//                     $(event.target).closest('.swatch').addClass('show--more');
//                     $(event.target).find('span:eq(0)').text('-'); 
//                 }
//             })
//         },

//         checkPreOrderOfVariant: function(selectedVariant, productAction, productJson) {
//             // Check if variant is allowed to sale when out of stock
//             const variantId = selectedVariant.id
//             const updatePreOrderText = (productAction, selectedVariant, inventoryQuantity) => {
//                 const product = productAction.parents('.product-item');
//                 const hasQuickShopPanel = product.find('[data-quickshop-popup]').length > 0;

//                 if (selectedVariant.inventory_management == null) {
//                     productAction
//                         .text(hasQuickShopPanel ? window.variantStrings.add : window.variantStrings.addToCart)
//                         .prop('disabled', false)
//                         .removeClass('is-notify-me')
//                         .addClass('button--pre-untrack')
//                 }
//                 else if (selectedVariant.available && inventoryQuantity <=0 ) {
//                     productAction
//                         .text(window.variantStrings.preOrder)
//                         .prop('disabled', false)
//                         .removeClass('is-notify-me')
//                         .addClass('button--pre-untrack')
//                 } else {
//                     productAction.removeClass('button--pre-untrack');
//                     if (inventoryQuantity > 0) {
//                         if(window.notify_me.show){
//                             productAction
//                                 .removeClass('is-notify-me')
//                                 .addClass('is-visible')
//                         } else {
//                             productAction
//                                 .removeClass('is-soldout')
//                                 .addClass('is-visible')
//                         }
//                     } else {
                      
//                        if(window.notify_me.show){
//                             productAction
//                                 .removeClass('is-visible')
//                                 .addClass('is-notify-me')
//                                 .prop('disabled', false);
//                         } else {
//                             productAction
//                                 .removeClass('is-visible')
//                                 .addClass('is-soldout').prop('disabled', true);
//                         }
//                     }

//                     if(productAction.hasClass('is-soldout') || productAction.hasClass('is-notify-me')){
//                         if(productAction.hasClass('is-notify-me')){

//                             productAction.text(window.notify_me.button).prop('disabled', false).removeClass('btn-unavailable');;
//                         } else {
//                             productAction
//                                 .text(window.variantStrings.soldOut)
//                                 .prop('disabled', true);
//                         }
//                     } else {
//                         productAction
//                             .text(hasQuickShopPanel ? window.variantStrings.add : window.variantStrings.addToCart)
//                             .prop('disabled', false);
//                     }
//                 }
//             }
    
//             const variantsQuantityInvenText = `quick_view_inven_array_${productJson.id}`
//             var arrayInVarName = variantsQuantityInvenText,
//                 inven_array = window[arrayInVarName]; 
            
//             if(inven_array != undefined) {
//                 var inven_num = inven_array[variantId],
//                     inventoryQuantity = parseInt(inven_num);
//                     updatePreOrderText(productAction, selectedVariant, inventoryQuantity)
//             } else {
//                 $.ajax({
//                     type: 'get',
//                     url: window.routes.root + '/products/' + productJson.handle + '?view=ajax_quick_shop_data',
//                     beforeSend: function () {},
//                     success: function (data) {
//                         window[variantsQuantityInvenText] = JSON.parse(data.split('=')[1])
//                         var inven_num = window[variantsQuantityInvenText][variantId],
//                             inventoryQuantity = parseInt(inven_num);
//                         updatePreOrderText(productAction, selectedVariant, inventoryQuantity)   
//                     },      
//                     error: function (xhr, text) {
//                         halo.showWarning($.parseJSON(xhr.responseText).description);
//                     },
//                     complete: function () {
                        
//                     }
//                 });
//             }
//         },

//         initQuickShop: function() {
//             if(window.quick_shop.show) {
//                 $doc.on('click', '[data-quickshop-popup]', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();
                    
//                     var $target = $(event.target),
//                         product = $target.parents('.product-item'),
//                         productJson = product.data('json-product'),
//                         variantPopup = product.find('.variants-popup');
                        
//                     const $quickView = document.querySelector('.halo-quick-view-popup');
//                     if (!document.body.matches('.qv-loaded', '.qs3-loaded') && $quickView) {
//                         halo.buildStyleSheet($quickView.dataset.urlStyleProduct, $quickView);
//                         document.body.classList.add('qs3-loaded');
//                     }

//                     if ($body.hasClass('quick_shop_option_1')) {
//                         if (!$('.productListing').hasClass('productList')) {
//                             halo.appendProductQuickShopOption2(product);
//                         }
//                     }

//                     if(!product.hasClass('quickshop-popup-show')){
//                         $('.product-item').removeClass('quickshop-popup-show');

//                         if ($body.hasClass('quick_shop_option_2')) {
//                             var height = product.find('.card-media').outerHeight(true);
//                             var variantsArray = variantPopup.find('.variants')

//                             if ($body.hasClass('product-card-layout-02')){
//                                 if ($win.width() > 1024) {
//                                     variantsArray.css('max-height', (height - 114) + 'px');
//                                     variantsArray.css('min-height', (height - 114) + 'px');
//                                 } else {
//                                     variantsArray.css('max-height', (height - 70) + 'px');
//                                     variantsArray.css('min-height', (height - 70) + 'px');
//                                 } 
//                             } else if ($body.hasClass('product-card-layout-04')){
//                                 if ($win.width() > 1024) {
//                                     variantsArray.css('max-height', (height - 116) + 'px');
//                                     variantsArray.css('min-height', (height - 116) + 'px');
//                                 } else {
//                                     variantsArray.css('max-height', (height - 70) + 'px');
//                                     variantsArray.css('min-height', (height - 70) + 'px');
//                                 } 
//                             } else {
//                                 if ($win.width() > 1024) {
//                                     variantsArray.css('max-height', (height - 74) + 'px');
//                                     variantsArray.css('min-height', (height - 74) + 'px');
//                                 } else {
//                                     variantsArray.css('max-height', (height - 20) + 'px');
//                                     variantsArray.css('min-height', (height - 20) + 'px');
//                                 } 
//                             }

//                             if (variantsArray[0].scrollHeight > variantsArray[0].clientHeight) {
//                                 variantsArray.addClass('scrollable')
//                             }

//                             if (!$('.productListing').hasClass('productList')){
//                                 halo.appendProductQuickShopOption2(product);
//                             }
//                         } else if ($body.hasClass('quick_shop_option_3')) {
//                             const handle = $target.data('product-handle');
//                             if (!$('.productListing').hasClass('productList')){
//                                 halo.updateContentQuickshopOption3(handle);
//                             }
                            
//                             $doc.on('click', '[data-close-quick-shop-popup]', (event) => {
//                                 event.preventDefault();
//                                 event.stopPropagation();
                
//                                 $body.removeClass('quickshop-popup-show');
//                             });
                            
//                             $doc.off('click.quickShopOverlay').on('click.quickShopOverlay', (event) => {
//                                 if ($body.hasClass('quickshop-popup-show')) {
//                                     if (($(event.target).closest('[data-quickshop-popup-option-3]').length === 0)){
//                                         $body.removeClass('quickshop-popup-show');
//                                     }
//                                 }
//                             })
//                         } else if ($body.hasClass('quick_shop_bulk')) {
//                             const handle = $target.data('product-handle');
//                             if (!$('.productListing').hasClass('productList')){
//                                 halo.updateContentQuickBulk(handle, $target);
//                             }
                            
//                             $doc.on('click', '[data-close-quick-shop-popup]', (event) => {
//                                 event.preventDefault();
//                                 event.stopPropagation();
//                                 $body.removeClass('quickshop-popup-show');
//                             });
                            
//                             $doc.off('click.quickShopOverlay').on('click.quickShopOverlay', (event) => {
//                                 if ($body.hasClass('quickshop-popup-show')) {
//                                     if (($(event.target).closest('[data-halo-quick-bulk-popup]').length === 0)){
//                                         $body.removeClass('quickshop-popup-show');
//                                     }
//                                 }
//                             })
//                         }
                        
//                         if (!$body.hasClass('quick_shop_bulk')) {
//                             if (!$body.hasClass('quick_shop_option_3')) {
//                                 if ($win.width() < 767) {
//                                     if ($('.productListing').hasClass('productList')) {
//                                         halo.appendToListViewModal(product)
//                                     } else {
//                                         product.addClass('quickshop-popup-show');
//                                     }
//                                 } else {
//                                     product.addClass('quickshop-popup-show');
//                                 }
//                             } else {
//                                 if ($('.productListing').hasClass('productList')){
//                                     if ($win.width() < 767) {
//                                         halo.appendToListViewModal(product)
//                                     } else {
//                                         product.addClass('quickshop-popup-show');
//                                     }
//                                 }
//                             }
//                         }
                        
//                         product.find('.swatch-label.is-active').trigger('click');
//                         halo.checkStatusSwatchQuickShop(product, productJson);

//                         let checkQuickShop1ForMobile = false;
//                         if ($body.hasClass('quick_shop_option_1') && $win.width() < 767) checkQuickShop1ForMobile = true;
                        
//                         if ($body.hasClass('quick_shop_option_2') || checkQuickShop1ForMobile || ($('productListing').hasClass('productList') && !$('.card-swatch').hasClass('quick_shop_type_3'))) {
//                             if ($win.width() < 767) {
//                                 if (!$('.productListing').hasClass('productList')){
//                                     var quickshopVariantPopup = $('#halo-card-mobile-popup .variants-popup');
//                                     quickshopVariantPopup.find('.selector-wrapper').each((index, element) => {
//                                         $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
//                                     });
//                                 } else {
//                                     variantPopup.find('.selector-wrapper').each((index, element) => {
//                                         $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
//                                     });
//                                 }
//                             } else {
//                                 variantPopup.find('.selector-wrapper').each((index, element) => {
//                                     $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
//                                 });
//                             }
//                             if (!$('.productListing').hasClass('productList')){
//                                 $body.addClass('quick_shop_popup_mobile');
//                             }
//                         } else {
//                             variantPopup.find('.selector-wrapper:not(.option-color)').each((index, element) => {
//                                 $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
//                             });
//                         }
//                     } else {
//                         halo.initAddToCartQuickShop($target, variantPopup);
//                     }

//                     if (halo.checkNeedToConvertCurrency()) {
//                         Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                     }
//                 });

//                 $doc.on('click', '[data-cancel-quickshop-popup]', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();

//                     var $target = $(event.currentTarget),
//                         product = $target.parents('.product-item'),
//                         quickshopMobilePopup = $doc.find('#halo-card-mobile-popup');

//                     product.removeClass('quickshop-popup-show');
//                     var productQuickshopShown = $doc.find('.quickshop-popup-show')
//                     productQuickshopShown.removeClass('quickshop-popup-show');
//                     $body.removeClass('quickshop-list-view-show');
                     
//                     if ($body.hasClass('quick_shop_option_1') || $body.hasClass('quick_shop_option_2')) {
//                         $body.removeClass('quick_shop_popup_mobile');
//                         quickshopMobilePopup.removeClass('show');
//                     }
//                 });

//                 $doc.on('click', (event) => {
//                     if ($(event.target).closest('[data-quickshop-popup]').length === 0 && $(event.target).closest('.variants-popup').length === 0 && $(event.target).closest('.card-swatch').length === 0 && $(event.target).closest('[data-warning-popup]').length === 0) {
//                         $('.product-item').removeClass('quickshop-popup-show');
//                         if($body.hasClass('quick_shop_option_2')){
//                             $body.removeClass('quick_shop_popup_mobile');
//                         }
//                     }
//                 });

//                 halo.changeSwatchQuickShop();
//             }
//         },
  
//         appendToListViewModal: function(product)  {
//             const quickshopMobilePopup = $doc.find('#list-view-popup');
//             const quickshopForm = product.clone();
//             quickshopMobilePopup.find('.halo-popup-content').empty();
//             quickshopMobilePopup.find('.halo-popup-content').append(quickshopForm);

//             const form = quickshopMobilePopup.find('[data-quickshop] .card-information .variants-popup form').eq('0');
//             const mobilePopupId = form.attr('id') + '-mobile';
//             const optionInputs = form.find('.single-option');
//             const optionLabels = form.find('.single-label');
//             const cardInfoWrapper = quickshopMobilePopup.find('.card-product')
//             const variantsPopup = quickshopMobilePopup.find('.variants-popup')
//             const submitBtn = quickshopMobilePopup.find('[data-btn-addtocart]')
//             variantsPopup.removeClass("card-list__hidden")
//             let clicked = {
//                 selected1: false,
//                 selected2: false,
//                 selected3: false
//             } 

//             form.attr('id', mobilePopupId);
//             submitBtn.attr('data-form-id', submitBtn.attr('data-form-id') + '-mobile')

//             optionInputs.each((index, optionInput) => {
//                 $(optionInput).attr('id', $(optionInput).attr('id') + '-mobile');
//                 $(optionInput).attr('name', $(optionInput).attr('name') + '-mobile');
//                 if (optionInput.checked) $(optionInput).trigger('change');
//             })

//             optionLabels.each((index, optionLabel) => {
//                 $(optionLabel).attr('for', $(optionLabel).attr('for') + '-mobile');

//                 const swatchWrapper = $(optionLabel).closest('.selector-wrapper')
//                 const swatchElement = $(optionLabel).closest('.swatch-element')
//                 if (!swatchElement.hasClass('available')) return 
                
//                 if (swatchWrapper.hasClass('selector-wrapper-1') && !clicked.selected1) {
//                     clicked.selected1 = true
//                     $(optionLabel).trigger('click')
//                 } else if (swatchWrapper.hasClass('selector-wrapper-2') && !clicked.selected2) {
//                     clicked.selected2 = true 
//                     $(optionLabel).trigger('click')
//                 } else if (swatchWrapper.hasClass('selector-wrapper-3') && !clicked.selected3) {
//                     clicked.selected3 = true
//                     $(optionLabel).trigger('click')
//                 }
//             })

//             $body.addClass('quickshop-list-view-show');

//             $('.background-overlay').off('click.closeListViewModal').on('click.closeListViewModal', () => {
//                 $body.removeClass('quickshop-list-view-show');
//             })
//         },

//         changeSwatchQuickShop: function () {
//             $doc.on('change', '[data-quickshop] .single-option', (event) => {
                
//                 var $target = $(event.target),
//                     product = $target.parents('.product-item'),
//                     productJson = product.data('json-product'),
//                     productAction = product.find('[data-btn-addtocart]'),
//                     variantList,
//                     optionColor = product.find('.option-color').data('option-position'),
//                     optionIndex = $target.closest('[data-option-index]').data('option-index'),
//                     swatch = product.find('.swatch-element'),
//                     thisVal = $target.val(),
//                     selectedVariant,
//                     productInput = product.find('[name=id]');

//                 if ($('.productListing').hasClass('productList')) {
//                     var selectedOption1 = product.find('.card-information .selector-wrapper-1').find('input:checked').val(),
//                         selectedOption2 = product.find('.card-information .selector-wrapper-2').find('input:checked').val(),
//                         selectedOption3 = product.find('.card-information .selector-wrapper-3').find('input:checked').val();
//                 }
//                 else {
//                     var selectedOption1 = product.find('.selector-wrapper-1').find('input:checked').val(),
//                         selectedOption2 = product.find('.selector-wrapper-2').find('input:checked').val(),
//                         selectedOption3 = product.find('.selector-wrapper-3').find('input:checked').val();
//                 }

//                 if ($body.hasClass('quick_shop_option_2') && $('.productListing').hasClass('productList')) {
//                     selectedOption1 = product.find('.selector-wrapper-1').eq('1').find('input:checked').val();
//                 } else {
//                     if ($('.productListing').hasClass('productList') && $win.width() < 767) {
//                         selectedOption1 = product.find('.selector-wrapper-1').eq('1').find('input:checked').val();
//                         selectedOption2 = product.find('[data-option-index="1"]').eq('1').find('input:checked').val();
//                     } else {
//                         selectedOption1 = product.find('.selector-wrapper-1').eq('0').find('input:checked').val();
//                     }
//                 }

//                 if (productJson != undefined) {
//                     variantList = productJson.variants;
//                 }

//                 swatch.removeClass('soldout');
//                 swatch.find('input[type="radio"]').prop('disabled', false);

//                 switch (optionIndex) {
//                     case 0:
//                         var availableVariants = variantList.find((variant) => {
//                             if (optionColor == 1) {
//                                 if (selectedOption3 != undefined) {
//                                     return variant.option2 == thisVal && variant.option1 == selectedOption2 && variant.option3 == selectedOption3;
//                                 }
//                                 else {
//                                     return variant.option2 == thisVal && variant.option1 == selectedOption2;
//                                 }
//                             } else {
//                                 if (optionColor == 2) {
//                                     return variant.option3 == thisVal && variant.option1 == selectedOption2;
//                                 } else {
//                                     return variant.option1 == thisVal && variant.option2 == selectedOption2;
//                                 }
//                             }
//                         });

//                         if(availableVariants != undefined){
//                             selectedVariant =  availableVariants;
//                         } else{
//                             var altAvailableVariants = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == thisVal;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == thisVal;
//                                     } else {
//                                         return variant.option1 == thisVal;
//                                     }
//                                 }
//                             });

//                             selectedVariant =  altAvailableVariants;
//                         }

//                         break;
//                     case 1:
//                         var availableVariants = variantList.find((variant) => {
//                             if (optionColor == 1) {
//                                 return variant.option2 == selectedOption1 && variant.option1 == thisVal && variant.option3 == selectedOption2;
//                             } else {
//                                 if (optionColor == 2) {
//                                     return variant.option3 == selectedOption1 && variant.option1 == thisVal && variant.option2 == selectedOption2;
//                                 } else {
//                                     return variant.option1 == selectedOption1 && variant.option2 == thisVal && variant.option3 == selectedOption2;
//                                 }
//                             }
//                         });

//                         if(availableVariants != undefined){
//                             selectedVariant =  availableVariants;
//                         } else {
//                             var altAvailableVariants = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == selectedOption1 && variant.option1 == thisVal;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == selectedOption1 && variant.option1 == thisVal;
//                                     } else {
//                                         return variant.option1 == selectedOption1 && variant.option2 == thisVal;
//                                     }
//                                 }
//                             });

//                             selectedVariant =  altAvailableVariants;
//                         }

//                         break;
//                     case 2:
//                         var availableVariants = variantList.find((variant) => {
//                             if (optionColor == 1) {
//                                 return variant.option2 == selectedOption1 && variant.option1 == selectedOption2 && variant.option3 == thisVal;
//                             } else {
//                                 if (optionColor == 2) {
//                                     return variant.option3 == selectedOption1 && variant.option1 == selectedOption2 && variant.option2 == thisVal;
//                                 } else {
//                                     return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == thisVal;
//                                 }
//                             }
//                         });

//                         if(availableVariants != undefined){
//                             selectedVariant =  availableVariants;
//                         }

//                         break;
//                 }
                            
//                 if (selectedVariant == undefined) {
//                     return;
//                 }
                
//                 productInput.val(selectedVariant.id);
//                 var value = $target.val();
               

                
//                 $target.parents('.selector-wrapper').find('.form-label span').text(value);
//                 if (selectedVariant.available) {
//                     product.find('[data-btn-addtocart]').removeClass('btn-unavailable');
//                     product.find('[data-quickshop] quickshop-update-quantity').removeClass('disabled');
//                     product.find('[data-btn-addtocart]').attr('data-available', 'true')
                      
//                 } else {
//                     product.find('[data-btn-addtocart]').addClass('btn-unavailable');
//                     product.find('[data-quickshop] quickshop-update-quantity').addClass('disabled');
//                     product.find('[data-btn-addtocart]').attr('data-available', 'false')
//                 }

//                 if (halo.checkNeedToConvertCurrency()) {
//                     Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                 };

//                 if (!$body.hasClass('quick_shop_option_2') && !$body.hasClass('quick_shop_option_3') && $win.width() < 767) {
                    
//                 } 

//                 if ($body.hasClass('quick_shop_option_2') && $win.width() < 767) {
//                     if ($('.halo-popup-wrapper .card-product__wrapper [data-option-index="0"] .swatch-element').length == 1){
//                         $('.halo-popup-wrapper .card-product__wrapper [data-option-index="0"] .swatch-element').eq('0').find('.single-label').trigger('click');
//                     }
//                     if ($('.halo-product-list-view-popup .product-options-wrapper .product-item .card-information [data-option-index="0"] .swatch-element').length == 1) {
//                         $('.halo-product-list-view-popup .product-options-wrapper .product-item .card-information [data-option-index="0"] .swatch-element').eq('0').find('.single-label').trigger('click');
//                     }
//                 } 

//                 halo.checkStatusSwatchQuickShop(product, productJson);
//                 halo.checkPreOrderOfVariant(selectedVariant, productAction, productJson);
//             });
//         },

//         checkStatusSwatchQuickShop: function(product, productJson){
//             var variantPopup = product.find('.card-variant'),
//                 variantList,
//                 productOption = product.find('[data-option-index]'),
//                 optionColor = product.find('.option-color').data('option-position'),
//                 selectedOption1 = product.find('[data-option-index="0"]').find('input:checked').val(),
//                 selectedOption2 = product.find('[data-option-index="1"]').find('input:checked').val(),
//                 selectedOption3 = product.find('[data-option-index="2"]').find('input:checked').val(),
//                 productId = product.data('product-id');

            
//             if ($body.hasClass('quick_shop_option_2')) {
//                 var height = product.find('.card-media').outerHeight(true);
//                 if (selectedOption3 != undefined) {
//                     if ($body.hasClass('product-card-layout-01')) {
//                         if (height < 310) {
//                             $('[data-quickshop]').addClass('active_option_3');
//                         } else {
//                             $('[data-quickshop]').removeClass('active_option_3');
//                         }  
//                     } else {
//                         if (height < 370) {
//                             $('[data-quickshop]').addClass('active_option_3');
//                         } else {
//                             $('[data-quickshop]').removeClass('active_option_3');
//                         } 
//                     }
//                 } else {
//                     if ($win.width() > 1024) {
//                         if ($body.hasClass('product-card-layout-05')) {
//                             if (height < 350 && selectedOption2 != undefined) {
//                                 $('[data-quickshop]').addClass('active_option_3');
//                             } else {
//                                 $('[data-quickshop]').removeClass('active_option_3');
//                             }    
//                         } else if ($body.hasClass('product-card-layout-01')) {
//                             if (height < 310 && selectedOption2 != undefined) {
//                                 $('[data-quickshop]').addClass('active_option_3');
//                             } else {
//                                 $('[data-quickshop]').removeClass('active_option_3');
//                             }  
//                         }else {
//                             if (height < 370 && selectedOption2 != undefined) {
//                                 $('[data-quickshop]').addClass('active_option_3');
//                             } else {
//                                 $('[data-quickshop]').removeClass('active_option_3');
//                             }   
//                         }
//                     } else {
//                         if ($body.hasClass('product-card-layout-01')) {
//                             if (height < 310) {
//                                 if (selectedOption1 != undefined || selectedOption2 != undefined) {
//                                     $('[data-quickshop]').removeClass('active_option_3');
//                                 } else {
//                                     $('[data-quickshop]').addClass('active_option_3');
//                                 }
//                             } else {
//                                 $('[data-quickshop]').removeClass('active_option_3');
//                             }   
//                         } else {
//                             if (height < 370) {
//                                 if (selectedOption1 != undefined || selectedOption2 != undefined) {
//                                     $('[data-quickshop]').removeClass('active_option_3');
//                                 } else {
//                                     $('[data-quickshop]').addClass('active_option_3');
//                                 }
//                             } else {
//                                 $('[data-quickshop]').removeClass('active_option_3');
//                             }   
//                         }
//                     }
//                 }
//             }

//             if ($body.hasClass('quick_shop_option_2') && $('.productListing').hasClass('productList')) {
//                 selectedOption1 = product.find('[data-option-index="0"]').eq('1').find('input:checked').val();
//             } else {
//                 if ($('.productListing').hasClass('productList') && $win.width() < 767) {
//                     selectedOption1 = product.find('[data-option-index="0"]').eq('1').find('input:checked').val();
//                     selectedOption2 = product.find('[data-option-index="1"]').eq('1').find('input:checked').val();
//                 } else {
//                     selectedOption1 = product.find('[data-option-index="0"]').eq('0').find('input:checked').val();
//                 }
//             }
            
//             if (productJson != undefined) {
//                 variantList = productJson.variants;
//             }

//             productOption.each((index, element) => {
//                 var optionIndex = $(element).data('option-index'),
//                     swatch = $(element).find('.swatch-element');

//                 switch (optionIndex) {
//                     case 0: 
//                         swatch.each((idx, elt) => {
//                             var item = $(elt),
//                                 swatchVal = item.data('value');

//                             var optionSoldout = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == swatchVal && variant.available;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == swatchVal && variant.available;
//                                     } else {
//                                         return variant.option1 == swatchVal && variant.available;
//                                     }
//                                 }
//                             });

//                             var optionUnavailable = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == swatchVal;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == swatchVal;
//                                     } else {
//                                         return variant.option1 == swatchVal;
//                                     }
//                                 }
//                             });

//                             if(optionSoldout == undefined){
//                                 if (optionUnavailable == undefined) {
//                                     item.removeClass('soldout available').addClass('unavailable');
//                                     item.find('input[type="radio"]').prop('checked', false);
//                                 } else {
//                                     item
//                                         .removeClass('unavailable available')
//                                         .addClass('soldout')
//                                         .find('.single-action')
//                                         .attr('data-variant-id', optionUnavailable.title);
//                                     item.find('input[type="radio"]').prop('disabled', false);
//                                 }
//                             } else {
//                                 item.removeClass('soldout unavailable').addClass('available');
//                                 item.find('input[type="radio"]').prop('disabled', false);
//                             }
//                         });

//                         break;
//                     case 1:
//                         swatch.each((idx, elt) => {
//                             var item = $(elt),
//                                 swatchVal = item.data('value');

//                             var optionSoldout = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == selectedOption1 && variant.option1 == swatchVal && variant.available;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == selectedOption1 && variant.option1 == swatchVal && variant.available;
//                                     } else {
//                                         return variant.option1 == selectedOption1 && variant.option2 == swatchVal && variant.available;
//                                     }
//                                 }
//                             });

//                             var optionUnavailable = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == selectedOption1 && variant.option1 == swatchVal;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == selectedOption1 && variant.option1 == swatchVal;
//                                     } else {
//                                         // CHECK: find the error and value of selectedOption1 
//                                         return variant.option1 == selectedOption1 && variant.option2 == swatchVal;
//                                     }
//                                 }
//                             });

//                             if(optionSoldout == undefined){
//                                 if (optionUnavailable == undefined) {
//                                     item.removeClass('soldout available').addClass('unavailable');
//                                     item.find('input[type="radio"]').prop('checked', false);
//                                 } else {
//                                     item
//                                         .removeClass('unavailable available')
//                                         .addClass('soldout')
//                                         .find('.single-action-selector')
//                                         .attr('data-variant-id', optionUnavailable.title);
//                                     item.find('input[type="radio"]').prop('disabled', false);
//                                 }
//                             } else {
//                                 item.removeClass('soldout unavailable').addClass('available');
//                                 item.find('input[type="radio"]').prop('disabled', false);
//                             }
                            
//                         });
//                         break;
//                     case 2:
//                         swatch.each((idx, elt) => {
//                             var item = $(elt),
//                                 swatchVal = item.data('value');

//                             var optionSoldout = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == selectedOption1 && variant.option1 == selectedOption2 && variant.option3 == swatchVal && variant.available;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == selectedOption1 && variant.option1 == selectedOption2 && variant.option2 == swatchVal && variant.available;
//                                     } else {
//                                         return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == swatchVal && variant.available;
//                                     }
//                                 }
//                             });

//                             var optionUnavailable = variantList.find((variant) => {
//                                 if (optionColor == 1) {
//                                     return variant.option2 == selectedOption1 && variant.option1 == selectedOption2 && variant.option3 == swatchVal;
//                                 } else {
//                                     if (optionColor == 2) {
//                                         return variant.option3 == selectedOption1 && variant.option1 == selectedOption2 && variant.option2 == swatchVal;
//                                     } else {
//                                         return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == swatchVal;
//                                     }
//                                 }
//                             });

//                             if(optionSoldout == undefined){
//                                 if (optionUnavailable == undefined) {
//                                     item.removeClass('soldout available').addClass('unavailable');
//                                     item.find('input[type="radio"]').prop('checked', false);
//                                 } else {
//                                     item
//                                         .removeClass('unavailable available')
//                                         .addClass('soldout')
//                                         .find('.single-action-selector')
//                                         .attr('data-variant-id', optionUnavailable.title);
//                                     item.find('input[type="radio"]').prop('disabled', false);
//                                 }
//                             } else {
//                                 item.removeClass('unavailable soldout').addClass('available');
//                                 item.find('input[type="radio"]').prop('disabled', false);
//                             }
//                         });

//                         break;  
//                 }
//             });

//             variantPopup.find('.selector-wrapper:not(.option-color)').each((index, element) => {
//                 var item = $(element);

//                 if (item.find('.swatch-element').find('input:checked').length < 1) {
//                     if (item.find('.swatch-element.available').length > 0) {
//                         item.find('.swatch-element.available').eq('0').find('.single-label').trigger('click');
//                     } else {
//                         item.find('.swatch-element.soldout').eq('0').find('.single-label').trigger('click');
//                     }
//                 }
//             });

  
//             if ($body.hasClass('quick_shop_option_2')) {
//                 var variantId = product.find('[data-quickshop]').eq(1).find('[name="id"]').val();
//                 var arrayInVarName = `quick_view_inven_array_${productId}`,
//                     inven_array = window[arrayInVarName]; 
                  
//                 if(inven_array != undefined) {
//                     var inven_num = inven_array[variantId],
//                         inventoryQuantity = parseInt(inven_num),
//                         quantityInput = product.find('input[name="quantity"]').eq(0);
                    
//                     quantityInput.attr('data-inventory-quantity', inventoryQuantity);
//                     if (quantityInput.val() > inventoryQuantity) {
//                         if (inventoryQuantity > 0) {
//                             quantityInput.val(inventoryQuantity)
//                         } else {
//                             quantityInput.val(1)
//                         }
//                     }
//                 }
//             }
//         },
        
//         initAddToCartQuickShop: function($target, popup){
//             if (window.customerInfoPopupPending) {
//                 window.customerInfoPopupTarget = $target;
//                 window.customerInfoPopupQuickShop = true;
//                 window.customerInfoPopupQuickShopPopup = popup;
//                 $body.removeClass('quickshop-popup-show');
//                 $doc.find('.quickshop-popup-show').removeClass('quickshop-popup-show');
//                 $body.removeClass('quick_shop_popup_mobile');
//                 $doc.find('#halo-card-mobile-popup').removeClass('show');
//                 $body.addClass('customer-info-show');
//                 return;
//             }

//             var variantId = popup.find('[name="id"]').val(),
//                 qty = 1;

//             halo.actionAddToCart($target, variantId, qty);
            
//         },

//         initAddToCart: function() {
//             $doc.off('click.addToCart').on('click.addToCart', '[data-btn-addtocart]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.target),
//                     product = $target.parents('.product-item'),
//                     MobilePopup_Option_2 = $doc.find('#halo-card-mobile-popup'),
//                     ProductQuickShopShown_Option_2 = $doc.find('.quickshop-popup-show');

//                 if (window.customerInfoPopupPending) {
//                     window.customerInfoPopupTarget = $target;
//                     $body.removeClass('quickshop-popup-show');
//                     $doc.find('.quickshop-popup-show').removeClass('quickshop-popup-show');
//                     $body.removeClass('quick_shop_popup_mobile');
//                     $doc.find('#halo-card-mobile-popup').removeClass('show');
//                     $body.addClass('customer-info-show');
//                     return;
//                 }

//                 if($target.closest('product-form').length > 0){
//                     var productForm = $target.closest('form');
                    
//                     halo.actionAddToCart2($target, productForm);
//                 } else {
//                     if(!$target.hasClass('is-notify-me') && !$target.hasClass('is-soldout')){
//                         var form = $target.parents('form'),
//                             variantId = form.find('[name="id"]').val(),
//                             qty = form.find('[name="quantity"]').val(),
//                             input = form.find('[name="quantity"]').eq(0);
//                         if(qty == undefined){
//                             qty = 1;
//                         }

//                         var quickViewSection = $target.closest('.productView')[0];
//                         var hasCustomization = (quickViewSection && quickViewSection.querySelector('[data-jersey-customization]')) || form.find('[data-jersey-customization]').length > 0;

//                         if ($('.recipient-form').length > 0) {
//                             $('#product-add-to-cart').trigger("click");
//                         } else if (hasCustomization) {
//                             halo.actionAddToCart2($target, form);
//                         } else {
//                             halo.actionAddToCart($target, variantId, qty, input);
//                         }
                    
//                     } else if($target.hasClass('is-notify-me')){
//                         halo.notifyInStockPopup($target);
//                     }
//                 }
//             });
            
//             $doc.on('click', '[data-close-add-to-cart-popup]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.removeClass('add-to-cart-show');
//             });


//             $doc.on('click', (event) => {
//                 if($body.hasClass('add-to-cart-show')){
//                     if (($(event.target).closest('[data-add-to-cart-popup]').length === 0)) {
//                         $body.removeClass('add-to-cart-show');
//                     }
//                 }
//             });
//         },

//         initBuyNow: function() {
//             $doc.off('click.buyNow').on('click.buyNow', '[data-buy-now]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.target);
//                 $target.addClass('is-loading');

//                 var addToCartForm = $target.closest('form')[0] || document.querySelector('[data-type="add-to-cart-form"]');
//                 var formData = new FormData(addToCartForm);
//                 var productSection = addToCartForm.closest('.productView') || addToCartForm.closest('.variants-popup') || addToCartForm.closest('form') || document;
//                 var customizationWrapper = productSection.querySelector('[data-jersey-customization]') || addToCartForm.querySelector('[data-jersey-customization]');
//                 var customizationSelected = customizationWrapper && customizationWrapper.querySelector('input[name="jersey_customization"]:checked');
//                 var isCustomizationAdd = customizationSelected && customizationSelected.value === 'yes';
//                 var customizationVariantIdInput = productSection.querySelector('[data-customization-variant-id]') || addToCartForm.querySelector('[data-customization-variant-id]');

//                 var mainId = formData.get('id');
//                 var quantity = parseInt(formData.get('quantity') || 1);

//                 var cartPromise;

//                 if (isCustomizationAdd && customizationVariantIdInput) {
//                     var nameInput = productSection.querySelector('[data-jersey-customization-name]') || addToCartForm.querySelector('[data-jersey-customization-name]');
//                     var numberInput = productSection.querySelector('[data-jersey-customization-number]') || addToCartForm.querySelector('[data-jersey-customization-number]');
//                     var name = nameInput ? nameInput.value : '';
//                     var number = numberInput ? numberInput.value : '';

//                     var items = [
//                         {
//                             id: mainId,
//                             quantity: quantity,
//                             properties: {}
//                         },
//                         {
//                             id: customizationVariantIdInput.value,
//                             quantity: quantity
//                         }
//                     ];

//                     if (name) items[0].properties.Name = name;
//                     if (number) items[0].properties.Number = number;

//                     var jsonConfig = fetchConfig('javascript');
//                     cartPromise = fetch(window.Shopify.routes.root + 'cart/add.js', {
//                         ...jsonConfig,
//                         method: 'POST',
//                         body: JSON.stringify({ items: items })
//                     });
//                 } else {
//                     var config = fetchConfig('javascript');
//                     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//                     delete config.headers['Content-Type'];
//                     cartPromise = fetch(window.Shopify.routes.root + 'cart/add.js', {
//                         ...config,
//                         method: 'POST',
//                         body: formData
//                     });
//                 }

//                 cartPromise.then(response => response.json())
//                 .then(() => {
//                     window.location.href = window.Shopify.routes.root + 'checkout';
//                 })
//                 .catch((error) => {
//                     console.error('Error:', error);
//                     $target.removeClass('is-loading');
//                 });
//             });
//         },

//         actionAddToCart: function($target, variantId, qty, input){
//             var originalMessage = window.variantStrings.submit,
//                 waitMessage = window.variantStrings.addingToCart,
//                 successMessage = window.variantStrings.addedToCart;

//             if($target.hasClass('button-text-change')){
//                 originalMessage = $target.text();
//             }

//             $target.addClass('is-loading');

//             if($body.hasClass('quick-view-show')){
//                 Shopify.addItem(variantId, qty, $target, () => {
//                     switch (window.after_add_to_cart.type) {
//                         case 'cart':
//                             halo.redirectTo(window.routes.cart);

//                             break;
//                         case 'quick_cart':
//                             if(window.quick_cart.show){
//                                 Shopify.getCart((cart) => {
//                                     if( window.quick_cart.type == 'popup'){
//                                     } else {
//                                         $body.addClass('cart-sidebar-show');
//                                         halo.updateSidebarCart(cart);
//                                     }
//                                     if (cart.item_count >= 100){
//                                         $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                     }

//                                     $target.removeClass('is-loading');
//                                     $('.background-overlay').removeClass('hold');
//                                 });
//                             } else {
//                                 halo.showWarning(window.after_add_to_cart.message_2);
//                                 $target.removeClass('is-loading');
//                                 halo.showWarning(window.after_add_to_cart.message_2);
//                                 Shopify.getCart((cart) => {
//                                     $body.find('[data-cart-count]').text(cart.item_count);
//                                     if (cart.item_count >= 100){
//                                         $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                     }
//                                     if (cart.item_count == 1){
//                                         $body.find('[data-cart-text]').text(window.cartStrings.item);
//                                     } else {
//                                         $body.find('[data-cart-text]').text(window.cartStrings.items);
//                                     }
//                                 });
//                             }

//                             break;
//                         case 'popup_cart_1':
//                             Shopify.getCart((cart) => {
//                                 halo.updatePopupCart(cart, 1, variantId);
//                                 //halo.updateSidebarCart(cart);
//                                 $body.addClass('add-to-cart-show');
//                                 $body.removeClass('quick-view-show');
//                                 $target.removeClass('is-loading');
//                                 if (cart.item_count >= 100){
//                                     $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                 }
//                                 $('.background-overlay').removeClass('hold');
//                             });

//                             break;
//                     }
//                 }, input);
//             } else if($body.hasClass('template-cart')) {
//                 Shopify.addItem(variantId, qty, $target, () => {
//                     // $target.text(successMessage);
//                     halo.redirectTo(window.routes.cart);
//                 }, input);
//             } else {
//                 Shopify.addItem(variantId, qty, $target, () => {
//                     // $target.text(successMessage);
//                     $target.removeClass('is-loading');
//                     if ($body.hasClass('quickshop-popup-show') && $body.hasClass('quick_shop_option_3')) {
//                         $body.removeClass('quickshop-popup-show');
                        
//                         $('.quickshop-popup-show').removeClass('quickshop-popup-show');
//                     }

//                     if ($body.hasClass('quickshop-list-view-show')) {
//                         $body.removeClass('quickshop-list-view-show')
//                     }

//                     if ($body.hasClass('show-mobile-options')) {
//                         $body.removeClass('show-mobile-options');
//                         $('.background-overlay').addClass('hold');
//                     }

//                     if ($body.hasClass('quick_shop_popup_mobile') && $body.hasClass('quick_shop_option_1') || $body.hasClass('quick_shop_option_2')) {
//                         // setTimeout(() => {
//                             $body.removeClass('quick_shop_popup_mobile');
//                             $doc.find('#halo-card-mobile-popup').removeClass('show');
//                             $doc.find('.quickshop-popup-show').each((index, popup) => {
//                                 $(popup).removeClass('quickshop-popup-show');
//                             })
//                         // }, 200);
//                     }

//                     switch (window.after_add_to_cart.type) {
//                         case 'cart':
//                             halo.redirectTo(window.routes.cart);

//                             break;
//                         case 'quick_cart':
//                             if(window.quick_cart.show){
//                                 Shopify.getCart((cart) => {
//                                     if( window.quick_cart.type == 'popup'){
//                                     } else {
//                                         $body.addClass('cart-sidebar-show');
//                                         halo.updateSidebarCart(cart);
//                                     }
//                                     $target.removeClass('is-loading');
//                                     $('.background-overlay').removeClass('hold');
//                                     if (cart.item_count >= 100){
//                                         $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                     }
//                                 });

//                             } else {
//                                 halo.showWarning(window.after_add_to_cart.message_2);
//                                 Shopify.getCart((cart) => {
//                                     $body.find('[data-cart-count]').text(cart.item_count);
//                                     if (cart.item_count >= 100){
//                                         $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                     }
//                                     if (cart.item_count == 1){
//                                         $body.find('[data-cart-text]').text(window.cartStrings.item);
//                                     } else {
//                                         $body.find('[data-cart-text]').text(window.cartStrings.items);
//                                     }
//                                 });
//                             }

//                             break;
//                         case 'popup_cart_1':
//                             Shopify.getCart((cart) => {
//                                 halo.updatePopupCart(cart, 1, variantId);
//                                 $body.addClass('add-to-cart-show');
//                                 $target.removeClass('is-loading');
//                                 $('.background-overlay').removeClass('hold');
//                                 if (cart.item_count >= 100){
//                                     $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                 }
//                             });

//                             break;
//                     }
//                 }, input);
//             }
//         },

//         actionAddToCart2: function($target, productForm) {
//             const config = fetchConfig('javascript');
//             config.headers['X-Requested-With'] = 'XMLHttpRequest';
//             delete config.headers['Content-Type'];
//             var originalMessage = window.variantStrings.submit,
//                 waitMessage = window.variantStrings.addingToCart,
//                 successMessage = window.variantStrings.addedToCart;
            
//             if($target.hasClass('button-text-change')){
//                 originalMessage = $target.text();
//             }

//             $target.addClass('is-loading');

//             let addToCartForm = productForm[0] || document.querySelector('[data-type="add-to-cart-form"]');
//             let formData = new FormData(addToCartForm);

//             const properties = document.querySelectorAll('.line-item-property__field [name^="properties"]')

//             properties.forEach(property => {
//               if (property.value == null) return;
//                 if (property.type == 'file') {
//                   formData.append(property.name, property.files[0])
//                 } else {
//                   formData.append(property.name, property.value)
//                 }
//             })

//             const enoughInStock = halo.checkSufficientStock(productForm);
//             if (!enoughInStock && $body.hasClass('quickshop-popup-show')) {
//                 alert(window.cartStrings.addProductOutQuantity);
//                 $target.removeClass('is-loading');
//                 return 
//             }

//             const productSection = addToCartForm.closest('.productView') || addToCartForm.closest('.variants-popup') || addToCartForm.closest('form') || document;
//             const customizationWrapper = productSection.querySelector('[data-jersey-customization]') || addToCartForm.querySelector('[data-jersey-customization]');
//             const customizationSelected = customizationWrapper && customizationWrapper.querySelector('input[name="jersey_customization"]:checked');
//             const isCustomizationAdd = customizationSelected && customizationSelected.value === 'yes';
//             const customizationVariantIdInput = (productSection.querySelector('[data-customization-variant-id]') || addToCartForm.querySelector('[data-customization-variant-id]'));

//             const addItemToCart = (variantId) => {
//                 let fetchPromise;

//                 if (isCustomizationAdd && customizationVariantIdInput) {
//                     const mainId = formData.get('id');
//                     const quantity = parseInt(formData.get('quantity') || 1);
//                     const nameInput = (productSection.querySelector('[data-jersey-customization-name]') || addToCartForm.querySelector('[data-jersey-customization-name]'));
//                     const numberInput = (productSection.querySelector('[data-jersey-customization-number]') || addToCartForm.querySelector('[data-jersey-customization-number]'));
//                     const name = nameInput ? nameInput.value : '';
//                     const number = numberInput ? numberInput.value : '';

//                     const items = [
//                         {
//                             id: mainId,
//                             quantity: quantity,
//                             properties: {}
//                         },
//                         {
//                             id: customizationVariantIdInput.value,
//                             quantity: quantity
//                         }
//                     ];

//                     if (name) items[0].properties.Name = name;
//                     if (number) items[0].properties.Number = number;

//                     const jsonConfig = fetchConfig('javascript');
//                     jsonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

//                     fetchPromise = fetch(window.Shopify.routes.root + 'cart/add.js', {
//                         ...jsonConfig,
//                         method: 'POST',
//                         body: JSON.stringify({ items: items })
//                     });
//                 } else {
//                     fetchPromise = fetch(window.Shopify.routes.root + 'cart/add.js', {...config, ...{
//                             method: 'POST',
//                             body: formData
//                         }
//                     });
//                 }

//                 fetchPromise
//                 .then(response => {
//                     return response.json();
//                 })
//                 .catch((error) => {
//                     console.error('Error:', error);
//                 })
//                 .finally(() => {
//                     if ($body.hasClass('quickshop-popup-show') && $body.hasClass('quick_shop_option_3')) {
//                         $body.removeClass('quickshop-popup-show');
//                     }

//                     $('.quickshop-popup-show').removeClass('quickshop-popup-show');

//                     if ($body.hasClass('quickshop-list-view-show')) {
//                         $body.removeClass('quickshop-list-view-show')
//                     }

//                     if ($body.hasClass('show-mobile-options')) {
//                         $body.removeClass('show-mobile-options');
//                         $('.background-overlay').addClass('hold');
//                     }

//                     if ($body.hasClass('quick_shop_popup_mobile') && $body.hasClass('quick_shop_option_1') || $body.hasClass('quick_shop_option_2')) {
//                         $body.removeClass('quick_shop_popup_mobile');
//                         $doc.find('#halo-card-mobile-popup').removeClass('show');
//                         $doc.find('.quickshop-popup-show').each((index, popup) => {
//                             $(popup).removeClass('quickshop-popup-show');
//                         })
//                     }

//                     if($body.hasClass('quick-view-show')){
//                         if (window.after_add_to_cart.type == 'cart') {
//                             halo.redirectTo(window.routes.cart);
//                         } else {
//                             Shopify.getCart((cartTotal) => {
//                                 $body.find('[data-cart-count]').text(cartTotal.item_count);
//                                 $target.removeClass('is-loading');
//                                 if (cart.item_count >= 100){
//                                     $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                 }
//                             });
//                         }
//                     } else {
//                         switch (window.after_add_to_cart.type) {
//                             case 'cart':
//                                 halo.redirectTo(window.routes.cart);
                            
//                                 break;
//                             case 'quick_cart':
//                                 if(window.quick_cart.show){
//                                     Shopify.getCart((cart) => {
//                                         if( window.quick_cart.type == 'popup'){
//                                             // $body.addClass('cart-modal-show');
//                                             // halo.updateDropdownCart(cart);
//                                         } else {
//                                             $body.addClass('cart-sidebar-show');
//                                             halo.updateSidebarCart(cart);
//                                         }
//                                         $target.removeClass('is-loading');
//                                         $('.background-overlay').removeClass('hold');
//                                         if (cart.item_count >= 100){
//                                             $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                         }
//                                     });
//                                 } else {
//                                     halo.redirectTo(window.routes.cart);
//                                 }
                                
//                                 break;
//                             case 'popup_cart_1':
//                                 Shopify.getCart((cart) => {
//                                     halo.updatePopupCart(cart, 1, variantId);
//                                     halo.updateSidebarCart(cart);
//                                     $body.addClass('add-to-cart-show');
//                                     $target.removeClass('is-loading');
//                                     if (cart.item_count >= 100){
//                                         $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                                     }
//                                 });
    
//                                 break;
//                         }
//                     }
//                 });
//             }

//             fetch(window.Shopify.routes.root + 'cart.js', {
//                 method: 'GET',
//             })
//             .then(response => {
//                 return response.json();
//             }).then(response => { 
//                 const variantId = parseInt($(addToCartForm).serialize().split('id=')[1])
//                 const item = response.items.find(item => item.variant_id == variantId)
//                 const currentQuantity = item?.quantity 
//                 const currentProductId = item?.product_id
//                 const moreQuantity = parseInt(productForm.find('[data-inventory-quantity]').val()) 
//                 const maxQuantity = parseInt(productForm.find('[data-inventory-quantity]').data('inventory-quantity'))
//                 const saleOutStock = (document.getElementById('product-add-to-cart')?.dataset.available === 'true') || false

//                 if (!currentQuantity || !maxQuantity || saleOutStock) return addItemToCart(variantId)
//                 var arrayInVarName = `selling_array_${currentProductId}`,
//                 itemInArray = window[arrayInVarName],
//                 itemStatus = itemInArray[variantId];
//                 if(itemStatus == 'deny') {
//                     if (currentQuantity + moreQuantity > maxQuantity)  {
//                         if(maxQuantity < 0){
//                             addItemToCart(variantId);
//                         } else {
//                             const remainingQuantity = maxQuantity - currentQuantity 
//                             throw new Error(`You ${remainingQuantity > 0 ? `can only add ${remainingQuantity}` : 'cannot add'} more of the items into the cart`)
//                         }
//                     } else {
//                         addItemToCart(variantId);
//                     }
//                 } else {
//                   addItemToCart(variantId);
//                 }
//             }).catch(err => {
//                 this.showWarning(err)
//             }).finally(() => {
//                 $target.removeClass('is-loading');
//             })
//         },

//         checkSufficientStock: function(productForm) {
//             const maxValidQuantity = productForm.find('[data-inventory-quantity]').data('inventory-quantity')
//             const inputQuantity = parseInt(productForm.find('[data-inventory-quantity]').val())
            
//             return maxValidQuantity >= inputQuantity
//         },  

//         updateContentQuickshopOption3: function(handle){
//             var quickShopPopup = $('#halo-quickshop-popup-option-3'),
//                 quickShopPopupContent = quickShopPopup.find('.halo-popup-content');

//             $.ajax({
//                 type: 'get',
//                 url: window.routes.root + '/products/' + handle + '?view=ajax_quick_shop',
//                 beforeSend: function () {
//                     $('[data-quick-view-popup] .halo-popup-content').empty()
//                 },
//                 success: function (data) {
//                     quickShopPopupContent.html(data);       
//                 },
//                 error: function (xhr, text) {
//                     // alert($.parseJSON(xhr.responseText).description);
//                     halo.showWarning($.parseJSON(xhr.responseText).description);
//                 },
//                 complete: function () {
//                     var $scope = quickShopPopup.find('.quickshop');
                    
//                     halo.productImageGallery($scope);
//                     setTimeout(() => {
//                         $body.addClass('quickshop-popup-show');
//                     }, 150)
//                 }
//             });
//         },

//         updateContentQuickBulk: function(handle, $target){
//             const quickBulkPopup = $('#halo-quick-bulk-popup'),
//                 quickBulkPopupContent = quickBulkPopup.find('.halo-popup-content');

//             $.ajax({
//                 type: 'get',
//                 url: window.routes.root + '/products/' + handle + '?view=ajax_quick_bulk',
//                 beforeSend: function () {
//                     $target.addClass('is-loading');
//                     $('[data-quick-view-popup] .halo-popup-content').empty();
//                 },
//                 success: function (data) {
//                     quickBulkPopupContent.html(data);       
//                 },
//                 error: function (xhr, text) {
//                     halo.showWarning($.parseJSON(xhr.responseText).description);
//                 },
//                 complete: function () {
//                     var $scope = quickBulkPopup.find('.quickshop');
//                     halo.productImageGallery($scope);
//                     setTimeout(() => {$target.removeClass('is-loading')}, 100);
//                 }
//             });
//         },
        
//         appendProductQuickShopOption2: function(product) {
//             //  Append Product Popup Quick Shop 2 Show Mobile
//             if (window.innerWidth <= 767) {
//                 var quickshopMobilePopup = $doc.find('#halo-card-mobile-popup');
//                 var quickshopForm = product.clone();
//                 quickshopMobilePopup.find('.halo-popup-content').empty();
//                 quickshopForm.find('.card-product__group').remove();
//                 quickshopMobilePopup.find('.halo-popup-content').append(quickshopForm);

//                 var form = quickshopMobilePopup.find('[data-quickshop] form').eq('0');
//                 var mobilePopupId = form.attr('id') + 'mobile';
//                 form.attr('id', mobilePopupId);
//                 var optionInputs = form.find('.single-option');
//                 var optionLabels = form.find('.single-label');

//                 optionInputs.each((index, optionInput) => {
//                     $(optionInput).attr('id', $(optionInput).attr('id') + '-mobile');
//                 })
                
//                 optionLabels.each((index, optionLabel) => {
//                     $(optionLabel).attr('for', $(optionLabel).attr('for') + '-mobile');
//                 })

//                 quickshopMobilePopup.addClass('show');

//                 $body.addClass("quick_shop_popup_mobile");

//                 $doc.on('click', (e) => {
//                     var $target = $(e.target)
//                     if ($target.hasClass('background-overlay')) {
//                         quickshopMobilePopup.removeClass('show');
//                         $body.removeClass('quick_shop_popup_mobile');
//                         product.removeClass('quickshop-popup-show');
//                     }
//                 })
//             } 
//         },

//         isRunningInIframe: function() {
//             try {
//                 return window.self !== window.top;
//             } catch (e) {
//                 return true;
//             }
//         },

//         redirectTo: function(url){
//             if (halo.isRunningInIframe() && !window.iframeSdk) {
//                 window.top.location = url;
//             } else {
//                 window.location = url;
//             }
//         },

//         initQuickCart: function() {
//             if(window.quick_cart.show){
//                 if(window.quick_cart.type == 'popup'){
//                     // halo.initDropdownCart();
//                 } else {
//                     halo.initSidebarCart();
//                 }
//             }

//             halo.initEventQuickCart();
//         },

//         initEventQuickCart: function(){
//             halo.removeItemQuickCart();
//             halo.updateQuantityItemQuickCart();
//             halo.editQuickCart();
//         },

//         productCollectionCartSlider: function(){
//             var productCart = $('[data-product-collection-cart]');

//             productCart.each((index, element) => {
//                 var self = $(element),
//                     productGrid = self.find('.products-carousel'),
//                     itemDots = productGrid.data('item-dots'),
//                     itemArrows = productGrid.data('item-arrows');

//                 if(productGrid.length > 0){
//                     if(!productGrid.hasClass('slick-initialized')){
//                         productGrid.slick({
//                             mobileFirst: true,
//                             adaptiveHeight: false,
//                             infinite: false,
//                             vertical: false,
//                             slidesToShow: 1,
//                             slidesToScroll: 1,
//                             dots: true,
//                             arrows: false,
//                             nextArrow: window.arrows.icon_next,
//                             prevArrow: window.arrows.icon_prev,
//                             rtl: window.rtl_slick,
//                             responsive: [
//                             {
//                                 breakpoint: 1025,
//                                 settings: {
//                                     dots: itemDots,
//                                     arrows: itemArrows
//                                 }
//                             }]
//                         });
//                     }
//                 }
//             });
//         },

//         updatePopupCart: function(cart, layout, variantId) {
//             var item = cart.items.filter(item => item.id == variantId)[0],
//                 popup = $('[data-add-to-cart-popup]'),
//                 product = popup.find('.product-added'),
//                 productTitle = product.find('.product-title'),
//                 productImage = product.find('.product-image'),
//                 title = item.title || item.product_title,
//                 image = item.featured_image,
//                 img = '<img src="'+ image.url +'" alt="'+ image.alt +'" title="'+ image.alt +'"/>';

//             productImage.attr('href', item.url).html(img);

//             productTitle
//                 .find('.title')
//                 .attr('href', item.url)
//                 .empty()
//                 .append(title);

//             Shopify.getCart((cartTotal) => {
//                 $body.find('[data-cart-count]').text(cartTotal.item_count);
//             });
//         },

//         initSidebarCart: function() {
//             var cartIcon = $('[data-cart-sidebar]');
//             let checkInitSideBarCart = true;
//             cartIcon.on('click', () => {
//                 if (!checkInitSideBarCart) return
//                 checkInitSideBarCart = false
//                 Shopify.getCart((cart) => {
//                     halo.updateSidebarCart(cart);
//                 })
//                 if ($('body').hasClass('cursor-fixed__show')){
//                     window.sharedFunctionsAnimation.onEnterButton();
//                     window.sharedFunctionsAnimation.onLeaveButton();
//                 }
//             })
//             if ($body.hasClass('template-cart')) {
//                 cartIcon.on('click', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();

//                     $('html, body').animate({
//                         scrollTop: 0
//                     }, 700);
//                 });
//                 if (halo.checkNeedToConvertCurrency()) {
//                   Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                 };
//             } else {
//                 cartIcon.on('click', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();
                    
//                     $body.addClass('cart-sidebar-show');
//                 });
//             }

//             $doc.on('click', '[data-close-cart-sidebar]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 if ($body.hasClass('cart-sidebar-show')) {
//                     $body.removeClass('cart-sidebar-show');
//                 }
//             });

//             $body.on('click', '.background-overlay', (event) => {
//                 if ($body.hasClass('cart-sidebar-show') && !$body.hasClass('quickshop-popup-show') && !$body.hasClass('quick_shop_popup_mobile') && !$body.hasClass('edit-cart-show') && !$body.hasClass('term-condition-show') && !$body.hasClass('has-warning')) {
//                     if (($(event.target).closest('#halo-cart-sidebar').length === 0) && 
//                         ($(event.target).closest('[data-cart-sidebar]').length === 0) && 
//                         ($(event.target).closest('[data-edit-cart-popup]').length === 0) && 
//                         ($(event.target).closest('[data-warning-popup]').length === 0) && 
//                         ($(event.target).closest('[data-term-condition-popup]').length === 0)){
//                         $body.removeClass('cart-sidebar-show');
//                     }
//                 }
//             })
//         },

//         updateSidebarCart: function(cart) {
//             if(!$.isEmptyObject(cart)){
//                 const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
//                 const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
//                         <div class="loading-overlay__spinner">\
//                             <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
//                                 <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
//                             </svg>\
//                         </div>\
//                     </div>';
//                 const loadingClass = 'is-loading';

//                 $cartDropdown
//                     .addClass(loadingClass)
//                     .prepend($cartLoading);

//                 $.ajax({
//                     type: 'GET',
//                     url: window.routes.root + '/cart?view=ajax_side_cart',
//                     cache: false,
//                     success: function (data) {
//                         var response = $(data);

//                         $cartDropdown
//                             .removeClass(loadingClass)
//                             .html(response);

//                         halo.dispatchChangeForShippingMessage();
//                     },
//                     error: function (xhr, text) {
//                         halo.showWarning($.parseJSON(xhr.responseText).description);
//                     },
//                     complete: function () {
//                         $body.find('[data-cart-count]').text(cart.item_count);
//                         if (cart.item_count >= 100){
//                             $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                         }
//                         if (cart.item_count == 1){
//                             $body.find('[data-cart-text]').text(window.cartStrings.item);
//                         } else {
//                             $body.find('[data-cart-text]').text(window.cartStrings.items);
//                         }
//                         halo.productCollectionCartSlider();
//                         halo.updateGiftWrapper();
//                         if (halo.checkNeedToConvertCurrency()) {
//                           Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                         };
//                         document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
//                         if ($('body').hasClass('cursor-fixed__show')){
//                             window.sharedFunctionsAnimation.onEnterButton();
//                             window.sharedFunctionsAnimation.onLeaveButton();
//                         }
//                     }
//                 });
//             }
//         },

//         dispatchChangeForShippingMessage: function() {
//             document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
//                 const changeEvent = new Event('change', { bubbles: true })
//                 freeShippingWrapper.dispatchEvent(changeEvent);
//             })
//         },

//         updateGiftWrapper: function() {
//             let debounce 
//             $('#gift-wrapping').off('click').on('click', (event) => {
//                 event.stopPropagation()
//                 event.preventDefault()
//                 const $target = $(event.currentTarget);
//                 clearTimeout(debounce)
//                 debounce = setTimeout(() => {
//                     const variantId = event.target.dataset.giftId;
//                     Shopify.addItem(variantId, 1, $target, () => {
//                         Shopify.getCart((cart) => {
//                             halo.updateSidebarCart(cart);
//                         });
//                     }); 
//                 }, 250)
//             });

//             $('#cart-gift-wrapping').off('click').on('click', (event) => {
//                 event.stopPropagation()
//                 event.preventDefault()

//                 var $target = $(event.currentTarget),
//                     text = $target.attr('data-adding-text');
//                 $target.text(text);

//                 clearTimeout(debounce)
//                 debounce = setTimeout(() => {
//                     const variantId = event.target.dataset.giftId;
//                     Shopify.addItem(variantId, 1, $target, () => {
//                         Shopify.getCart((cart) => {
//                             halo.updateCart(cart)
//                         });
//                     }); 
//                 }, 250)
//             });
//         },

//         removeItemQuickCart: function () {
//             $doc.on('click', '[data-cart-remove]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.currentTarget),
//                     productId = $target.attr('data-cart-remove-id'),
//                     text = $('#cart-gift-wrapping').attr('data-add-text'),
//                     productLine = $target.data('line'),
//                     index = $target.data('index');

//                 $('#cart-gift-wrapping').text(text);

//                 Shopify.removeItem(productLine, index, (cart) => {
//                     if($body.hasClass('template-cart')){
//                         halo.updateCart(cart);
//                     } else if($body.hasClass('cart-modal-show')){
//                         // halo.updateDropdownCart(cart);
//                     } else if($body.hasClass('cart-sidebar-show')) {
//                         halo.updateSidebarCart(cart);
//                     }
//                 });
//             });
//         },

//         updateCart: function(cart){
//             if(!$.isEmptyObject(cart)){
//                 const $sectionId = $('#main-cart-items').data('id');
//                 const $cart = $('[data-cart]')
//                 const $cartContent = $cart.find('[data-cart-content]');
//                 const $cartTotals = $cart.find('[data-cart-total]');
//                 const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
//                         <div class="loading-overlay__spinner">\
//                             <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
//                                 <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
//                             </svg>\
//                         </div>\
//                     </div>';
//                 const loadingClass = 'is-loading';

//                 $cart
//                     .addClass(loadingClass)
//                     .prepend($cartLoading);

//                 $.ajax({
//                     type: 'GET',
//                     url: `/cart?section_id=${$sectionId}`,
//                     cache: false,
//                     success: function (data) {
//                         var jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
//                         var response = $(jsPreventedData);

//                         $cart.removeClass(loadingClass);
//                         $cart.find('.loading-overlay').remove();

//                         if(cart.item_count > 0){
//                             var contentCart =  response.find('[data-cart-content] .cart').html(),
//                                 subTotal = response.find('[data-cart-total] .cart-total-subtotal').html(),
//                                 grandTotal = response.find('[data-cart-total] .cart-total-grandtotal').html(),
//                                 savings = response.find('[data-cart-total] .cart-total-savings').html();

//                             $cartContent.find('.cart').html(contentCart);
//                             $cartTotals.find('.cart-total-subtotal').html(subTotal);
//                             $cartTotals.find('.cart-total-grandtotal').html(grandTotal);
//                             $cartTotals.find('.cart-total-savings').html(savings);

//                             if(response.find('.haloCalculatorShipping').length > 0){
//                                 var calculatorShipping = response.find('.haloCalculatorShipping');

//                                 $cart.find('.haloCalculatorShipping').replaceWith(calculatorShipping);
//                             }
//                         } else {
//                             var contentCart =  response.find('#main-cart-items').html(),
//                                 headerCart =  response.find('.page-header').html();
//                                 cartCountdownText1 = response.find('.cart-countdown').data('coundown-text-empty-1');
//                                 cartCountdownText2 = response.find('.cart-countdown').data('coundown-text-empty-2');
//                                 cartCountdownProductUrl = response.find('.cart-countdown').data('coundown-prd-empty-url');
//                                 cartCountdownProductTitle = response.find('.cart-countdown').data('coundown-prd-empty-title');
//                             var cartCountdownHtml = cartCountdownText1 + ' <a href="'+ cartCountdownProductUrl +'" class="cart-countdown-product link-effect p-relative"><span class="text">'+ cartCountdownProductTitle +'</span></a> ' + cartCountdownText2;

//                             $('#main-cart-items').html(contentCart);
//                             $('.page-header').html(headerCart);
//                             $('.cart-countdown .text-wrap').html(cartCountdownHtml);
//                         }
//                     },
//                     error: function (xhr, text) {
//                         halo.showWarning($.parseJSON(xhr.responseText).description);
//                     },
//                     complete: function () {
//                         $body.find('[data-cart-count]').text(cart.item_count);
//                         halo.dispatchChangeForShippingMessage();
//                         if (halo.checkNeedToConvertCurrency()) {
//                             Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                         }
//                         if ($body.hasClass('template-cart')) {
//                             const giftWrapping = document.getElementById('cart-gift-wrapping')
//                             const isChecked = giftWrapping?.dataset.isChecked
//                             const variantId = giftWrapping?.dataset.giftId
//                             if (isChecked === 'true') {
//                                 $('#is-a-gift').hide()
//                                 const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
//                                 const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

//                                 giftCardRemoveButton?.addEventListener('click', () => {
//                                     giftWrapping.dataset.isChecked = 'false'
//                                 })

//                                 giftCardQuantityInput?.addEventListener('change', (e) => {
//                                     const value = Number(e.target.value)
//                                     if (value  <= 0) {
//                                         giftWrapping.dataset.isChecked = 'false'
//                                     }
//                                 })
//                             } else {
//                                 $('#is-a-gift').show()
//                             }
//                             if (cart.item_count >= 100){
//                                 $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
//                             }
//                         }
                        
//                         document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
//                     }
//                 });
//             }
//         },

//         updateQuantityItemQuickCart: function(){
//             $doc.on('change', '[data-cart-quantity]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.currentTarget),
//                     productId = $target.attr('data-cart-quantity-id'),
//                     productLine = $target.data('line'),
//                     quantity = parseInt($target.val()),
//                     stock = parseInt($target.data('inventory-quantity')),
//                     index = $target.data('index');
//                 let enoughInStock = true;

//                 if ($target.parents('.quick-order-list__contents').length) return;
               
//                 if (stock < quantity && stock > 0) {
//                   var arrayInVarName = `cart_selling_array_${event.currentTarget.closest('cart-update-quantity').dataset.product}`,
//                     itemInArray = window[arrayInVarName],
//                     itemStatus = itemInArray[event.currentTarget.closest('cart-update-quantity').dataset.variant];
//                   if(itemStatus == 'deny') {
//                     quantity = stock;
//                     enoughInStock = false;
//                   }
//                 }

//                 Shopify.changeItem(productLine, quantity, index, (cart) => {
//                     if($body.hasClass('template-cart')){
//                         halo.updateCart(cart);
//                     } else if($body.hasClass('cart-modal-show')){
//                         // halo.updateDropdownCart(cart);
//                     } else if($body.hasClass('cart-sidebar-show')) {
//                         halo.updateSidebarCart(cart);
//                     }
//                     if (!enoughInStock) halo.showWarning(`${ window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', quantity) }`)
//                 });
//             });
//         },

//         editQuickCart: function() {
//             let checkLoadEC = true; 

//             $doc.on('click', '[data-open-edit-cart]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.currentTarget),
//                     url = $target.data('edit-cart-url'),
//                     itemId = $target.data('edit-cart-id'),
//                     itemLine = $target.data('line'),
//                     itemIndex = $target.data('index'),
//                     quantity = $target.data('edit-cart-quantity'),
//                     option = $target.parents('.previewCartItem').find('previewCartItem-variant').text();

//                 const modal = $('[data-edit-cart-popup]'),
//                     modalContent = modal.find('.halo-popup-content');

//                 if (checkLoadEC) {
//                     checkLoadEC = false;
//                     const $editCart = document.querySelector('.halo-edit-cart-popup');
//                     const urlStyleEC = $editCart.dataset.urlStyleEditCart;
//                     const urlScriptEC = $editCart.dataset.urlScriptEditCart;
    
//                     halo.buildStyleSheet(urlStyleEC, $editCart);
//                     halo.buildScript(urlScriptEC);
//                 }

//                 $.ajax({
//                     type: 'get',
//                     url: url,
//                     cache: false,
//                     dataType: 'html',
//                     beforeSend: function() {
//                         if($body.hasClass('template-cart')){
//                             // halo.showLoading();
//                         }
//                     },
//                     success: function(data) {
//                         modalContent.html(data);
//                         modalContent
//                             .find('[data-template-cart-edit]')
//                             .attr({
//                                 'data-cart-update-id': itemId,
//                                 'data-line': itemLine,
//                                 'data-index': itemIndex
//                             });

//                         var productItem = modalContent.find('.product-edit-item');
//                         productItem.find('input[name="quantity"]').val(quantity);
//                     },
//                     error: function(xhr, text) {
//                         // alert($.parseJSON(xhr.responseText).description);
//                         halo.showWarning($.parseJSON(xhr.responseText).description);
//                         if($body.hasClass('template-cart')){
//                             // halo.hideLoading();
//                         }
//                     },
//                     complete: function () {
//                         $body.addClass('edit-cart-show');

//                         if($body.hasClass('template-cart')){
//                             // halo.hideLoading();
//                         }

//                         if (halo.checkNeedToConvertCurrency()) {
//                             Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                         };

//                         if ($('body').hasClass('cursor-fixed__show')){
//                             window.sharedFunctionsAnimation.onEnterButton();
//                             window.sharedFunctionsAnimation.onLeaveButton();
//                         }
//                     }
//                 });
//             });

//             $doc.on('click', '[data-close-edit-cart]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.removeClass('edit-cart-show');
//             });

//             $doc.on('click', (event) => {
//                 if ($body.hasClass('edit-cart-show')) {
//                     if (($(event.target).closest('[data-edit-cart-popup]').length === 0) && ($(event.target).closest('[data-open-edit-cart]').length === 0)){
//                         $body.removeClass('edit-cart-show');
//                     }
//                 }
//             });

//             halo.addMoreItemEditCart();
//             halo.addAllItemCartEdit();
//         },

//         addMoreItemEditCart: function(){
//             $doc.on('click', '[data-edit-cart-add-more]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var itemWrapper = $('[data-template-cart-edit]'),
//                     currentItem = $(event.target).parents('.product-edit-item'),
//                     count = parseInt(itemWrapper.attr('data-count')),
//                     cloneProduct = currentItem.clone().removeClass('product-edit-itemFirst');
//                     cloneProductId = cloneProduct.attr('id') + count;

//                 cloneProduct.attr('id', cloneProductId);

//                 halo.updateClonedProductAttributes(cloneProduct, count);

//                 cloneProduct.insertAfter(currentItem);

//                 count = count + 1;
//                 itemWrapper.attr('data-count', count);

//                 if ($('body').hasClass('cursor-fixed__show')){
//                     window.sharedFunctionsAnimation.onEnterButton();
//                     window.sharedFunctionsAnimation.onLeaveButton();
//                 }
//             });

//             $doc.on('click', '[data-edit-cart-remove]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var currentItem = $(event.target).parents('.product-edit-item');

//                 currentItem.remove();
//             });
//         },

//         updateClonedProductAttributes: function(product, count){
//             var form = $('.shopify-product-form', product),
//                 formId = form.attr('id'),
//                 newFormId = formId + count;

//             form.attr('id', newFormId);

//             $('.product-form__radio', product).each((index, element) => {
//                 var formInput = $(element),
//                     formLabel = formInput.next(),
//                     id = formLabel.attr('for'),
//                     newId = id + count,
//                     formInputName = formInput.attr('name');

//                 formLabel.attr('for', newId);

//                 formInput.attr({
//                     id: newId,
//                     name: formInputName + count
//                 });
//             });
//         },

//         addAllItemCartEdit: function() {
//             $doc.on('click', '#add-all-to-cart', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.currentTarget),
//                     cartEdit = $('[data-template-cart-edit]'),
//                     product = cartEdit.find('.product-edit-item.isChecked'),
//                     productId = cartEdit.attr('data-cart-update-id'),
//                     productLine = cartEdit.data('line'),
//                     index = cartEdit.data('index');

//                 if(product.length > 0){
//                     $target.addClass('is-loading');

//                     Shopify.removeItem(productLine, index, (cart) => {
//                         if(!$.isEmptyObject(cart)) {
//                             var productHandleQueue = [];

//                             var ajax_caller = function(data) {
//                                 return $.ajax(data);
//                             }

//                             product.each((index, element) => {
//                                 var item = $(element),
//                                     variantId = item.find('input[name="id"]').val(),
//                                     qty = parseInt(item.find('input[name="quantity"]').val());

//                                 productHandleQueue.push(ajax_caller({
//                                     type: 'post',
//                                     url: window.routes.root + '/cart/add.js',
//                                     data: 'quantity=' + qty + '&id=' + variantId,
//                                     dataType: 'json',
//                                     async: false
//                                 }));
//                             });

//                             if(productHandleQueue.length > 0) {
//                                 $.when.apply($, productHandleQueue).done((event) => {
//                                     setTimeout(function(){ 
//                                         $target.removeClass('is-loading');
//                                     }, 1000);

//                                     Shopify.getCart((cart) => {
//                                         $body.removeClass('edit-cart-show');

//                                         if($body.hasClass('template-cart')){
//                                             halo.updateCart(cart);
//                                         } else if($body.hasClass('cart-modal-show')){
//                                             // halo.updateDropdownCart(cart);
//                                         } else if($body.hasClass('cart-sidebar-show')) {
//                                             halo.updateSidebarCart(cart);
//                                         }
//                                     });
//                                 });
//                             }
//                         }
//                     });
//                 } else {
//                     alert(window.variantStrings.addToCart_message);
//                 }
//             });
//         },

//         initNotifyInStock: function() {
//             $doc.on('click', '[data-open-notify-popup]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var $target = $(event.currentTarget);

//                 halo.notifyInStockPopup($target);
//             });

//             $doc.on('click', '[data-close-notify-popup]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.removeClass('notify-me-show');
//                 setTimeout(() => {
//                     $('.halo-notify-popup .form-field').removeClass('hidden')
//                     $('.halo-notify-popup .form-message').addClass('hidden')
//                 }, 700)
//             });

//             $doc.on('click', (event) => {
//                 if($body.hasClass('notify-me-show')){
//                     if (($(event.target).closest('[data-open-notify-popup]').length === 0) && ($(event.target).closest('[data-notify-popup]').length === 0)){
//                         $body.removeClass('notify-me-show');
//                         setTimeout(() => {
//                             $('.halo-notify-popup .form-field').removeClass('hidden')
//                             $('.halo-notify-popup .form-message').addClass('hidden')
//                         }, 700)
//                     }
//                 }
//             });
//         },

//         notifyInStockPopup: function($target){
//             var variant,
//                 product = $target.parents('.product-item'),
//                 title = product.find('.card-title').data('product-title'),
//                 link = window.location.host + product.find('.card-title').data('product-url'),
//                 popup = $('[data-notify-popup]');

//             if($target.hasClass('is-notify-me')){
//                 variant = product.find('.card-swatch .swatch-label.is-active').attr('title');
//             } else {
//                 variant = $target.data('variant-id');
//             }

//             popup.find('.halo-notify-product-title').val($.trim(title));
//             popup.find('.halo-notify-product-link').val(link);

//             if(variant){
//                 popup.find('.halo-notify-product-variant').val(variant);
//             }
//             $body.addClass('notify-me-show');
//         },

//         initAskAnExpert: function(){
//             $doc.on('click', '[data-open-ask-an-expert]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var askAnExpert = $('[data-ask-an-expert-popup]'),
//                     modalContent = askAnExpert.find('.halo-popup-content'),
//                     url;

//                 if($body.hasClass('template-product')){
//                     var handle = $('.productView').data('product-handle');

//                     url = window.routes.root + '/products/' + handle + '?view=ajax_ask_an_expert';
//                 } else if($body.hasClass('quick-view-show')){
//                     var handle = $('.halo-quickView').data('product-quickview-handle');

//                     url = window.routes.root + '/products/' + handle + '?view=ajax_ask_an_expert';
//                 } else {
//                     url = window.routes.root + '/search?view=ajax_ask_an_expert';
//                 }

//                 $.ajax({
//                     type: 'get',
//                     url: url,
//                     beforeSend: function () {
//                         modalContent.empty();
//                     },
//                     success: function (data) {
//                         modalContent.html(data);
//                     },
//                     error: function (xhr, text) {
//                         alert($.parseJSON(xhr.responseText).description);
//                     },
//                     complete: function () {
//                         $body.addClass('ask-an-expert-show');
//                     }
//                 });
//             });

//             $doc.on('click', '[data-close-ask-an-expert]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.removeClass('ask-an-expert-show');
//                 if($body.hasClass('recently-popup-mb-show')){
//                     $body.removeClass('recently-popup-mb-show');
//                 }
//             });

//             $doc.on('click', (event) => {
//                 if($body.hasClass('ask-an-expert-show')){
//                     if (($(event.target).closest('[data-open-ask-an-expert]').length === 0) && ($(event.target).closest('#halo-ask-an-expert-popup').length === 0)){
//                         $body.removeClass('ask-an-expert-show');
//                     }
//                 }
//             });
//         },

//         resetForm: function(form){
//             $('.form-field', form).removeClass('form-field--success form-field--error');
//             $('input[type=email], input[type=text], textarea', form).val('');
//         },

//         formMessage: function() {
//             const error = window.location.href.indexOf('form_type=contact') > -1;

//             if (window.location.href.indexOf('contact_posted=true') > -1 || error) {
//                 const formMessage = $(`[data-form-message="${$.cookie('contact_form')}"]`);
//                 let delay = 400;
                
//                 if ($body.hasClass('template-product')) delay = 1600;
    
//                 switch(formMessage.data('form-message')) {
//                     case 'ask':
//                         setTimeout(() => {$body.addClass('ask-an-expert-show')}, delay)
//                         this.changeStateforContactForm(formMessage, error)
//                         $('.halo-notify-popup .form-message').addClass('hidden')
//                         break;
//                     case 'contact':
//                         formMessage.removeClass('hidden')
//                         this.changeStateforContactForm(formMessage, error)
//                         $('.halo-notify-popup .form-message').addClass('hidden')
//                         break;
//                     case 'notifyMe':
//                         $('.halo-notify-popup .form-field').addClass('hidden')
//                         setTimeout(() => {$body.addClass('notify-me-show')}, delay)
//                         this.changeStateforContactForm(formMessage, error)
//                         break;
//                 }
//             }

//             $(document).on('click', '[data-button-message]', (event) => {
//                 $.cookie('contact_form', $(event.target).data('button-message'), {
//                     expires: 1,
//                     path: '/',
//                 });
//             })
//         },

//         changeStateforContactForm(formMessage, error) {
//             window.history.pushState('object', document.title, location.href.split('?')[0])
//             if (error) {$('.newsletter-form__message--error').addClass('hidden'); $('html, body').animate({scrollTop: formMessage.offset().top - window.innerHeight/2}, 700)}
//         },

//         initCompareProduct: function() {
//             var $compareLink = $('[data-compare-link]');

//             if(window.compare.show){
//                 halo.setLocalStorageProductForCompare($compareLink);
//                 halo.setAddorRemoveProductForCompare($compareLink);
//                 halo.setProductForCompare();

//                 $doc.on('click', '[data-close-compare-product-popup]', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();

//                     $body.removeClass('compare-product-show');
//                 });

//                 $doc.on('click', (event) => {
//                     if($body.hasClass('compare-product-show')){
//                         if (($(event.target).closest('[data-compare-link]').length === 0) && ($(event.target).closest('[data-compare-product-popup]').length === 0)){
//                             $body.removeClass('compare-product-show');
//                         }
//                     }
//                 });
//             }
//         },

//         setLocalStorageProductForCompare: function($link) {
//             var count = JSON.parse(localStorage.getItem('compareItem')),
//                 items = $('[data-product-compare-handle]');

//             if(count !== null){ 
//                 if(items.length > 0) {
//                     items.each((index, element) => {
//                         var item = $(element),
//                             handle = item.data('product-compare-handle');

//                         if(count.indexOf(handle) >= 0) {
//                             item.find('.compare-icon').addClass('is-checked');
//                             item.find('.text').text(window.compare.added);
//                             item.find('input').prop('checked', true);
//                         } else {
//                             item.find('.compare-icon').removeClass('is-checked');
//                             item.find('.text').text(window.compare.add);
//                             item.find('input').prop('checked', false);
//                         }
//                     });

//                     halo.updateCounterCompare($link);
//                 }
//             }
//         },

//         setAddorRemoveProductForCompare: function($link) {
//             $doc.on('change', '[data-product-compare] input', (event) => {
//                 var $this = $(event.currentTarget),
//                     item = $this.parents('.card-compare'),
//                     handle = $this.val(),
//                     count = JSON.parse(localStorage.getItem('compareItem'));

//                 count = halo.uniqueArray(count);

//                 if(event.currentTarget.checked) {
//                     item.find('.compare-icon').addClass('is-checked');
//                     item.find('.text').text(window.compare.added);
//                     item.find('input').prop('checked', true);
//                     halo.incrementCounterCompare(count, handle, $link);
//                 } else {
//                     item.find('.compare-icon').removeClass('is-checked');
//                     item.find('.text').text(window.compare.add);
//                     item.find('input').prop('checked', false);
//                     halo.decrementCounterCompare(count, handle, $link);
//                 }
//             });
//         },

//         setProductForCompare: function() {
//             $doc.on('click', '[data-compare-link]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var list = JSON.parse(localStorage.getItem('compareItem'));

//                 if (list.length <= 1) {
//                     alert(window.compare.message);

//                     return false;
//                 } else {
//                     halo.updateContentCompareProduct(list, 0);
//                 }
//             });

//             $doc.on('click', '[data-compare-remove]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var id = $(event.currentTarget).data('compare-item'),
//                     compareTable = $('[data-compare-product-popup] .compareTable'),
//                     item = compareTable.find('.compareTable-row[data-product-compare-id="'+ id +'"]'),
//                     handle = item.data('compare-product-handle');

//                 if(compareTable.find('tbody .compareTable-row').length == 1){
//                     // alert(window.compare.message);
//                     item.remove();
//                     var count = JSON.parse(localStorage.getItem('compareItem')),
//                         index = count.indexOf(handle),
//                         $compareLink = $('[data-compare-link]');

//                     if (index > -1) {
//                         count.splice(index, 1);
//                         count = halo.uniqueArray(count);
//                         localStorage.setItem('compareItem', JSON.stringify(count));

//                         halo.setLocalStorageProductForCompare($compareLink);
//                         halo.updateCounterCompare($compareLink);
//                     }

//                     $body.removeClass('compare-product-show');
//                 } else {
//                     item.remove();
                    
//                     var count = JSON.parse(localStorage.getItem('compareItem')),
//                         index = count.indexOf(handle),
//                         $compareLink = $('[data-compare-link]');

//                     if (index > -1) {
//                         count.splice(index, 1);
//                         count = halo.uniqueArray(count);
//                         localStorage.setItem('compareItem', JSON.stringify(count));

//                         halo.setLocalStorageProductForCompare($compareLink);
//                         halo.updateCounterCompare($compareLink);
//                     }
//                 }
//             });
//         },

//         updateCounterCompare: function($link) {
//             var count = JSON.parse(localStorage.getItem('compareItem'));

//             if (count.length > 1) {
//                 $link.parent().addClass('is-show');
//                 $link.find('span.countPill').html(count.length);
//             } else {
//                 $link.parent().removeClass('is-show');
//             }
//         },

//         uniqueArray: function(list) {
//             var result = [];

//             $.each(list, function(index, element) {
//                 if ($.inArray(element, result) == -1) {
//                     result.push(element);
//                 }
//             });

//             return result;
//         },

//         incrementCounterCompare: function(count, item, $link){
//             const index = count.indexOf(item);

//             count.push(item);
//             count = halo.uniqueArray(count);

//             localStorage.setItem('compareItem', JSON.stringify(count));

//             halo.updateCounterCompare($link);
//         },

//         decrementCounterCompare: function(count, item, $link){
//             const index = count.indexOf(item);

//             if (index > -1) {
//                 count.splice(index, 1);
//                 count = halo.uniqueArray(count);
//                 localStorage.setItem('compareItem', JSON.stringify(count));

//                 halo.updateCounterCompare($link);
//             }
//         },

//         updateContentCompareProduct: function(list, count){
//             const compareTable = $('[data-compare-product-popup] .compareTable'),
//                 url = window.routes.root + '/products/' + list[count] + '?view=ajax_product_card_compare';

//             if (count == 0) compareTable.find('tbody').empty();

//             if (list.length > count) {
//                 $.ajax({
//                     type: 'get',
//                     url: url,
//                     cache: false,
//                     success: function (data) {
//                         compareTable.find('tbody').append(data);
//                         count++;
//                         halo.updateContentCompareProduct(list, count);
//                     }
//                 });
//             } else {
//                 $body.addClass('compare-product-show');
//             }

//             if ($('body').hasClass('cursor-fixed__show')){
//                 window.sharedFunctionsAnimation.onEnterButton();
//                 window.sharedFunctionsAnimation.onLeaveButton();
//             }
//         },

//         initProductView: function($scope){
//             halo.productImageGallery($scope);
//             halo.productLastSoldOut($scope);
//             halo.productCustomerViewing($scope);
//             halo.productCountdown($scope);
//             halo.productSizeChart($scope);
//             halo.productCustomCursor($scope);
//             halo.productVideoGallery($scope);
//             halo.initVariantImageGroup($scope, window.variant_image_group);
//         },

//         initQuickView: function(){
//             let checkLoadQV = true;

//             $doc.on('click', '[data-open-quick-view-popup]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 if (checkLoadQV) {
//                     checkLoadQV = false;
//                     const $quickView = document.querySelector('.halo-quick-view-popup');
//                     const urlStyleProduct = $quickView.dataset.urlStyleProduct;
//                     const urlStyleQV = $quickView.dataset.urlStyleQuickView;
//                     const urlVariantsQV = $quickView.dataset.urlVariantsQuickView;
//                     const urlSortable = 'https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js';

//                     if (!document.body.matches('.qs3-loaded')) halo.buildStyleSheet(urlStyleProduct, $quickView);
//                     halo.buildStyleSheet(urlStyleQV, $quickView);
//                     halo.buildScript(urlVariantsQV);
//                     document.body.classList.add('qv-loaded');
//                     if (!document.body.matches('.sortable-loader')) {
//                         document.body.classList.add('sortable-loader');
//                         halo.buildScript(urlSortable);
//                     }
//                 }

//                 var handle = $(event.currentTarget).data('product-handle');

//                 halo.updateContentQuickView(handle);
//             });

//             $doc.on('click', '[data-close-quick-view-popup]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.removeClass('quick-view-show');
//             });
            
//             $('.background-overlay').off('click.closeQuickView').on('click.closeQuickView', e => {
//                 if ($body.hasClass('quick-view-show') &&
//                        !$body.hasClass('cart-sidebar-show') && 
//                        !$body.hasClass('ask-an-expert-show') && 
//                        !$body.hasClass('size-chart-show') && 
//                        !$body.hasClass('compare-color-show') && 
//                        !$body.hasClass('term-condition-show')
//                    ) {
//                     $body.removeClass('quick-view-show');
//                 }
//             });
//         },

//         updateContentQuickView: function(handle){
//             var popup = $('[data-quick-view-popup]'),
//                 popupContent = popup.find('.halo-popup-content');

//             $.ajax({
//                 type: 'get',
//                 url: window.routes.root + '/products/' + handle + '?view=ajax_quick_view',
//                 beforeSend: function () {
//                     popupContent.empty();
//                     $('#halo-quickshop-popup-option-3').find('.halo-popup-content').empty()
//                 },
//                 success: function (data) {
//                     popupContent.html(data);
//                 },
//                 error: function (xhr, text) {
//                     alert($.parseJSON(xhr.responseText).description);
//                 },
//                 complete: function () {
//                     var $scope = popup.find('.quickView');
//                     const items = $('.halo-popup-content .halo-compare-color-popup li.item'),
//                         tableList = $('.halo-popup-content .halo-compare-color-popup #sortTableList'),
//                         compareColorPopup = $('.halo-popup-content .halo-compare-color-popup'),
//                         sizeChartPopup = $('.halo-popup-content .halo-size-chart-popup');
                    
//                     halo.productImageGallery($scope);
//                     halo.productLastSoldOut($scope);
//                     halo.productCustomerViewing($scope);
//                     halo.productCountdown($scope);
//                     halo.productSizeChart($scope);
//                     halo.setProductForWishlist(handle);
//                     halo.initVariantImageGroup($scope, window.variant_image_group_quick_view);

//                     $body.addClass('quick-view-show');

//                     if (window.Shopify && Shopify.PaymentButton) {
//                         Shopify.PaymentButton.init();
//                     }

//                     tableList.attr('id', 'quickViewSortTableList');

//                     items.each((index, element) => {
//                         const itemInput = $(element).find('.swatch-compare-color-option'),
//                             itemLabel = $(element).find('.swatch-compare-color-label'),
//                             itemId = itemInput.attr('id');

//                         itemInput
//                             .attr('id', `quickView-${itemId}`)
//                             .attr('name', `quickView-${itemId}`);
//                         itemLabel.attr('for', `quickView-${itemId}`);
//                     });

//                     compareColorPopup.attr('id', 'quickView-halo-compare-color-popup');
//                     sizeChartPopup.attr('id', 'quickView-halo-size-chart-popup');

//                     if ($('.halo-productView .addthis_inline_share_toolbox').length) {
//                         var html = $('.halo-productView .addthis_inline_share_toolbox').html();

//                         $('.halo-popup-content .share-button__button').click(function(){
//                             $('.halo-popup-content .addthis_inline_share_toolbox').append(html);
//                         });
//                     }

//                     const thisSortTable = document.getElementById('quickViewSortTableList');
//                     const thisImageList = $('.halo-popup-content .halo-compareColors-image');

//                     if (window.innerWidth >= 1025 && thisSortTable) {
//                         new Sortable(thisSortTable, {
//                             animation: 150
//                         });
//                     } else {
//                         onRemoveHandlerQuickView();
//                     }

//                     function onRemoveHandlerQuickView(){
//                         thisImageList.on('click', '.item', (event) => {
//                             event.preventDefault();

//                             var $target = event.currentTarget,
//                                 itemId = $target.classList[1].replace('item-', ''),
//                                 optionId = `swatch-compare-color-${itemId}`,
//                                 item = $(document.getElementById(optionId));

//                             item.trigger('click');
//                         });
//                     }

//                     if ($('body').hasClass('cursor-fixed__show')){
//                         window.sharedFunctionsAnimation.onEnterButton();
//                         window.sharedFunctionsAnimation.onLeaveButton();
//                     }
//                 }
//             });
//         },

//         productImageGallery: function($scope) {
//             var sliderNav = $scope.find('.productView-nav'),
//                 sliderFor = $scope.find('.productView-for:not(".mobile")'),
//                 sliderForMobile = $scope.find('.productView-for.mobile');

//             if(!sliderFor.hasClass('slick-initialized') && !sliderNav.hasClass('slick-initialized')) {
//                 const navArrowsDesk = sliderNav.data('arrows-desk'),
//                     navArrowsMobi = sliderNav.data('arrows-mobi'),
//                     navCounterMobi = sliderNav.data('counter-mobi'),
//                     navMediaCount = sliderNav.data('media-count'),
//                     thumbnailToShow = parseInt(sliderFor.data('max-thumbnail-to-show'));
                
//                 let checkNav, checkFor, navSlideCount;

//                 var appendTimeout;

//                 sliderNavHTML = sliderNav.html();

//                 sliderNav.hasClass('productView-nav-gallery') ? navSlideCount = Math.round(navMediaCount / 2) : navSlideCount = navMediaCount;
//                 sliderNav.hasClass('productView-horizontal-tabs') && navMediaCount == 2 ? navSlideCount = 1 : navSlideCount = navMediaCount;
//                 let slickCounter = `<div class="slick-counter">
//                     <span class="slick-counter--current">1</span>
//                     <span aria-hidden="true">/</span>
//                     <span class="slick-counter--total">`+ navSlideCount + `</span>
//                 </div>`;

//                 const getSlickCounter = () => {
//                     setTimeout(() => {
//                         let countSlide = $('.productView-nav .slick-slide').length;
//                         if (sliderNav.hasClass('productView-nav-gallery')) countSlide = Math.round(countSlide / 2);
//                         slickCounter = `<div class="slick-counter">
//                             <span class="slick-counter--current">1</span>
//                             <span aria-hidden="true">/</span>
//                             <span class="slick-counter--total">`+ countSlide + `</span>
//                         </div>`;
//                     }, 1000);
//                 }

//                 const setSlickCounter = () => {
//                     clearTimeout(appendTimeout);
//                     appendTimeout = setTimeout(() => {sliderNav.append(slickCounter)}, 1000);
//                 }

//                 sliderNav.on('init', () => {
//                     if (window.innerWidth < 768 && navCounterMobi) {
//                         if (variant_image_group) getSlickCounter();
//                         setSlickCounter();
//                         sliderNav.on('reInit afterChange', function (event, slick, currentSlide, nextSlide) {
//                             var i = (currentSlide ? currentSlide : 0) + 1;
//                             sliderNav.find('.slick-counter--current').text(i);
//                         });
//                     }
//                 });

//                 sliderNav.on('reInit', () => {
//                     if (window.innerWidth < 768 && navCounterMobi) {
//                         if (variant_image_group) getSlickCounter();
//                         setSlickCounter();
//                     }
//                 });

//                 sliderNav.closest('.productView').is('.layout-4') ? checkFor = false : checkFor = sliderFor;

//                 if(sliderNav.hasClass('productView-nav-gallery')) {
//                     var sliderNav2 = $scope.find('.productView-nav.productView-nav-gallery'),
//                         length = sliderNav2.data('media-count'),
//                         oneItems = sliderNav2.data('1-item-mobi'),
//                         show = 2,
//                         rows = 2;

//                     if (length == 1) {
//                       show = 1;
//                       rows = 1;
//                     }
//                     if (length == 2) {
//                       show = 2;
//                       rows = 1;
//                     }

//                     if (oneItems && window.innerWidth < 551) {
//                         show = 1;
//                         rows = 1;
//                     }

//                     sliderNav2.slick({
//                         dots: true,
//                         rows: rows,
//                         arrows: navArrowsDesk,
//                         infinite: true,
//                         slidesPerRow: 1,
//                         slidesToShow: show,
//                         focusOnSelect: false,
//                         asNavFor: checkFor,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: [
//                             {
//                                 breakpoint: 767,
//                                 settings: {
//                                     arrows: navArrowsMobi
//                                 }
//                             }
//                         ]
//                     });
//                     checkNav = sliderNav2;
//                 } else if(sliderNav.hasClass('productView-horizontal-tabs')) {
//                     var sliderNav2 = $scope.find('.productView-nav.productView-horizontal-tabs'),
//                         show = 2,
//                         rows = 1;

//                     sliderNav2.slick({
//                         dots: true,
//                         rows: rows,
//                         arrows: navArrowsDesk,
//                         infinite: false,
//                         slidesPerRow: 1,
//                         slidesToShow: 2,
//                         focusOnSelect: false,
//                         asNavFor: checkFor,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: [
//                             {
//                                 breakpoint: 767,
//                                 settings: {
//                                     arrows: navArrowsMobi,
//                                     get slidesToShow() {
//                                         if(sliderNav2.parents('.product-details').hasClass('featured-product')) {
//                                             return this.slidesToShow = 1;
//                                         } else {
//                                             return this.slidesToShow = 2;
//                                         }
//                                     }
//                                 }
//                             }
//                         ]
//                     });
//                     checkNav = sliderNav2;
//                 } else {
//                     if (!sliderNav.is('.style-2, .style-3') || window.innerWidth < 768) {
//                         sliderNav.slick({
//                             fade: true,
//                             dots: false,
//                             arrows: navArrowsDesk,
//                             infinite: true,
//                             slidesToShow: 1,
//                             slidesToScroll: 1,
//                             asNavFor: checkFor,
//                             nextArrow: window.arrows.icon_next,
//                             prevArrow: window.arrows.icon_prev,
//                             rtl: window.rtl_slick,
//                             responsive: [
//                                 {
//                                     breakpoint: 768,
//                                     settings: {
//                                         arrows: navArrowsMobi
//                                     }
//                                 }
//                             ]
//                         }); 
//                         checkNav = sliderNav;
//                     }
//                     else {
//                         checkNav = false;
//                     }
//                 }

//                 if($scope.hasClass('layout-1') || $scope.hasClass('layout-2')){
//                     sliderFor.on('init',(event, slick) => {
//                         sliderFor.find('.animated-loading').removeClass('animated-loading');
//                     });

//                     if( $body.hasClass('safari') && (window.innerWidth != document.querySelector('body').clientWidth)){
//                         sliderFor.slick({
//                             slidesToShow: thumbnailToShow,
//                             slidesToScroll: 1,
//                             asNavFor: checkNav,
//                             arrows: true,
//                             dots: false,
//                             draggable: false,
//                             adaptiveHeight: false,
//                             focusOnSelect: true,
//                             vertical: true,
//                             verticalSwiping: true,
//                             infinite: true,
//                             nextArrow: window.arrows.icon_next,
//                             prevArrow: window.arrows.icon_prev,
//                             responsive: [
//                                 {
//                                     breakpoint: 1601,
//                                     settings: {
//                                         slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
//                                         vertical: true,
//                                         verticalSwiping: true,
//                                         slidesToScroll: 1
//                                     }
//                                 },
//                                 {
//                                     breakpoint: 1281,
//                                     settings: {
//                                         vertical: false,
//                                         verticalSwiping: false,
//                                         rtl: window.rtl_slick,
//                                     }
//                                 },
//                                 {
//                                     breakpoint: 768,
//                                     settings: {
//                                         slidesToShow: 3,
//                                         slidesToScroll: 1,
//                                         vertical: false,
//                                         verticalSwiping: false,
//                                         rtl: window.rtl_slick,
//                                     }
//                                 }
//                             ]
//                         });
//                     } else{
//                         sliderFor.slick({
//                             slidesToShow: thumbnailToShow,
//                             slidesToScroll: 1,
//                             asNavFor: checkNav,
//                             arrows: true,
//                             dots: false,
//                             draggable: false,
//                             adaptiveHeight: false,
//                             focusOnSelect: true,
//                             vertical: true,
//                             verticalSwiping: true,
//                             infinite: true,
//                             nextArrow: window.arrows.icon_next,
//                             prevArrow: window.arrows.icon_prev,
//                             responsive: [
//                                 {
//                                     breakpoint: 1600,
//                                     settings: {
//                                         slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
//                                         slidesToScroll: 1
//                                     }
//                                 },
//                                 {
//                                     breakpoint: 1280,
//                                     settings: {
//                                         vertical: false,
//                                         verticalSwiping: false,
//                                         rtl: window.rtl_slick,
//                                     }
//                                 },
//                                 {
//                                     breakpoint: 767,
//                                     settings: {
//                                         slidesToShow: 3,
//                                         slidesToScroll: 1,
//                                         vertical: false,
//                                         verticalSwiping: false,
//                                         rtl: window.rtl_slick,
//                                     }
//                                 }
//                             ]
//                         });
//                     }
//                 } else if($scope.hasClass('layout-3')){
//                     sliderFor.on('init',(event, slick) => {
//                         sliderFor.find('.animated-loading').removeClass('animated-loading');
//                     });

//                     sliderFor.slick({
//                         slidesToShow: thumbnailToShow,
//                         slidesToScroll: 1,
//                         asNavFor: checkNav,
//                         arrows: true,
//                         dots: false,
//                         focusOnSelect: true,
//                         infinite: true,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: [
//                             {
//                                 breakpoint: 1600,
//                                 settings: {
//                                     slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
//                                     slidesToScroll: 1
//                                 }
//                             },
//                             {
//                                 breakpoint: 767,
//                                 settings: {
//                                     slidesToShow: 3,
//                                     slidesToScroll: 1
//                                 }
//                             }
//                         ]
//                     });
//                 }

//                 sliderForMobile.on('init',(event, slick) => {
//                     sliderForMobile.find('.animated-loading').removeClass('animated-loading');
//                 });

//                 sliderForMobile.slick({
//                     slidesToShow:  parseInt(sliderForMobile.data('max-thumbnail-to-show')),
//                     slidesToScroll: 1,
//                     asNavFor: checkNav,
//                     arrows: true,
//                     dots: false,
//                     draggable: false,
//                     adaptiveHeight: false,
//                     focusOnSelect: true,
//                     vertical: true,
//                     verticalSwiping: true,
//                     infinite: true,
//                     nextArrow: window.arrows.icon_next,
//                     prevArrow: window.arrows.icon_prev,
//                     rtl: window.rtl_slick,
//                     responsive: [
//                         {
//                             breakpoint: 1600,
//                             settings: {
//                                 slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
//                                 slidesToScroll: 1
//                             }
//                         },
//                         {
//                             breakpoint: 1280,
//                             settings: {
//                                 vertical: false,
//                                 verticalSwiping: false
//                             }
//                         },
//                         {
//                             breakpoint: 767,
//                             settings: {
//                                 slidesToShow: 2.2,
//                                 slidesToScroll: 1,
//                                 vertical: false,
//                                 verticalSwiping: false
//                             }
//                         }
//                     ]
//                 });

//                 if (sliderNav.find('[data-youtube]').length > 0) {
//                     if (typeof window.onYouTubeIframeAPIReady === 'undefined') {
//                         window.onYouTubeIframeAPIReady = halo.initYoutubeCarousel.bind(window, sliderNav);

//                         const tag = document.createElement('script');
//                         tag.src = 'https://www.youtube.com/player_api';
//                         const firstScriptTag = document.getElementsByTagName('script')[0];
//                         firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
//                     } else {
//                         halo.initYoutubeCarousel(sliderNav);
//                     }
//                 }

//                 if (sliderNav.find('[data-vimeo]').length > 0) {
//                     sliderNav.on('beforeChange', (event, slick) => {
//                         var currentSlide,
//                             player,
//                             command;

//                         currentSlide = $(slick.$slider).find('.slick-current');
//                         player = currentSlide.find('iframe').get(0);

//                         command = {
//                             'method': 'pause',
//                             'value': 'true'
//                         };

//                         if (player != undefined) {
//                             player.contentWindow.postMessage(JSON.stringify(command), '*');
//                         }
//                     });

//                     sliderNav.on('afterChange', (event, slick) => {
//                         var currentSlide,
//                             player,
//                             command;

//                         currentSlide = $(slick.$slider).find('.slick-current');
//                         player = currentSlide.find('iframe').get(0);

//                         command = {
//                             'method': 'play',
//                             'value': 'true'
//                         };

//                         if (player != undefined) {
//                             player.contentWindow.postMessage(JSON.stringify(command), '*');
//                         }
//                     });
//                 }

//                 if (sliderNav.find('[data-mp4]').length > 0) {
//                     sliderNav.on('beforeChange', (event, slick) => {
//                         var currentSlide,
//                             player;

//                         currentSlide = $(slick.$slider).find('.slick-current');
//                         player = currentSlide.find('video').get(0);

//                         if (player != undefined) {
//                             player.pause();
//                         }
//                     });

//                     sliderNav.on('afterChange', (event, slick) => {
//                         var currentSlide,
//                             player;

//                         currentSlide = $(slick.$slider).find('.slick-current');
//                         player = currentSlide.find('video').get(0);

//                         if (player != undefined) {
//                             player.play();
//                         }
//                     });
//                 }
//             }

//             var productFancybox = $scope.find('[data-fancybox]');

//             if(productFancybox.length > 0){
//                 productFancybox.fancybox({
//                     buttons: [
//                         "zoom",
//                         "share",
//                         "slideShow",
//                         "fullScreen",
//                         //"download",
//                         "thumbs",
//                         "close"
//                     ],
//                     loop : true,
//                     thumbs : {
//                         autoStart : true,
//                     }
//                 });
//             }

//             // if($body.hasClass('template-product')) {
//                 // if ($scope.closest('.quickView').length) return;
//                 var productZoom = $scope.find('[data-zoom-image]');

//                 if ($win.width() > 1024) {
//                     productZoom.each((index, element) => {
//                         var $this = $(element);
                        
//                         if ($win.width() > 1024) {
//                             $this.zoom({ url: $this.attr('data-zoom-image'), touch: false });
//                         } else {
//                             $this.trigger('zoom.destroy');
//                         }
//                     });
//                 }
//             // }

//             $win.on('resize', () => {
//                 if($scope.hasClass('layout-1') || $scope.hasClass('layout-2')){
//                     if ($win.width() > 1279) {
//                         setTimeout(() => {
//                             if (sliderFor.find('.slick-arrow').length > 0) {
//                                 var height_for = sliderFor.outerHeight(),
//                                     height_nav = sliderNav.outerHeight(),
//                                     pos = (height_nav - height_for)/2;

//                                 sliderFor.parent().addClass('arrows-visible');
//                                 sliderFor.parent().css('top', pos);
//                             } else {
//                                 sliderFor.parent().addClass('arrows-disable');
//                             }
//                         }, 200);
//                     } else {
//                         setTimeout(() => {
//                             if (sliderFor.find('.slick-arrow').length > 0) {
//                                 sliderFor.parent().css('top', 'unset');
//                             }
//                         }, 200);
//                     }
//                 }
//             });
//         },

//         productVideoGallery: function($scope) {
//             const videoThumbnail = $scope.find('[data-video-thumbnail]'),
//                 videoThumbnailLen = videoThumbnail.length,
//                 productVideoLen = $('.productView-video').length;

//             if (videoThumbnailLen) {
//                 const $imageWrapper = $scope.find('.productView-image-wrapper'),
//                     videoModal = $('[data-popup-video]'),
//                     sliderNav = $scope.find('.productView-nav');
//                 let offsetTop = $imageWrapper.offset().top + $imageWrapper.outerHeight();

//                 if (productVideoLen) {
//                     $body.addClass('has-product-video');
//                 }
                
//                 $win.on('scroll', (event) => {
//                     const $targetCur = $(event.currentTarget),
//                         thisVideo = $scope.find('.slick-current .productView-video'),
//                         videoType = thisVideo.data('type'),
//                         videoUrl = thisVideo.data('video-url');

//                     if (videoUrl != undefined) {
//                         if ($targetCur.scrollTop() > offsetTop) {
//                             if (!videoModal.is('.is-show')) {
//                                 const player = sliderNav.find('.slick-slide.slick-active').data('youtube-player'),
//                                     dataTime = parseInt(player.getCurrentTime()),
//                                     videoContent = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">
//                                                     ${videoType == 'youtube' ? 
//                                                         `<iframe
//                                                             id="player"
//                                                             type="text/html"
//                                                             width="100%"
//                                                             frameborder="0"
//                                                             webkitAllowFullScreen
//                                                             mozallowfullscreen
//                                                             allowFullScreen
//                                                             src="https://www.youtube.com/embed/${videoUrl}?autoplay=1&mute=1&start=${dataTime}">
//                                                         </iframe>`
//                                                         :
//                                                         `<iframe 
//                                                             src="https://player.vimeo.com/video/${videoUrl}?autoplay=1&mute=1" 
//                                                             class="js-vimeo" 
//                                                             allow="autoplay; 
//                                                             encrypted-media" 
//                                                             webkitallowfullscreen 
//                                                             mozallowfullscreen 
//                                                             allowfullscreen">
//                                                         </iframe>`
//                                                     }
//                                                 </div>`;
//                                 videoModal.addClass('is-show');
//                                 videoModal.find('.halo-popup-content').html(videoContent);
//                                 $body.addClass('video-show product-video-show');
//                                 player.pauseVideo();
//                             }
//                         } else {
//                             const player = sliderNav.find('.slick-slide.slick-active').data('youtube-player');
//                             videoModal.removeClass('is-show');
//                             videoModal.find('.halo-popup-content').empty();
//                             $body.removeClass('video-show product-video-show');
//                             player.playVideo();
//                         }
//                     }
//                 });
//             }
//         },

//         initVariantImageGroup: function($scope, enable = false) {
//             if(enable){
//                 var inputChecked = $scope.find('[data-filter]:checked'),
//                 sliderFor = $scope.find('.productView-for'),
//                 sliderNav = $scope.find('.productView-nav'),
//                 productOption = $scope.find('.productView-product .productView-options'),
//                 metafields = $scope.find('[data-filter]:checked').data('metafields-vig'),
//                 pageLayout;

//                 switch (true) {
//                     case sliderNav.hasClass('productView-nav-gallery'):
//                         pageLayout = 'gallery';
//                         break;
//                     case sliderNav.closest('.product-full-width').length == 1 || sliderNav.closest('.product-full-width-2').length == 1:
//                         pageLayout = 'full-width';
//                         break;
//                     default:
//                         pageLayout = 'default';
//                 }

//                 const unFilter = () => {
//                     sliderFor.slick('slickUnfilter');
//                     if (pageLayout == 'full-width' && window.innerWidth > 767) return;
//                     if (sliderNav.hasClass('slick-filter')) sliderNav.find('.slick-counter').remove();
//                     sliderNav.slick('slickUnfilter').removeClass('slick-filter');
//                 }

//                 const filter = (list) => {
//                     switch (pageLayout) {
//                         case 'gallery':
//                             sliderNav
//                                 .slick('unslick')
//                                 .empty()
//                                 .html(sliderNavHTML)
//                                 .find('.productView-image').each(function() {
//                                     if (!$(this).is(list)) $(this).remove();
//                                 });

//                             const navArrowsDesk = sliderNav.data('arrows-desk'),
//                                 navArrowsMobi = sliderNav.data('arrows-mobi'),
//                                 length = sliderNav.data('media-count'),
//                                 oneItems = sliderNav.data('1-item-mobi'),
//                                 show = 2,
//                                 rows = 2;

//                             if (length == 1) {
//                                 show = 1;
//                                 rows = 1;
//                             }

//                             if (length == 2) {
//                                 show = 2;
//                                 rows = 1;
//                             }

//                             if (oneItems && window.innerWidth < 551) {
//                                 show = 1;
//                                 rows = 1;
//                             }

//                             sliderNav.slick({
//                                 dots: true,
//                                 rows: rows,
//                                 arrows: navArrowsDesk,
//                                 infinite: true,
//                                 slidesPerRow: 1,
//                                 slidesToShow: show,
//                                 focusOnSelect: false,
//                                 asNavFor: sliderFor,
//                                 nextArrow: window.arrows.icon_next,
//                                 prevArrow: window.arrows.icon_prev,
//                                 rtl: window.rtl_slick,
//                                 responsive: [
//                                     {
//                                         breakpoint: 767,
//                                         settings: {
//                                             arrows: navArrowsMobi
//                                         }
//                                     }
//                                 ]
//                             });
//                             if ($('.cursor-wrapper').length) halo.productCustomCursor($('.halo-productView'));
//                             break;
//                         case 'full-width':
//                             if (window.innerWidth > 767) {
//                                 let dataIndex = 1, checkList = 0;

//                                 sliderNav
//                                     .empty()
//                                     .html(sliderNavHTML);

//                                 if (sliderNavHTML.length) {
//                                     list.split(',').forEach(element => {if (sliderNavHTML.includes(element.replace(/\./g,''))) checkList++});
//                                     if (checkList == 0) {
//                                         sliderNav.removeClass('media-filter');
//                                     } else {
//                                         sliderNav.addClass('media-filter');
//                                         sliderNav.find('.productView-image').each(function() {
//                                             if (!$(this).is(list)) {
//                                                 $(this).remove();
//                                             } else {
//                                                 $(this).attr('data-index', dataIndex);
//                                                 $(this).find('img').attr('data-index', dataIndex);
//                                                 dataIndex++;
//                                             }
//                                         });
//                                     }
//                                 }

//                                 if ($('.cursor-wrapper').length) {
//                                     $('.cursor-wrapper .counter-total').text(sliderNav.find('.productView-image').length);
//                                     halo.productCustomCursor($('.halo-productView'));
//                                 }
//                             }
//                             break;
//                         default:
//                             sliderNav
//                                 .slick('slickFilter', list)
//                                 .slick('refresh')
//                                 .addClass('slick-filter');
//                     }
//                     if (sliderFor) sliderFor.slick('slickFilter', list).slick('refresh');
//                 }

//                 const setImageForMetafields = (list, unfilter) => {
//                     let array = list.split(','),
//                         slidesToKeep = [];
                    
//                     array.forEach(element => {
//                         slidesToKeep.push(`.filter-${element.toLowerCase().replace(/[^A-Z0-9]/ig, '-')}`);
//                     });
                    
//                     if (unfilter) unFilter();
//                     filter(slidesToKeep.join(','));
//                 }

//                 const setImage = (className, input) => {
//                     if (productOption.data('lang') != productOption.data('default-lang') && input.data('value-default-lang')) className = `.filter-${input.data('value-default-lang')}`;
//                     unFilter();
//                     if(className !== undefined) {
//                         if (sliderNav.find(className).length || sliderFor.find(className).length || pageLayout == 'full-width') filter(className);
//                     }
//                 }

//                 if(inputChecked.length > 0) {
//                     let className = inputChecked.data('filter');
//                     metafields && metafields.length ? setImageForMetafields(metafields, false) : setImage(className, inputChecked);
//                 }

//                 $doc.on('change', 'input[data-filter]', (event) => {
//                     let className = $(event.currentTarget).data('filter'),
//                     thisMetafields = $(event.currentTarget).data('metafields-vig');
//                     thisMetafields && thisMetafields.length ? setImageForMetafields(thisMetafields, true) : setImage(className, $(event.currentTarget));
//                 });
//             }
//         },

//         initYoutubeCarousel: function(slider) {
//             slider.each((index, slick) => {
//                 const $slick = $(slick);

//                 if ($slick.find('[data-youtube]').length > 0) {
//                     $slick.addClass('slick-slider--video');

//                     halo.initYoutubeCarouselEvent(slick);
//                 }
//             });
//         },

//         initYoutubeCarouselEvent: function(slick){
//             var $slick = $(slick),
//                 $videos = $slick.find('[data-youtube]');

//             bindEvents(slick);

//             function bindEvents() {
//                 if ($slick.hasClass('slick-initialized')) {
//                     onSlickImageInit($slick, $videos);
//                 }

//                 $doc.on('init', $slick, onSlickImageInit);
//                 $doc.on('beforeChange', $slick, onSlickImageBeforeChange);
//                 $doc.on('afterChange', $slick, onSlickImageAfterChange);
//             }

//             function onPlayerReady(event) {
//                 $(event.target.getIframe()).closest('.slick-slide').data('youtube-player', event.target);

//                 setTimeout(function(){
//                     if ($(event.target.getIframe()).closest('.slick-slide').hasClass('slick-active')) {
//                         $slick.slick('slickPause');
//                         event.target.playVideo();
//                     }
//                 }, 200);
//             }

//             function onPlayerStateChange(event) {
//                 if (event.data === YT.PlayerState.PLAYING) {
//                     $slick.slick('slickPause');
//                 }

//                 if (event.data === YT.PlayerState.ENDED) {
//                     $slick.slick('slickNext');
//                 }
//             }

//             function onSlickImageInit() {
//                 $videos.each((j, vid) => {
//                     const $vid = $(vid);
//                     const id = `youtube_player_${Math.floor(Math.random() * 100)}`;

//                     $vid.attr('id', id);

//                     const player = new YT.Player(id, {
//                         host: 'http://www.youtube.com',
//                         videoId: $vid.data('youtube'),
//                         wmode: 'transparent',
//                         playerVars: {
//                             autoplay: 0,
//                             controls: 0,
//                             disablekb: 1,
//                             enablejsapi: 1,
//                             fs: 0,
//                             rel: 0,
//                             showinfo: 0,
//                             iv_load_policy: 3,
//                             modestbranding: 1,
//                             wmode: 'transparent',
//                         },
//                         events: {
//                             onReady: onPlayerReady,
//                             onStateChange: onPlayerStateChange,
//                         },
//                     });
//                 });
//             }

//             function onSlickImageBeforeChange(){
//                 const player = $slick.find('.slick-slide.slick-active').data('youtube-player');

//                 if (player) {
//                     player.stopVideo();
//                     $slick.removeClass('slick-slider--playvideo');
//                 }
//             }

//             function onSlickImageAfterChange(){
//                 const player = $slick.find('.slick-slide.slick-active').data('youtube-player');

//                 if (player) {
//                     $slick.slick('slickPause');
//                     $slick.addClass('slick-slider--playvideo');
//                     player.playVideo();
//                 }
//             }
//         },

//         productSizeChart: function($scope){
//             window.sizeChart = function() {
//                 var sizeChartBtn =  $scope.find('[data-open-size-chart-popup]');

//                 sizeChartBtn.on('click', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();

//                     document.body.classList.add('size-chart-show');
//                     if (document.body.classList.contains('quick-view-show')) {
//                         $('.halo-popup-content .halo-size-chart-popup').addClass('is-show');
//                     }
//                     else {
//                         $('#MainContent .halo-size-chart-popup').addClass('is-show');
//                     }
//                 });

//                 $doc.on('click', '[data-close-size-chart-popup]', () => {
//                     $body.removeClass('size-chart-show');
//                     $('.halo-size-chart-popup').removeClass('is-show');
//                 });

//                 $doc.on('click', (event) => {
//                     if ($body.hasClass('size-chart-show')) {
//                         if (($(event.target).closest('[data-open-size-chart-popup]').length === 0) && ($(event.target).closest('[data-size-chart-popup]').length === 0)) {
//                             $body.removeClass('size-chart-show');
//                         }
//                     }
//                 });
//             };

//             var quickViewShow = document.body.classList.contains('quick-view-show'),
//                 productSizeChart = $('.halo-productView .productView-sizeChart').length;

//             if (document.body.classList.contains('template-product')) {
//                 if (!quickViewShow && productSizeChart) {
//                     window.sizeChart();
//                 } else if (quickViewShow && productSizeChart === 0) {
//                     window.sizeChart();
//                 }
//             } else {
//                 window.sizeChart();
//             }
//         },

//         productLastSoldOut: function($scope) {
//             var wrapper = $scope.find('[data-sold-out-product]');

//             if (wrapper.length > 0) {
//                 var numbersProductList = wrapper.data('item').toString().split(','),
//                     numbersProductItem = Math.floor(Math.random() * numbersProductList.length),
//                     numbersHoursList = wrapper.data('hours').toString().split(','),
//                     numbersHoursItem = Math.floor(Math.random() * numbersHoursList.length);

//                 wrapper.find('[data-sold-out-number]').text(numbersProductList[numbersProductItem]);
//                 wrapper.find('[data-sold-out-hours]').text(numbersHoursList[numbersHoursItem]);
//                 wrapper.show();
//             }
//         },

//         productCustomerViewing: function($scope) {
//             var wrapper = $scope.find('[data-customer-view]');

//             if (wrapper.length > 0) {
//                 var numbersViewer = wrapper.data('customer-view'),
//                     numbersViewerList =  JSON.parse('[' + numbersViewer + ']'),
//                     numbersViewerTime = wrapper.data('customer-view-time'),
//                     timeViewer =  parseInt(numbersViewerTime) * 1000;
                
//                 setInterval(function() {
//                     var numbersViewerItem = (Math.floor(Math.random() * numbersViewerList.length));

//                     wrapper.find('.text').text(window.customer_view.text.replace('[number]', numbersViewerList[numbersViewerItem]));
//                 }, timeViewer);
//             }
//         },

//         productCountdown: function($scope){
//             var wrapper = $scope.find('[data-countdown-id]'),
//                 countDown = wrapper.data('countdown'),
//                 countDownDate = new Date(countDown).getTime(),
//                 countDownText = window.countdown.text;

//             if(wrapper.length > 0) {
//                 var countdownfunction = setInterval(function() {
//                     var now = new Date().getTime(),
//                         distance = countDownDate - now;

//                     if (distance < 0) {
//                         clearInterval(countdownfunction);
//                         wrapper.remove();
//                     } else {
//                         var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
//                             hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
//                             minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
//                             seconds = Math.floor((distance % (1000 * 60)) / 1000),
//                             strCountDown;

//                         if (wrapper.is('.style-2, .style-3, .style-4')) {
//                             strCountDown = '<span class="text"><span>'+ countDownText +'</span></span><span class="num">'+days+'<span>'+ window.countdown.day_2 +'</span></span>\
//                                 <span class="num">'+hours+'<span>'+ window.countdown.hour_2 +'</span></span>\
//                                 <span class="num">'+minutes+'<span>'+ window.countdown.min_2 +'</span></span>\
//                                 <span class="num">'+seconds+'<span>'+ window.countdown.sec_2 +'</span></span>';
//                         }
//                         else {
//                             strCountDown = '<span class="text"><span>'+ countDownText +'</span></span><span class="num">'+days+'<span>'+ window.countdown.day +'</span></span>\
//                                 <span class="num">'+hours+'<span>'+ window.countdown.hour +'</span></span>\
//                                 <span class="num">'+minutes+'<span>'+ window.countdown.min +'</span></span>\
//                                 <span class="num">'+seconds+'<span>'+ window.countdown.sec +'</span></span>';
//                         }

//                         wrapper.html(strCountDown);
//                         wrapper.addClass('show');
//                     }
//                 }, 1000);
//             }
//         },

//         productCustomCursor: function($scope){
//             if ($('.cursor-wrapper').length == 0) return;
//             const { Back } = window;

//             this.cursorWrapper = document.querySelector(".cursor-wrapper");
//             this.innerCursor = document.querySelector(".custom-cursor__inner");
//             this.outerCursor = document.querySelector(".custom-cursor__outer");

//             this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect();
//             this.innerCursorBox = this.innerCursor.getBoundingClientRect();
//             this.outerCursorBox = this.outerCursor.getBoundingClientRect();

//             document.addEventListener("mousemove", e => {
//                 this.clientX = e.clientX;
//                 this.clientY = e.clientY;
//             });

//             const render = () => {
//                 TweenMax.set(this.cursorWrapper, {
//                     x: this.clientX,
//                     y: this.clientY
//                 });
//                 requestAnimationFrame(render);
//             };
//             requestAnimationFrame(render);

//             this.fullCursorSize = 60;
//             this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, {
//                 width: this.fullCursorSize,
//                 height: this.fullCursorSize,
//                 ease: this.easing,
//                 paused: true
//             });

//             const handleMouseEnter = () => {
//                 this.enlargeCursorTween.play();
//                 $('.cursor-wrapper').addClass('handleMouseEnter').removeClass('handleMouseLeave');
//             };

//             const handleMouseLeave = () => {
//                 this.enlargeCursorTween.reverse();
//                 $('.cursor-wrapper').addClass('handleMouseLeave').removeClass('handleMouseEnter');
//             };

//             const gridItems = document.querySelectorAll(".productView-image");
//             gridItems.forEach(el => {
//                 if (el?.querySelector('.productView-video')) return;
//                 el.addEventListener("mouseenter", handleMouseEnter);
//                 el.addEventListener("mouseleave", handleMouseLeave);
//             });

//             this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
//                 scale: 0.7,
//                 paused: true,
//                 onComplete: () => {
//                     TweenMax.to(this.outerCursor, 0.2, {
//                         scale: 1,
//                         ease: this.easing
//                     });
//                 }
//             });

//             $(document).on('mouseover', '[data-cursor-image]', (event) => {
//                 var $target = $(event.currentTarget),
//                     imagesInView = new Array();

//                 imagesInView.push($target.attr('data-index'));
//                 $("#count-image").text(imagesInView[0]);
//             });

//             $.fn.isInViewport = function(excludePartials) {
//                 var elementTop = $(this).offset().top;
//                 var elementBottom = elementTop + $(this).height();

//                 var viewportTop = $(document).scrollTop();
//                 var viewportBottom = viewportTop + $(window).height();

//                 if (excludePartials) {
//                     var bottomVisible = (elementBottom - viewportTop) / $(this).height();
//                     var isInView = elementBottom > viewportTop && elementTop < viewportBottom;

//                     return isInView && bottomVisible > 0.5;
//                 }

//                 return elementBottom > viewportTop && elementTop < viewportBottom;
//             };

            
//             if ($('.product-full-width').length > 0 || $('.product-full-width-2').length > 0) {
//                 $(window).on('resize scroll', function() {
//                     var imagesInView = new Array();
//                     $('.productView-image').each(function() {
//                         if ($(this).isInViewport(true)) {
//                             imagesInView.push($(this).attr('data-index'));
//                             $("#count-image").text(imagesInView[0]);
//                         }
//                     });
//                 });
//             }
//         },

//         initWishlist: function() {
//             if(window.wishlist.show){
//                 halo.setLocalStorageProductForWishlist();

//                 $doc.on('click', '[data-wishlist]', (event) => {
//                     event.preventDefault();
//                     event.stopPropagation();

//                     if (!$(event.currentTarget).hasClass('is-in-grid')) {
//                         $('[data-wishlist-items-display]').removeClass('is-loaded');
//                     }

//                     var $target = $(event.currentTarget),
//                         id = $target.data('product-id'),
//                         handle = $target.data('wishlist-handle'),
//                         wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
//                         index = wishlistList.indexOf(handle),
//                         wishlistContainer = $('[data-wishlist-container]');
//                         wishlistLayout = wishlistContainer.attr('data-wishlist-layout');

//                     if(!$target.hasClass('wishlist-added')){
//                         $target
//                             .addClass('wishlist-added')
//                             .find('.text')
//                             .text(window.wishlist.added);

//                         if(wishlistContainer.length > 0) {
//                             const addEvent = new CustomEvent('addwishlistitem', { detail: { handle } , bubbles: true });
//                             document.dispatchEvent(addEvent);
//                         }

//                         wishlistList.push(handle);
//                         localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
                        
//                         const updateWishlistMailEvent = new CustomEvent('updatewishlistmail', { bubbles: true });
//                         document.dispatchEvent(updateWishlistMailEvent); 
//                     } else {
//                         $target
//                             .removeClass('wishlist-added')
//                             .find('.text')
//                             .text(window.wishlist.add);
//                         if(wishlistContainer.length > 0) {
//                             if($('[data-wishlist-added="wishlist-'+ id +'"]').length > 0) {
//                                 $('[data-wishlist-added="wishlist-'+ id +'"]').remove();
//                                 const icon = $(`[data-wishlist][data-product-id=${id}]`);
//                                 const productCard = icon.closest('.product');
//                                 productCard.remove();
//                             }           
//                         }

//                         wishlistList.splice(index, 1);
//                         localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

//                         const updatePaginationEvent = new CustomEvent('updatepagination', { bubbles: true })
//                         document.dispatchEvent(updatePaginationEvent);
                        
//                         if(wishlistContainer.length > 0) {
//                             wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

//                             if (wishlistList.length > 0) {
//                                 const updateWishlistMailEvent = new Event('updatewishlistmail', { bubbles: true })
//                                 document.dispatchEvent(updateWishlistMailEvent);
//                             } else {
//                                 $('[data-wishlist-container]')
//                                     .addClass('is-empty')
//                                     .html(`\
//                                     <div class="wishlist-content-empty text-center">\
//                                         <span class="wishlist-content-text">${window.wishlist.empty}</span>\
//                                         <div class="wishlist-content-actions">\
//                                             <a class="button button-2 button-continue" href="${window.routes.collection_all}">\
//                                                 ${window.wishlist.continue_shopping}\
//                                             </a>\
//                                         </div>\
//                                     </div>\
//                                 `);

//                                 $('[data-wishlist-footer]').hide();
//                             }   
//                         }
//                     }
//                     $('[data-wishlist-count]').text(wishlistList.length);
//                     halo.setProductForWishlist(handle);
//                 })
//             }
//         },

//         calculateCard06Padding() {
//             if (!$body.hasClass('product-card-layout-06')) return 

//             const cardAction = document.querySelector('.card .card-action.card-grid__hidden');
//             cardAction.classList.remove('card-grid__hidden');
//             const padding = cardAction.scrollHeight;

//             document.querySelector('[data-wishlist-items-grid-display]').style.setProperty('--card-06-padding', padding + 'px');
//             cardAction.classList.add('card-grid__hidden');
//         },

//         setProductForWishlist: function(handle){
//             var wishlistList = JSON.parse(localStorage.getItem('wishlistItem')),
//                 item = $('[data-wishlist-handle="'+ handle +'"]'),
//                 index = wishlistList?.indexOf(handle);

//             if (index == null || wishlistList == null) return;
            
//             if(index >= 0) {
//                 item
//                     .addClass('wishlist-added')
//                     .find('.text')
//                     .text(window.wishlist.added)
//             } else {
//                 item
//                     .removeClass('wishlist-added')
//                     .find('.text')
//                     .text(window.wishlist.add);
//             }
//         },

//         setLocalStorageProductForWishlist: function() {
//             var wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
//             localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

//             if (wishlistList.length > 0) {
//                 wishlistList = JSON.parse(localStorage.getItem('wishlistItem'));
                
//                 wishlistList.forEach((handle) => {
//                     halo.setProductForWishlist(handle);
//                 });
//             }
//             $('[data-wishlist-count]').text(wishlistList.length);
//         },

//         initCountdown: function () {
//           var countdownAnnouncementElm = $('[data-countdown-announcement]'),
//               countdownElm = $('[data-countdown]').not('[data-countdown-id]'),
//               countdownNewsletter = $('[data-countdown-time]'),
//               countdownSlideShow = $('[data-countdown-slide-show]');

//             if (countdownAnnouncementElm.length) {
//                 countdownAnnouncementElm.each(function () {
//                     var self = $(this),
//                         countdownAnnouncement = self.data('countdown-value'),
//                         countdownAnnouncementDate = new Date(countdownAnnouncement).getTime();

//                     var countdownAnnouncementFunction = setInterval(function() {
//                         var now = new Date().getTime(),
//                             distance = countdownAnnouncementDate - now;

//                         if (distance < 0) {
//                             clearInterval(countdownAnnouncementFunction);
//                             if (self.hasClass('hide--countdown')) {
//                                 self.remove();
//                             }
//                             else {
//                                 const thisItem = self.parents('.announcement-bar__message'),
//                                     thisBar = self.parents('[data-announcement-bar]');
//                                 thisBar.is('.slick-initialized') ? thisBar.slick('slickRemove', thisItem.data('slick-index')) : thisItem.remove();
//                             }
//                         } else {
//                              var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
//                                 hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
//                                 minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
//                                 seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
//                                 strCountDown = '';
                            
//                             strCountDown = '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>\
//                                             <div class="clock-item"><span class="num">'+hours+'</span><span class="text">'+ window.countdown.hours +'</span></div>\
//                                             <div class="clock-item"><span class="num">'+minutes+'</span><span class="text">'+ window.countdown.mins +'</span></div>\
//                                             <div class="clock-item"><span class="num">'+seconds+'</span><span class="text">'+ window.countdown.secs +'</span></div>';
                          
//                             self.html(strCountDown);
//                         }
//                     }, 1000);
//                 });
//             }

//             if (countdownElm.length) {
//                 countdownElm.each(function () {
//                     var self = $(this),
//                         countDown = self.data('countdown-value'),
//                         countDownDate = new Date(countDown).getTime();
                        
//                     var countdownfunction = setInterval(function() {
//                         var now = new Date().getTime(),
//                             distance = countDownDate - now;

//                         if (distance < 0) {
//                             clearInterval(countdownfunction);
//                             if (self.hasClass('hide--countdown')) {
//                                 self.remove();
//                             }
//                             else {
//                                 self.parents('.shopify-section').remove();
//                             }
//                         } else {
//                             var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
//                                 hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
//                                 minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
//                                 seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
//                                 strCountDown = '';
//                             if (self.hasClass('product-countdown-block')) {
//                                 if($('.halo-block-header').hasClass('countdown_style_2')){
//                                     strCountDown = '<div class="clock-item"><span class="num">'+days+ window.countdown.d +'</span><span class="icon">:</span></div>\
//                                                 <div class="clock-item"><span class="num">'+hours+ window.countdown.h +'</span><span class="icon">:</span></div>\
//                                                 <div class="clock-item"><span class="num">'+minutes+ window.countdown.m +'</span><span class="icon">:</span></div>\
//                                                 <div class="clock-item"><span class="num">'+seconds+ window.countdown.s +'</span><span class="icon"></span></div>';
//                                 } else{
//                                     strCountDown = `<div class="clock-item"><span class="num">${days}d&nbsp;</span></div>
//                                     <div class="clock-item"><span class="num">${hours}:</span></div>
//                                     <div class="clock-item"><span class="num">${minutes}:</span></div>
//                                     <div class="clock-item"><span class="num">${seconds}</span></div>`;
//                                 }
//                             } else {
//                                 strCountDown = '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>\
//                                                 <div class="clock-item"><span class="num">'+hours+'</span><span class="text">'+ window.countdown.hours +'</span></div>\
//                                                 <div class="clock-item"><span class="num">'+minutes+'</span><span class="text">'+ window.countdown.mins +'</span></div>\
//                                                 <div class="clock-item"><span class="num">'+seconds+'</span><span class="text">'+ window.countdown.secs +'</span></div>';
//                             }
//                             self.html(strCountDown);
//                         }
//                     }, 1000);
//                 });
//             }

//             if (countdownSlideShow.length) {
//                 countdownSlideShow.each(function () {
//                     var self = $(this),
//                         countDown = self.data('countdown-value'),
//                         countDownDate = new Date(countDown).getTime();
                        
//                     var countdownfunction = setInterval(function() {
//                         var now = new Date().getTime(),
//                             distancePrev = countDownDate - now;
//                             distanceNext = countDownDate - now - 1000;

//                         if (distancePrev < 0) {
//                             clearInterval(countdownfunction);
//                             if (self.hasClass('hide--countdown')) {
//                                 self.remove();
//                             }
//                             else {
//                                 self.parents('.shopify-section').remove();
//                             }
//                         } else {
//                             var days = Math.floor(distancePrev / (1000 * 60 * 60 * 24)),
//                                 hoursPrev = `0${Math.floor((distancePrev % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
//                                 hoursNext = `0${Math.floor((distanceNext % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
//                                 hoursPrevTens = Math.floor(hoursPrev / 10),
//                                 hoursNextTens = Math.floor(hoursNext / 10),
//                                 hoursPrevUnits = hoursPrev % 10,
//                                 hoursNextUnits = hoursNext % 10,
//                                 minutesPrev = `0${Math.floor((distancePrev % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
//                                 minutesNext = `0${Math.floor((distanceNext % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
//                                 minutesPrevTens = Math.floor(minutesPrev / 10),
//                                 minutesNextTens = Math.floor(minutesNext / 10),
//                                 minutesPrevUnits = minutesPrev % 10,
//                                 minutesNextUnits = minutesNext % 10,
//                                 secondsPrev = `0${Math.floor((distancePrev % (1000 * 60)) / 1000)}`.slice(-2),
//                                 secondsNext = `0${Math.floor((distanceNext % (1000 * 60)) / 1000)}`.slice(-2),
//                                 secondsPrevTens = Math.floor(secondsPrev / 10),
//                                 secondsNextTens = Math.floor(secondsNext / 10),
//                                 secondsPrevUnits = secondsPrev % 10,
//                                 secondsNextUnits = secondsNext % 10,
//                                 strCountDown = (days > 0 ? '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>' 
//                                                 : '') + 
//                                                 '<div class="clock-item">\
//                                                     <span class="num">\
//                                                         <span class="tens">\
//                                                             <span class="next" data-value="'+hoursNextTens+'">'+hoursNextTens+'</span>\
//                                                             <span class="prev" data-value="'+hoursPrevTens+'">'+hoursPrevTens+'</span>\
//                                                         </span>\
//                                                         <span class="units">\
//                                                             <span class="next" data-value="'+hoursNextUnits+'">'+hoursNextUnits+'</span>\
//                                                             <span class="prev" data-value="'+hoursPrevUnits+'">'+hoursPrevTens+'</span>\
//                                                         </span>\
//                                                     </span>\
//                                                     <span class="text">'+ window.countdown.hours +'</span>\
//                                                 </div>\
//                                                 <div class="clock-item">\
//                                                     <span class="num">\
//                                                         <span class="tens">\
//                                                             <span class="next" data-value="'+minutesNextTens+'">'+minutesNextTens+'</span>\
//                                                             <span class="prev" data-value="'+minutesPrevTens+'">'+minutesPrevTens+'</span>\
//                                                         </span>\
//                                                         <span class="units">\
//                                                             <span class="next" data-value="'+minutesNextUnits+'">'+minutesNextUnits+'</span>\
//                                                             <span class="prev" data-value="'+minutesPrevUnits+'">'+minutesPrevUnits+'</span>\
//                                                         </span>\
//                                                     </span>\
//                                                     <span class="text">'+ window.countdown.mins +'</span>\
//                                                 </div>\
//                                                 <div class="clock-item">\
//                                                     <span class="num">\
//                                                         <span class="tens">\
//                                                             <span class="next" data-value="'+secondsNextTens+'">'+secondsNextTens+'</span>\
//                                                             <span class="prev" data-value="'+secondsPrevTens+'">'+secondsPrevTens+'</span>\
//                                                         </span>\
//                                                         <span class="units">\
//                                                             <span class="next" data-value="'+secondsNextUnits+'">'+secondsNextUnits+'</span>\
//                                                             <span class="prev" data-value="'+secondsPrevUnits+'">'+secondsPrevUnits+'</span>\
//                                                         </span>\
//                                                     </span>\
//                                                     <span class="text">'+ window.countdown.secs +'</span>\
//                                                 </div>';
//                             self.html(strCountDown);
//                             self.find('.num>span').each((index, element) =>{
//                                 var $this = $(element);
//                                 if ($this.find('.next').data('value') != $this.find('.prev').data('value')){
//                                     $this.addClass('digit-roll-in');
//                                     $this.find('span').addClass('digit-fade');
//                                 }
//                             });
//                         }
//                     }, 1000);
//                 });
//             }

//             if (countdownNewsletter.length){
//                 function initCountdown(element) {
//                     const $element = $(element);
//                     const countdownTime = new Date($element.data('countdown-time')).getTime();
                
//                     const intervalId = setInterval(function() {
//                       const now = new Date().getTime();
//                       const distance = countdownTime - now;
                
//                       if (distance < 0) {
//                         clearInterval(intervalId);
//                         $element.remove();
//                       } else {
//                         const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//                         const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//                         const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//                         const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                
//                         const content = `
//                           <span class="item pos-relative d-inline-block v-a-top left w-auto">
//                             <span class="num dis-i-block">${days}</span>
//                             <span class="dis-block text uppercase">${window.countdown.day}ays</span>
//                           </span>
//                           <span class="item pos-relative d-inline-block v-a-top left w-auto">
//                             <span class="num dis-i-block">${hours}</span>
//                             <span class="dis-block text uppercase">${window.countdown.hour}ours</span>
//                           </span>
//                           <span class="item pos-relative d-inline-block v-a-top left w-auto">
//                             <span class="num dis-i-block">${minutes}</span>
//                             <span class="dis-block text uppercase">${window.countdown.min}ins</span>
//                           </span>
//                           <span class="item pos-relative d-inline-block v-a-top left w-auto">
//                             <span class="num dis-i-block">${seconds}</span>
//                             <span class="dis-block text uppercase">${window.countdown.sec}econds</span>
//                           </span>`;
                
//                         $element.find('.countdown').html(content);
//                         $element.parent().removeClass('hidden');
//                         $element.find('.countdown').addClass('show');
//                       }
//                     }, 1000);
//                 }
                
//                 countdownNewsletter.each(function() {
//                     initCountdown(this);
//                 });
//             }
//         },

//         collectionCountdown: function () {
//             var countdownElm = $('[data-collection-countdown]');

//             if (countdownElm.length) {
//                 countdownElm.each(function () {
//                     var self = $(this);

//                     var countDownCollection = (self) => {
//                         var countDown = self.data('collection-countdown-value'),
//                             countDownDate = new Date(countDown).getTime(),
//                             countDownText = window.countdown.text,
//                             now = new Date().getTime(),
//                             distance = countDownDate - now;

//                         if (distance < 0) {
//                             clearInterval(countDownCollection);
//                             if (self.hasClass('hide--countdown')) {
//                                 self.remove();
//                             }
//                         } else {
//                             var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
//                                 hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
//                                 minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
//                                 seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
//                                 strCountDown = '';
//                             if (self.hasClass('collection-countdown')) {
//                                 strCountDown = '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>\
//                                                 <div class="clock-item"><span class="num">'+hours+'</span><span class="text">'+ window.countdown.hours +'</span></div>\
//                                                 <div class="clock-item"><span class="num">'+minutes+'</span><span class="text">'+ window.countdown.mins +'</span></div>\
//                                                 <div class="clock-item"><span class="num">'+seconds+'</span><span class="text">'+ window.countdown.secs +'</span></div>';
//                             }
//                             self.html(strCountDown);
//                         }
//                     }

//                     setInterval(() =>{
//                         countDownCollection(self)
//                     }, 1000);
//                 });
//             }
//         },

//         handleScrollDown: function() {
//             var iconSrollDownSlt = '[data-scroll-down]',
//                 iconSrollDown = $(iconSrollDownSlt);

//             if (iconSrollDownSlt.length) {
//                 iconSrollDown.each(function() {
//                     var self = $(this);
//                     var target = self.closest('.shopify-section').next('.shopify-section').attr('id');

//                     self.attr('href', '#'+ target +'');

//                     iconSrollDown.on('click', function(e) {
//                         e.preventDefault();
//                         var scroll = $(this.getAttribute('href'));

//                         if (scroll.length) {
//                             $('html, body').stop().animate({
//                                 scrollTop: scroll.offset().top
//                             }, 400);
//                         };
//                     });
//                 });
//             }
//         },

//         toggleSidebarMobile: function() {
//             $doc.on('click', '[data-sidebar]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.addClass('open-mobile-sidebar');
              
//             });

//             $doc.on('click', '[data-close-sidebar]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 $body.removeClass('open-mobile-sidebar');
//             });

//             $doc.on('click', (event) => {
//                 if($body.hasClass('open-mobile-sidebar')){
//                     if (($(event.target).closest('[data-sidebar]').length === 0) && ($(event.target).closest('#halo-sidebar').length === 0)) {
//                         $body.removeClass('open-mobile-sidebar');
//                     }
//                 }
//             });
//         },

//         initBlogMasonry: function() {
//             const $blogMasonry = $('.blog-layout-masonry .blog-block-item');
//             const isRTL = $body.hasClass('layout_rtl');

//             $blogMasonry.masonry({
//                 columnWidth: '.blog-grid-sizer',
//                 itemSelector: '[data-masonry-item]',
//                 isRTL: isRTL,
//                 originLeft: !isRTL
//             });
//         },

//         articleGallery: function() {
//             const $gallery = $('.articleGallery-block'),
//                 $gallerySlider = $('.articleGallery-slider'),
//                 galleryLength = $gallery.length,
//                 col = $gallerySlider.data('col');

//             if (galleryLength > 0 && $gallerySlider.not('.slick-initialized')) {
//                 $gallerySlider.slick({
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     dots: true,
//                     arrows: true,
//                     infinite: false,
//                     mobileFirst: true,
//                     focusOnSelect: false,
//                     nextArrow: window.arrows.icon_next,
//                     prevArrow: window.arrows.icon_prev,
//                     rtl: window.rtl_slick,
//                     responsive: [
//                         {
//                             breakpoint: 767,
//                             settings: {
//                                 slidesToShow: col,
//                                 slidesToScroll: col
//                             }
//                         },
//                         {
//                             breakpoint: 319,
//                             settings: {
//                                 slidesToShow: 2,
//                                 slidesToScroll: 2
//                             }
//                         }
//                     ]
//                 });
//             }
//         },

//         initCollapseSidebarBlock: function () {
//             $doc.on('click', '.sidebarBlock-headingWrapper .sidebarBlock-heading', (event) => {
//                 var $target = $(event.currentTarget),
//                     $blockCollapse = $target.parent().siblings(),
//                     $sidebarBlock = $target.parents('.sidebarBlock');

//                 if ($target.hasClass('is-clicked')) {
//                     $target.removeClass('is-clicked');
//                     $blockCollapse.slideUp('slow');
//                 } else {
//                     $target.addClass('is-clicked');
//                     $blockCollapse.slideDown('slow');

//                     if ($sidebarBlock.hasClass('sidebar-product')) {
//                         $sidebarBlock.find('.products-carousel').slick('refresh');
//                     }
//                 }
//             });

//             $doc.on('click', '.sidebarBlock-headingWrapper-slide .sidebarBlock-heading', (event) => {
//                 var $target = $(event.currentTarget),
//                     $wrapBlock = $target.closest(".halo-sidebar-wrapper"),
//                     $blockSlide = $target.parent().siblings(),
//                     $backButton = $blockSlide.find(".sidebarBlock-slide__content-close"),
//                     $sidebarBlock = $target.parents('.sidebarBlock');

//                 $blockSlide.toggleClass("is-show")
//                 $wrapBlock.toggleClass("disable-scroll")
//                 $sidebarBlock.toggleClass("has-slide")

//                 $backButton.on("click", function () {
//                     $blockSlide.removeClass("is-show")
//                     $wrapBlock.removeClass("disable-scroll")
//                     $sidebarBlock.removeClass("has-slide")
//                 })
//             });
//         },

//         initCategoryActive: function(){
//             if ($('.all-categories-list').length > 0) {
//                 $doc.on('click', '.all-categories-list .icon-dropdown', (event) => {
//                     var $target = $(event.currentTarget).parent();

//                     $target.siblings().removeClass('is-clicked current-cate');
//                     $target.toggleClass('is-clicked');
//                     $target.siblings().find('> .dropdown-category-list').slideUp('slow');
//                     $target.find('> .dropdown-category-list').slideToggle('slow');
//                 });

//                 $('.all-categories-list li').each((index, element) =>{
//                     if ($(element).hasClass('current-cate')) {
//                         $(element).find('> .dropdown-category-list').slideToggle('slow');
//                     }
//                     if ($(element).hasClass("is-clicked")) {
//                         $(element).closest(".navPages-item").addClass("is-clicked");
//                         $(element).parent().slideDown("slow");
//                     }
//                 });
//             }
//         },

//         productBlockSilderSidebar: function() {
//             var productGrid = $('[data-product-slider-sidebar]'),
//                 itemToShow = productGrid.data('item-to-show'),
//                 itemDots = productGrid.data('item-dots'),
//                 itemArrows = productGrid.data('item-arrows');

//             if(productGrid.length > 0) {
//                 if(productGrid.not('.slick-initialized')) {
//                     productGrid.slick({
//                         mobileFirst: true,
//                         // adaptiveHeight: true,
//                         vertical: false,
//                         infinite: false,
//                         slidesToShow: itemToShow,
//                         slidesToScroll: 1,
//                         arrows: itemArrows,
//                         dots: itemDots,
//                         autoplay: true,
//                         autoplaySpeed: 2000,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                     });

                  
//                 }
//             }

//             if ($('body').hasClass('cursor-fixed__show')){
//                 window.sharedFunctionsAnimation.onEnterButton();
//                 window.sharedFunctionsAnimation.onLeaveButton();
//             }
//         },

//         productBlockSilderArticle: function() {
//             var productGrid = $('[data-product-slider-article]'),
//                 itemToShow = productGrid.data('item-to-show'),
//                 itemDots = productGrid.data('item-dots'),
//                 itemArrows = productGrid.data('item-arrows');

//             if(productGrid.length > 0) {
//                 if(productGrid.not('.slick-initialized')) {
//                     productGrid.slick({
//                         adaptiveHeight: true,
//                         vertical: false,
//                         infinite: false,
//                         slidesToShow: itemToShow,
//                         slidesToScroll: 1,
//                         arrows: itemArrows,
//                         dots: itemDots,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: [{
//                                 breakpoint: 992,
//                                 settings: {
//                                     slidesToShow: 3,
//                                     slidesToScroll: 1,
//                                 }
//                             },
//                             {
//                                 breakpoint: 551,
//                                 settings: {
//                                     slidesToShow: 2,
//                                     slidesToScroll: 1,
//                                 }
//                             }
//                         ]
//                     });
//                 }
//             }
//         },

//         articleGallery: function() {
//             const $gallery = $('.articleGallery-block'),
//                 $gallerySlider = $('.articleGallery-slider'),
//                 galleryLength = $gallery.length,
//                 col = $gallerySlider.data('col');

//             if (galleryLength > 0 && $gallerySlider.not('.slick-initialized')) {
//                 $gallerySlider.slick({
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     dots: true,
//                     arrows: true,
//                     infinite: false,
//                     mobileFirst: true,
//                     focusOnSelect: false,
//                     nextArrow: window.arrows.icon_next,
//                     prevArrow: window.arrows.icon_prev,
//                     rtl: window.rtl_slick,
//                     responsive: [
//                         {
//                             breakpoint: 767,
//                             settings: {
//                                 slidesToShow: col,
//                                 slidesToScroll: col
//                             }
//                         },
//                         {
//                             breakpoint: 319,
//                             settings: {
//                                 slidesToShow: 2,
//                                 slidesToScroll: 2
//                             }
//                         }
//                     ]
//                 });
//             }
//         },

//         initInfiniteScrolling: function(){
//             if ($('.pagination-infinite'.length > 0)) {
//                 $win.on('scroll load', () => {
//                     var currentScroll = $win.scrollTop(),
//                         pageInfinite = $('.pagination-infinite'),
//                         linkInfinite = pageInfinite.find('[data-infinite-scrolling]'),
//                         position; 

//                     if(linkInfinite.length > 0 && !linkInfinite.hasClass('is-loading')){
//                         position = pageInfinite.offset().top - 500;
                        
//                         if (currentScroll > position) {
//                             var url = linkInfinite.attr('href');

//                             halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
//                         }
//                     }
//                 });
//             }

//             $doc.on('click', '[data-infinite-scrolling]', (event) => {
//                 var linkInfinite = $(event.currentTarget),
//                     url = linkInfinite.attr('href');

//                 event.preventDefault();
//                 event.stopPropagation();

//                 halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
//             });
//         },

//         doAjaxInfiniteScrollingGetContent: function(url, link){
//             $.ajax({
//                 type: 'GET',
//                 url: url,
//                 beforeSend: function () {
//                     link.text(link.attr('data-loading-more'));
//                     link.addClass('is-loading');
//                     // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.add('is-loading');
//                     // $body.addClass('has-halo-loader');
//                 },
//                 success: function (data) {
//                     halo.ajaxInfiniteScrollingMapData(data);
//                 },
//                 error: function (xhr, text) {
//                     alert($.parseJSON(xhr.responseText).description);
//                 },
//                 complete: function () {
//                     link.text(link.attr('data-load-more'));
//                     link.removeClass('is-loading');
//                     // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.remove('is-loading');
//                     // $body.removeClass('has-halo-loader');
//                     if (document.querySelector('.collection-masonry')) {
//                         resizeAllGridItems();
//                     }
//                 }
//             });
//         },

//         ajaxInfiniteScrollingMapData: function(data){
//             var currentTemplate = $('#CollectionProductGrid'),
//                 currentProductListing = currentTemplate.find('.productListing'),
//                 currentPagination = currentTemplate.find('.pagination'),
//                 newTemplate = $(data).find('#CollectionProductGrid'),
//                 newProductListing = newTemplate.find('.productListing'),
//                 newPagination = newTemplate.find('.pagination'),
//                 newProductItem = newProductListing.children('.product');
                
//             if (newProductItem.length > 0) {
//                 currentProductListing.append(newProductItem);
//                 currentPagination.replaceWith(newPagination);

//                 $('[data-total-start]').text(1);

//                 if(window.compare.show){
//                     var $compareLink = $('[data-compare-link]');
//                     halo.setLocalStorageProductForCompare($compareLink);
//                 }

//                 if(window.wishlist.show){
//                     halo.setLocalStorageProductForWishlist();
//                 }

//                 if (halo.checkNeedToConvertCurrency()) {
//                     Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//                 }
//             }
//         },

//         initQuickShopProductList: function() {
//             $doc.on('click', '[data-open-quickshop-popup-list]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var handle = $(event.currentTarget).data('product-handle'),
//                     product = $(event.currentTarget).closest('.card');

//                 if(!product.hasClass('quick-shop-show')){
//                     halo.updateContentQuickShop(product, handle);
//                 }
//             });

//             $doc.on('click', '[data-close-quickshop-popup-list]', (event) => {
//                 event.preventDefault();
//                 event.stopPropagation();

//                 var product = $(event.currentTarget).closest('.card');

//                 product.removeClass('quick-shop-show');
//                 product.find('.card-popup-content').empty();
//             });

//             $doc.on('click', (event) => {
//                 if($('.card').hasClass('quick-shop-show')){
//                     if (($(event.target).closest('[data-open-quickshop-popup-list]').length === 0) && ($(event.target).closest('.card-popup').length === 0)){
//                         $('.card').removeClass('quick-shop-show');
//                         $('.card').find('.card-popup-content').empty();
//                     }
//                 }
//             });
//         },

//         updateContentQuickShop: function(product, handle) {
//             var popup = product.find('.card-popup'),
//                 popupContent = popup.find('.card-popup-content');

//             $.ajax({
//                 type: 'get',
//                 url: window.routes.root + '/products/' + handle + '?view=ajax_quick_shop',
//                 beforeSend: function () {
//                     $('.card').removeClass('quick-shop-show');
//                 },
//                 success: function (data) {
//                     popupContent.append(data);
//                 },
//                 error: function (xhr, text) {
//                     alert($.parseJSON(xhr.responseText).description);
//                 },
//                 complete: function () {
//                     product.addClass('quick-shop-show');
//                 }
//             });
//         },

//         toggleVariantsForExpressOrder: function () {
//             var toggleVariant = '[data-toggle-variant]';

//             $(document).on('click', toggleVariant, function (e) {
//                 e.preventDefault();
//                 e.stopPropagation();

//                 var self = $(this),
//                     curVariants = self.data('target');

//                 if(self.hasClass('show-options-btn')) {
//                     self.text(window.inventory_text.hide_options);
//                     $(curVariants).slideDown(700, function () {
//                         self.addClass('hide-options-btn').removeClass('show-options-btn');
//                     });
//                 }
//                 else {
//                     self.text(window.inventory_text.show_options);
//                     $(curVariants).slideUp(700, function () {
//                         self.addClass('show-options-btn').removeClass('hide-options-btn');
//                     });
//                 };
//             })
//         },

//         initExpressOrderAddToCart: function() {
//             var addToCartSlt = '[data-express-addtocart]';

//             $(document).off('click.addToCartExpress', addToCartSlt).on('click.addToCartExpress', addToCartSlt, function (e) {
//                 e.preventDefault();

//                 var self = $(this);

//                 if (self.attr('disabled') != 'disabled') {
//                     var productItem = self.closest('.product-item');

//                     if(productItem.length == 0) {
//                         productItem = self.closest('.col-options');
//                     }

//                     var form = productItem.find('form');
//                     var variant_id = form.find('select[name=id]').val();

//                     if (!variant_id) {
//                         variant_id = form.find('input[name=id]').val();
//                     };

//                     var quantityElm = productItem.find('input[name=quantity]');

//                     if(quantityElm.length == 0) {
//                         quantityElm = productItem.siblings('.col-qtt').find('input[name=quantity]');
//                     }

//                     var quantity = quantityElm.val();
//                     if (!quantity) {
//                         quantity = 1;
//                     };

//                     if(parseInt(quantity) !== 0) {
//                         if (window.ajax_cart == 'none') {
//                             form.submit();
//                         } else {
//                             halo.expressAjaxAddToCart(variant_id, quantity, self, form);
//                             form.next('.feedback-text').show();
//                         }
//                     }
//                     else {
//                         form.next('.feedback-text').text('Quantity cannot be blank').show();
//                     }
//                 }
//                 return false;
//             });
//         },

//         expressAjaxAddToCart: function(variant_id, quantity, cartBtn, form) {
//             $.ajax({
//                 type: "post",
//                 url: "/cart/add.js",
//                 data: 'quantity=' + quantity + '&id=' + variant_id,
//                 dataType: 'json',

//                 beforeSend: function() {
//                     window.setTimeout(function() {
//                         cartBtn.text(window.inventory_text.adding +"...");
//                     }, 100);
//                 },

//                 success: function(msg) {
//                     window.setTimeout(function() {
//                         cartBtn.text(window.inventory_text.thank_you);
//                         cartBtn.addClass('add_more');
//                         form.next('.feedback-text').text(window.inventory_text.cart_feedback).addClass('is-added');
//                     }, 600);
//                     window.setTimeout(function() {
//                         cartBtn.text(window.inventory_text.add_more + "...");
//                     }, 1000);

//                     switch (window.after_add_to_cart.type) {
//                         case 'cart':
//                             halo.redirectTo(window.routes.cart);

//                             break;
//                         case 'quick_cart':
//                             if(window.quick_cart.show){
//                                 Shopify.getCart((cart) => {
//                                     if( window.quick_cart.type == 'popup'){
//                                         // $body.addClass('cart-modal-show');
//                                         // halo.updateDropdownCart(cart);
//                                     } else {
//                                         $body.addClass('cart-sidebar-show');
//                                         halo.updateSidebarCart(cart);
//                                     }
//                                 });
//                             } else {
//                                 halo.redirectTo(window.routes.cart);
//                             }

//                             break;
//                         case 'popup_cart_1':
//                             Shopify.getCart((cart) => {
//                                 halo.updatePopupCart(cart, 1, variant_id);
//                                 halo.updateSidebarCart(cart);
//                                 $body.addClass('add-to-cart-show');
//                             });

//                             break;
//                     }
//                 },

//                 error: function(xhr, text) {
//                     alert($.parseJSON(xhr.responseText).description);
//                     window.setTimeout(function() {
//                         cartBtn.text(window.inventory_text.add_to_cart);
//                     }, 400);
//                 }
//             });
//         },

//         initProductBundle: function() {
//             var productBundle = $('[data-product-bundle]'),
//                 bundleList = productBundle.find('[data-bundle-slider]'),
//                 dots = bundleList.data('dots'),
//                 arrows = bundleList.data('arrows');

//             if(bundleList.length > 0){
//                 if(!bundleList.hasClass('slick-initialized')){
//                     bundleList.slick({
//                         dots: true,
//                         arrows: arrows,
//                         slidesToShow: 2,
//                         slidesToScroll: 1,
//                         mobileFirst: true,
//                         infinite: false,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         responsive: [
//                             {
//                                 breakpoint: 1200,
//                                 settings: {
//                                     slidesToShow: 4,
//                                     slidesToScroll: 1,
//                                     dots: dots
//                                 }
//                             },
//                             {
//                                 breakpoint: 551,
//                                 settings: {
//                                     slidesToShow: 3,
//                                     slidesToScroll: 1,
//                                     dots: dots
//                                 }
//                             }
//                         ]
//                     });

//                     productBundle.find('.bundle-product-wrapper').removeClass('has-halo-block-loader');

//                     bundleList.on('afterChange', function(){
//                         bundleList.find('.bundle-product-item').removeClass('is-open');
//                     });
//                 }
//             }
//         },

//         initDynamicBrowserTabTitle: function() {
//             if(window.dynamic_browser_title.show){
//                 var pageTitleContent = document.title,
//                     newPageTitleContent = window.dynamic_browser_title.text;

//                 window.onblur = function () {
//                     document.title = window.dynamic_browser_title.text;
//                 }

//                 window.onfocus = function () {
//                     document.title = pageTitleContent;
//                 }
//             }
//         },

//         initWarningPopup: function() {
//             this.warningPopup = document.querySelector('[data-warning-popup]');
//             this.warningPopupContent = this.warningPopup.querySelector('[data-halo-warning-content]');
//             this.warningPopupCloseButton = this.warningPopup.querySelector('[data-close-warning-popup]');
//             this.warningPopupCloseButton.addEventListener('click', () => {
//                 document.body.classList.remove('has-warning');
//             })

//             document.body.addEventListener('click', () => {
//                 if (!event.target.closest('[data-warning-popup]')) {
//                     document.body.classList.remove('has-warning');
//                 }
//             })
           
//             this.warningTime = 3000
//             this.warningTimeout = undefined;

//             window.warningTimeout = this.warningTimeout;
//         },  

//         showWarning: function(content, time = this.warningTime) {
//             if (this.warningTimeout) {
//                 clearTimeout(this.warningTimeout);
//             }

//             this.warningPopupContent.textContent = content;
//             document.body.classList.add('has-warning');
            
//             if (time) {
//                 this.warningTimeout = setTimeout(() => {
//                     document.body.classList.remove('has-warning');
//                 }, time);
//             }
//         },

//         backgroundOverlayHoverEffect: function() {
//             const backgroundOverlay = document.querySelector('.background-overlay')
//             const backgroundCursorWrapper = backgroundOverlay.firstChild

//             const enlargeCursor = () => {
//                 backgroundCursorWrapper.classList.add('enlarge-cursor')
//             }

//             const dwindleCursor = () => {
//                 backgroundCursorWrapper.classList.remove('enlarge-cursor')
//             }

//             const setCursorPosition = (clientX, clientY) => {
//                 requestAnimationFrame(() => {
//                     backgroundCursorWrapper.style.setProperty('--translate-y', clientY)
//                     backgroundCursorWrapper.style.setProperty('--translate-x', clientX)
//                 })
//             }

//             const handleMouseMove = (e) => {
//                 setCursorPosition(e.clientX, e.clientY)                
//             }

//             const handleMouseEnter = (e) => {
//                 setCursorPosition(e.clientX, e.clientY)
//                 enlargeCursor()
//             }
            
//             const handleMouseLeave = e => {
//                 setCursorPosition(e.clientX, e.clientY)
//                 backgroundCursorWrapper.removeEventListener('mousemove', handleMouseMove)
//                 dwindleCursor()
//             }

//             backgroundOverlay.addEventListener('mouseenter', handleMouseEnter)
//             backgroundOverlay.addEventListener('mouseleave', handleMouseLeave)
//             backgroundOverlay.addEventListener('mousemove', handleMouseMove)
//             backgroundOverlay.addEventListener('click', dwindleCursor)
//         },
//         backgroundOverlayHoverEffect1: function() {
//             const backgroundOverlay = document.querySelector('.background-overlay1')
//             if (!backgroundOverlay) return;
          
//             const backgroundCursorWrapper = backgroundOverlay.firstChild

//             const enlargeCursor = () => {
//                 backgroundCursorWrapper.classList.add('enlarge-cursor')
//             }

//             const dwindleCursor = () => {
//                 backgroundCursorWrapper.classList.remove('enlarge-cursor')
//             }

//             const setCursorPosition = (clientX, clientY) => {
//                 requestAnimationFrame(() => {
//                     backgroundCursorWrapper.style.setProperty('--translate-y', clientY)
//                     backgroundCursorWrapper.style.setProperty('--translate-x', clientX)
//                 })
//             }

//             const handleMouseMove = (e) => {
//                 setCursorPosition(e.clientX, e.clientY)                
//             }

//             const handleMouseEnter = (e) => {
//                 setCursorPosition(e.clientX, e.clientY)
//                 enlargeCursor()
//             }
            
//             const handleMouseLeave = e => {
//                 setCursorPosition(e.clientX, e.clientY)
//                 backgroundCursorWrapper.removeEventListener('mousemove', handleMouseMove)
//                 dwindleCursor()
//             }

//             backgroundOverlay.addEventListener('mouseenter', handleMouseEnter)
//             backgroundOverlay.addEventListener('mouseleave', handleMouseLeave)
//             backgroundOverlay.addEventListener('mousemove', handleMouseMove)
//             backgroundOverlay.addEventListener('click', dwindleCursor)
//         },
        
//         productCustomInformation() {
//             const $customInfo = $('[data-custom-information]');
//             const $thisPopup = $('#halo-product-custom-information');
            
//             $customInfo.on('click', (event) => {
//                 const $this = $(event.currentTarget);
//                 const title = $this.find('.title')[0].innerText;
//                 const thisContent = $this.find('.product-customInformation__popup').html();

//                 if (thisContent === "" || thisContent == null) return;
//                 $thisPopup.addClass('is-show');
//                 $thisPopup.find('.halo-popup-title').text(title);
//                 $thisPopup.find('.halo-popup-content').html(thisContent);
//                 $body.addClass('is-custom-information');
//             });

//             $doc.on('click', '[data-close-custom-information]', () => {
//                 $body.removeClass('is-custom-information');
//                 $thisPopup.removeClass('is-show');
//             });

//             $doc.on('click', (event) => {
//                 if ($body.hasClass('is-custom-information')) {
//                     if (($(event.target).closest('#halo-product-custom-information').length === 0) && ($(event.target).closest('[data-custom-information]').length === 0)) {
//                         $body.removeClass('is-custom-information');
//                     }
//                 }
//             });
//         },

//         initLazyloadObserver(loadingImages, productGrid) {
//             const setLazyLoaded = (target) => {
//                 const card = target.closest('.card')
//                 card.classList.add('ajax-loaded')
//             }

//             this.lazyloadedObserver = new MutationObserver((mutationList, observer) => {
//                 mutationList.forEach((mutation) => {
//                     if (mutation.type == 'attributes') {
//                         if (!mutation.target.classList.contains('lazyloaded')) return 
//                         setLazyLoaded(mutation.target)
//                     }
//                 })
//             }) 
            
//             const parentObserver = new MutationObserver((mutationlist) => {
//                 mutationlist.forEach((mutation) => {
//                     if (mutation.type == 'childList') {
//                         const addedLoadingImages = [...mutation.addedNodes].map(node => node.querySelector('.media--loading-effect img'))
//                         addedLoadingImages.forEach(image => {
//                             if (image) {
//                                 this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
//                             }
//                         })    
//                     }
//                 })
//             }) 

//             if (productGrid) parentObserver.observe(productGrid, { subtree: false, childList: true });
//             if (loadingImages.length > 0) loadingImages.forEach(image => {
//                 if (image.classList.contains('lazyloaded')) {
//                     setLazyLoaded(image)
//                 } else {
//                     this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
//                 }
//             })
//         },

//         observeImageLazyloaded(images) {
//             images.forEach(image => {
//                 this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
//             })
//         },

//         iconZoomClickMobile() {
//             const iconZoom = $('.productView-iconZoom');
//             iconZoom.on('click', (event) => {
//                 document.querySelector('.productView-image .productView-img-container .media').click();
//             });
//         },

//         calculateTranslateYHeight() {
//             const cardActions = document.querySelectorAll('.card .card-action:not(.variants-popup-form)');
//             let heighest = 0;
          
//             if (!cardActions.length) return;
//             cardActions.forEach(cardAction => {
//               cardAction.classList.add('temporary-show');
            
//               const height = cardAction.clientHeight ;
//               if (height > heighest) heighest = height;
  
//               cardAction.classList.remove('temporary-show');
//             })
//             document.body.style.setProperty('--translate-y-height', heighest * -1 + 'px');
//         },

//         checkScrollLayoutForRecenlyViewed() {
//             const RecentlyViewedSection = document.getElementById('recently-viewed-products-list-2');

//             if (RecentlyViewedSection && RecentlyViewedSection.classList.contains('products-flex')) {
//                 const RecentlyViewedObserver = new MutationObserver((mutationList, observer) => {
//                     const mutationRecentlyViewed = mutationList[0];

//                     if (mutationRecentlyViewed.type == 'attributes' 
//                         && mutationRecentlyViewed.target.classList.contains('recently-viewed-loaded')) {

//                         observer.disconnect();
//                     }
//                 })

//                 RecentlyViewedObserver.observe(RecentlyViewedSection, { attributes: true });
//             }
//         },
      
//         clickIconScrollSection() {
//             if (!document.querySelector('.arrow-icon-scroll')) return;
//             let isScrollingDown = 'next';
//             const sections = document.querySelectorAll('.wrapper-body .shopify-section'),
//               sectionsLength = sections.length,
//               sectionFirstHeight = sections[0]?.getBoundingClientRect().height || 0,
//               sectionEndHeight = sections[sectionsLength - 1]?.getBoundingClientRect().height || 0,
//               footerHeight = document.querySelectorAll('.shopify-section-group-footer-group')[0]?.getBoundingClientRect().height || 0;

//               if (window.pageYOffset + sectionEndHeight >= document.documentElement.scrollHeight - footerHeight - 100) loadRotateArrow('prev');
            
//               $(window).scroll(function() {
//                   if (window.pageYOffset + sectionEndHeight >= document.documentElement.scrollHeight - footerHeight - 100) loadRotateArrow('prev');
//                   else if (window.pageYOffset <= sectionFirstHeight/2) loadRotateArrow('next');
//               });
            
//               $doc.on('click', '.arrow-icon-scroll', (event) => {
//                   let checkScroll = true;
//                   const headerHeight = window.innerWidth > 1024 ? document.querySelectorAll('sticky-header')[0]?.getBoundingClientRect().height : document.querySelector('sticky-header-mobile')?.getBoundingClientRect().height || 0,
//                     footerTop = document.querySelectorAll('.shopify-section-group-footer-group')[0]?.getBoundingClientRect().top || -1;
                
//                   sections.forEach((element, index) => {
//                       if (!checkScroll) return;
//                       const thisTop = element.getBoundingClientRect().top;
                    
//                       if (thisTop >= 0) {
//                           checkScroll = false;
                        
//                           if (isScrollingDown == 'next') {
//                               if (element.nextElementSibling != null) scrollToSection(element.nextElementSibling.offsetTop - headerHeight);
//                               sectionsLength == index + 2 || element.nextElementSibling == null ? loadRotateArrow('prev') : loadRotateArrow('next');
//                           }
//                           else {
//                               if (element.previousElementSibling != null) scrollToSection(element.previousElementSibling.offsetTop - headerHeight);
//                               index == 1 || element.previousElementSibling == null ? loadRotateArrow('next') : loadRotateArrow('prev');
//                           }
//                       }
//                       else if (footerTop >= 0) scrollToSection(sections[sectionsLength - 1].offsetTop - headerHeight);
//                   });
//               });
            
//               function scrollToSection(scope, rotate) {
//                   window.scrollTo({top: scope, behavior: "smooth"});
//               }
  
//               function loadRotateArrow(rotate) {
//                   isScrollingDown = rotate;
//                   rotate == 'next' ? document.querySelector('.arrow-icon-scroll').classList.remove('rotate') : document.querySelector('.arrow-icon-scroll').classList.add('rotate');
//               }
//         },

//         specialBanner() {
//             const banners = document.querySelectorAll('[sticky-special-banner]'),
//               wdWidth = window.innerWidth,
//               wdHeight = window.innerHeight,
//               headerHeight = wdWidth > 1024 ? document.querySelectorAll('sticky-header')[0]?.getBoundingClientRect().height : document.querySelector('sticky-header-mobile')?.getBoundingClientRect().height || 0;
          
//             if (banners) {
//                 banners.forEach(element => {
//                     const banner = element.querySelector('.special-banner__img_box'),
//                       bannerWrap = element.querySelector('.special-banner__img'),  
//                       wrapperHeight = element.closest('.special-banner__wrapper').getBoundingClientRect().height,
//                       bannerHeight = bannerWrap.getBoundingClientRect().height;
                  
//                     let top = headerHeight || 0;
//                     if (wdWidth >= 1200) {
//                         if (wrapperHeight > bannerHeight) {
//                             if (wdHeight > bannerHeight) top = (wdHeight - bannerHeight)/2;
//                             calculateSticky(banner, top);
//                         }
//                     }
//                     else if (wdWidth >= 768 && wdWidth < 1200) {
//                         if (wrapperHeight > bannerHeight) {
//                             calculateSticky(banner, top);
//                         }
//                     }
//                     else {
//                         element.classList.remove('is-sticky');
//                         element.style.top = ``;
//                     }
//                 });
//             }

//             function calculateSticky(banner, top) {
//                 banner.classList.add('is-sticky');
//                 banner.style.top = `${top}px`;
//             }
//         },

//         specialBannerSlider() {
//             const productGrid = $('.special-banner__products--grid'),
//               wdWidth = window.innerWidth;
          
//             if (productGrid) {
//                 productGrid.each(function(index, element) {
//                     const $this = $(element),
//                       $block = $this.closest('.special-banner__product');
                    
//                     if (!$block.hasClass('ajax-loaded')) return;
                    
//                     if (wdWidth < 1200) {
//                         if (!$this.hasClass('slick-initialized')) {
//                             $this.addClass('products-carousel');
//                             specialProductSlider($block);
//                         }
//                     }
//                     else {
//                         if ($this.hasClass('slick-initialized')) {
//                             $this.slick('unslick');
//                             $this.removeClass('products-carousel');
//                         }
//                     }
//                 })
//             }

//             function specialProductSlider(wrapper) {
//                 let productGrid = wrapper.find('.products-carousel'),
//                     itemToShow = productGrid.data('item-to-show'),
//                     itemDots = productGrid.data('item-dots'),
//                     itemDotsMb = productGrid.data('item-dots-mb'),
//                     itemArrows = productGrid.data('item-arrows'),
//                     itemArrowsMb = productGrid.data('item-arrows-mb');
    
//                 productGrid.slick({
//                     mobileFirst: true,
//                     adaptiveHeight: true,
//                     infinite: true,
//                     slidesToShow: 2,
//                     slidesToScroll: 2,
//                     arrows: itemArrowsMb,
//                     dots: itemDotsMb,
//                     nextArrow: window.arrows.icon_next,
//                     prevArrow: window.arrows.icon_prev,
//                     rtl: window.rtl_slick,
//                     responsive: 
//                     [
//                         {
//                             breakpoint: 767,
//                             settings: {
//                                 arrows: itemArrows,
//                                 dots: itemDots,
//                                 slidesToShow: itemToShow,
//                                 slidesToScroll: itemToShow,
//                             }
//                         }
//                     ]
//                 });
//             }
//         },

//         unsymmetricalSlider(){
//             const productUnsy = $('.unsymmetrical-slider'),
//               wdWidth = $(window).width();

//                 if(productUnsy){
//                     productUnsy.each(function(index, element) {
//                     const $this = $(element),
//                         $block = $this.closest('.halo-block-content');
                    
//                     if (!$block.hasClass('ajax-loaded')) return;
                    
//                     if (wdWidth < 1200) {
//                         if (!$this.hasClass('slick-initialized')) {
//                             $this.addClass('products-carousel');
//                             setTimeout(() => {
//                                 unsymmetricalProductSlider($block);
//                             }, 1000);
//                         }
//                     }
//                     else {
//                         if ($this.hasClass('slick-initialized')) {
//                             $this.slick('unslick');
//                             $this.removeClass('products-carousel');
//                         }
//                     }
//                 })

//                 function unsymmetricalProductSlider(wrapper) {
//                     let productGrid = wrapper.find('.products-carousel'),
//                         itemToShow = productGrid.data('item-to-show'),
//                         itemDots = productGrid.data('item-dots'),
//                         itemArrows = productGrid.data('item-arrows');

//                     if (productGrid.hasClass('enable_progress_bar')) {
//                         var progressBar = wrapper.find('.scrollbar-thumb');
//                         productGrid.on('init', (event, slick) => {
//                             var percent = ((slick.currentSlide / (slick.slideCount - 1)) * 100) + '%';
//                             progressBar.css('--percent', percent);
//                         });
//                     }
        
//                     productGrid.slick({
//                         mobileFirst: true,
//                         adaptiveHeight: true,
//                         infinite: true,
//                         slidesToShow: 1.5,
//                         slidesToScroll: 1,
//                         arrows: itemArrows,
//                         nextArrow: window.arrows.icon_next,
//                         prevArrow: window.arrows.icon_prev,
//                         rtl: window.rtl_slick,
//                         dots: itemDots,
//                         get initialSlide() {
//                             return this.initialSlide = 0.5;
//                         },
//                         responsive: 
//                         [
//                             {
//                                 breakpoint: 767,
//                                 settings: {
//                                     arrows: itemArrows,
//                                     slidesToShow: itemToShow,
//                                     dots: itemDots,
//                                     slidesToScroll: itemToShow,
//                                     get slidesToScroll() {
//                                         if(itemToShow !== undefined && itemToShow !== null && itemToShow !== '' && itemToShow !== 1.5 && itemToShow !== 2.5 && itemToShow !== 3.5){
//                                             return this.slidesToScroll = itemToShow;
//                                         } else {
//                                             return this.slidesToScroll = 1;
//                                         }
//                                     },
//                                     get initialSlide() {
//                                         if(itemToShow !== 1.5 && itemToShow == 2.5 || itemToShow == 3.5) {
//                                             return this.initialSlide = 0.5;
//                                         } else {
//                                             return this.initialSlide = 0;
//                                         }
//                                     }
//                                 }
//                             }
//                         ]
//                     });

//                     if (productGrid.hasClass('enable_progress_bar')) {
//                         productGrid.on('afterChange', (event, slick, nextSlide) => {
//                             let number = 0;
//                             if(wdWidth > 767) {
//                                 if(itemToShow == 1.5 || itemToShow == 2.5 || itemToShow == 3.5) {
//                                     number = 0.5;
//                                 } else {
//                                     number = 0;
//                                 }
//                             } else {
//                                 number = 0.5;
//                             }
//                             var percent = (((nextSlide - number ) / (slick.slideCount - 1)) * 100) + '%';
//                             progressBar.css('--percent', percent);
//                         });
//                     }
//                 }
//             }
//         },

//         productCountdownCard: function(){
//             var wrapper = $('.card .card-countDown').find('[data-countdown-id]'),
//                 countDown = wrapper.data('countdown'),
//                 countDownDate = new Date(countDown).getTime(),
//                 countDownText = window.countdown.text;

//             if(wrapper.length > 0) {
//                 var countdownfunction = setInterval(function() {
//                     var now = new Date().getTime(),
//                         distance = countDownDate - now;

//                     if (distance < 0) {
//                         clearInterval(countdownfunction);
//                         wrapper.remove();
//                     } else {
//                         var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
//                             hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
//                             minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
//                             seconds = Math.floor((distance % (1000 * 60)) / 1000),
//                             strCountDown;

//                             strCountDown = '<span class="text"><span>'+ countDownText +'</span></span><span class="num">'+days+'<span>'+ window.countdown.day +'</span></span>\
//                                 <span class="num">'+hours+'<span class="icon">:</span></span>\
//                                 <span class="num">'+minutes+'<span class="icon">:</span></span>\
//                                 <span class="num">'+seconds+'</span>';

//                         wrapper.html(strCountDown);
//                         wrapper.addClass('show');
//                     }
//                 }, 1000);
//             }
//         },

//         typingAnimation() {
//             // typing multiple text 
//             $.fn.textType = function (rotate, period) {
//                 return this.each(function () {
//                     var $this = $(this);
//                     var textType = new TextType($this, rotate, period);
//                 });
//             };

//             var TextType = function (element, rotate, period) {
//                 this.rotate = rotate;
//                 this.$element = $(element);
//                 this.loopNum = 0;
//                 this.period = parseInt(period, 10) || 2000;
//                 this.text = '';
//                 this.tick();
//                 this.isDeleting = false;
//             };

//             TextType.prototype.tick = function () {
//                 var i = this.loopNum % this.rotate.length;
//                 var fullText = this.rotate[i];

//                 if (this.isDeleting) {
//                     this.text = fullText.substring(0, this.text.length - 1);
//                 } else {
//                     this.text = fullText.substring(0, this.text.length + 1);
//                 }

//                 this.$element.find('[data-text-convert]').html(`<span class="text">${this.text}</span>`);

//                 var that = this;
//                 var delta = 200 - Math.random() * 100;

//                 if (this.isDeleting) {
//                     delta /= 2;
//                 }

//                 if (!this.isDeleting && this.text === fullText) {
//                     delta = this.period;
//                     this.isDeleting = true;
//                 } else if (this.isDeleting && this.text === '') {
//                     this.isDeleting = false;
//                     this.loopNum++;
//                     delta = 500;
//                 }

//                 setTimeout(function () {
//                     that.tick();
//                 }, delta);
//             };

//             // typing full text and split with comma
//             $.fn.textTypeMultipleSentences = function (period) {
//                 return this.each(function () {
//                     var $this = $(this);
//                     var textType = new MultipleSentencesType($this, period);
//                 });
//             };

//             var MultipleSentencesType = function (element, period) {
//                 this.$element = $(element);
//                 this.sentences = JSON.parse(this.$element.attr('data-type'));
//                 this.period = parseInt(period, 10) || 2000;
//                 this.sentenceIndex = 0;
//                 this.setupCurrentSentence();
//                 this.isDeleting = false;
//                 this.isPaused = false;
//                 this.tick();
//             };

//             MultipleSentencesType.prototype.setupCurrentSentence = function () {
//                 this.currentTextArray = this.sentences[this.sentenceIndex].split(',').map(word => word.trim());
//                 this.fullTextArray = this.currentTextArray;
//                 this.displayedWords = this.currentTextArray.map(() => '');
//             };

//             MultipleSentencesType.prototype.tick = function () {
//                 var that = this;
//                 var completedTextArray = this.fullTextArray;

//                 if (!this.isDeleting && !this.isPaused) {
//                     for (let i = 0; i < this.currentTextArray.length; i++) {
//                         if (this.displayedWords[i] !== completedTextArray[i]) {
//                             this.displayedWords[i] = completedTextArray[i].substring(0, this.displayedWords[i].length + 1);
//                             break;
//                         }
//                     }

//                     if (this.displayedWords.join(' ') === completedTextArray.join(' ')) {
//                         this.isPaused = true;
//                         setTimeout(function () {
//                             that.isPaused = false;
//                             that.isDeleting = true;
//                         }, 1000);
//                     }
//                 } else if (this.isDeleting) {
//                     for (let i = this.currentTextArray.length - 1; i >= 0; i--) {
//                         if (this.displayedWords[i] !== '') {
//                             this.displayedWords[i] = this.displayedWords[i].substring(0, this.displayedWords[i].length - 1);
//                             break;
//                         }
//                     }

//                     if (this.displayedWords.join('') === '') {
//                         this.isDeleting = false;
//                         this.sentenceIndex = (this.sentenceIndex + 1) % this.sentences.length;
//                         this.setupCurrentSentence();
//                     }
//                 }

//                 var spans = this.displayedWords.map(word => `<span class="text">${word}</span>`).join(' ');
//                 this.$element.html(spans);

//                 var delta = 150 - Math.random() * 50;
//                 if (this.isPaused) {
//                     delta = this.period;
//                 } else if (this.isDeleting && this.displayedWords.join('') === '') {
//                     delta = 500;
//                 }

//                 setTimeout(function () {
//                     that.tick();
//                 }, delta);
//             };

//             //use
//             if ($("type-writer").length) {
//                 $("type-writer").each(function (index, el) {
//                     const rotate = $(this).attr('data-type');
//                     const period = $(this).attr('data-period');

//                     if ($(this).hasClass('typing-comma')) {
//                         new MultipleSentencesType($(this), period);

//                     } else {
//                         if (rotate) {
//                             new TextType($(this), JSON.parse(rotate), period);
//                         }
//                     }
//                 })
//             }


//         },

//         spotlightproductSlider: function(){
//             var productSpotlight = $('[data-spotlight-product]');
//             if (!productSpotlight.length > 0) return;

//             productSpotlight.each((index, element) => {
//                 var self = $(element),
//                     productGrid = self.find('.spotlight-products__products--slider'),
//                     itemDots = productGrid.data('item-dots'),
//                     itemDotsMB = productGrid.data('item-dots-mb'),
//                     itemArrows = productGrid.data('item-arrows'),
//                     itemArrowsMB = productGrid.data('item-arrows-mb');

//                 if(productGrid.length > 0){
//                     if(!productGrid.hasClass('slick-initialized')){
//                         productGrid.slick({
//                             mobileFirst: true,
//                             adaptiveHeight: false,
//                             infinite: false,
//                             vertical: false,
//                             slidesToShow: 1,
//                             slidesToScroll: 1,
//                             dots: itemDotsMB,
//                             arrows: itemArrowsMB,
//                             nextArrow: window.arrows.icon_next,
//                             prevArrow: window.arrows.icon_prev,
//                             rtl: window.rtl_slick,
//                             focusOnSelect: true,
//                             responsive: [
//                             {
//                                 breakpoint: 1025,
//                                 settings: {
//                                     dots: itemDots,
//                                     arrows: itemArrows
//                                 }
//                             }]
//                         });

//                         productGrid.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//                             const section = $(event.target).parents('.spotlight-products');
//                             section.find('.point-button').removeClass('active');
//                             section.find(`[data-slide="${nextSlide+1}"]`).addClass('active');
//                         });
//                     }
//                 }
//             });

//             $('.spotlight-products__product_point .point-button').click(function(e) {
//                 e.preventDefault();
//                 const $this = $(this);
//                 const section = $this.parents('.spotlight-products');
//                 const slider = section.find('.spotlight-products__products--slider');
//                 slider.slick('slickGoTo', $this.data('slide') - 1);
//             });
//         },

//         activeCheckboxStickyCartMobile: function(){
//             var enableSticky = $('.enable_sticky_buttton');
//             if (!enableSticky.length) return;

//             var buttonDisable = $('.button-disable'),
//                 stickyButtonMB = $('.sticky_button_checkout_mb'),
//                 haloStickyToolbar = $('.halo-sticky-toolbar-mobile'),
//                 heightToolbar = haloStickyToolbar.outerHeight();

//             buttonDisable.on('click', function () {
//                 stickyButtonMB.addClass('active');
//             });

//             if(haloStickyToolbar.length > 0) {
//                 stickyButtonMB.css('bottom', heightToolbar);
//             } else {
//                 stickyButtonMB.css('bottom','0px');
//             }
//         }
//     }
// })(jQuery);





// Use our custom event listeners to tap into common functions.
// Documentation - https://archetypethemes.co/blogs/streamline/javascript-events-for-developers
//
// document.addEventListener('page:loaded', function() {
//   /* Stylesheet and theme scripts have loaded */
// });

window.theme = window.theme || {};
window.slate = window.slate || {};

if (console && console.log) {
  try {
    console.log('Streamline theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
  } catch(e) {}
}

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function($){
  var $ = jQuery = $;

  slate.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    promiseStylesheet: function() {
      if (typeof this.stylesheetPromise === 'undefined') {
        this.stylesheetPromise = $.Deferred(function(defer) {
          var link = document.querySelector('link[href="' + theme.stylesheet + '"]');
  
          if (link.loaded) {
            defer.resolve();
          }
  
          onloadCSS(link, function() { // Global onloadCSS function injected by load-css.liquid
            defer.resolve();
          });
        });
      }
  
      return this.stylesheetPromise;
    }
  };
  
  slate.a11y = {
  
    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
  
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
  
      $(document).off('focusin');
  
      $(document).on(eventName, function(evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    },
  
    // Not from Slate, but fit in the a11y category
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
  
    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    },
  
    promiseAnimationEnd: function($el) {
      var events = 'animationend webkitAnimationEnd oAnimationEnd';
      var properties = ['animation-duration', '-moz-animation-duration', '-webkit-animation-duration', '-o-animation-duration'];
      var duration = 0;
      var promise = $.Deferred().resolve();
  
      // check the various CSS properties to see if a duration has been set
      $.each(properties, function(index, value) {
        duration || (duration = parseFloat($el.css(value)));
      });
  
      if (duration > 0) {
        promise = $.Deferred(function(defer) {
          $el.on(events, function(evt) {
            if (evt.target !== $el[0]) return;
            $el.off(events);
            defer.resolve();
          });
        });
      }
  
      return promise;
    },
  
    promiseTransitionEnd: function($el) {
      var events = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
      var properties = ['transition-duration', '-moz-transition-duration', '-webkit-transition-duration', '-o-transition-duration'];
      var duration = 0;
      var promise = $.Deferred().resolve();
  
      // check the various CSS properties to see if a duration has been set
      $.each(properties, function(index, value) {
        duration || (duration = parseFloat($el.css(value)));
      });
  
      if (duration > 0) {
        promise = $.Deferred(function(defer) {
          $el.on(events, function(evt) {
            if (evt.target !== $el[0]) return;
            $el.off(events);
            defer.resolve();
          });
        });
      }
  
      return promise;
    }
  };
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container,
        namespace: '.' + type + '-' + id
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
  
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
  
      if (!container) {
        return;
      }
  
      this.createInstance(container);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      if (!subSection) {
        this.loadSubSections();
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
  
    loadSubSections: function($context) {
      var $sections = $context ? $context.find('[data-subsection]') : $('[data-subsection]');
  
      $sections.each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
  
      if (AOS) {
        AOS.refreshHard();
      }
    },
  
    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    reinitSection: function(section) {
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    },
  
    register: function(type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
  
      // Any section within the scope
      if ($scope) {
        $sections = $('[data-section-type=' + type + ']', $scope);
      }
  
      $sections.each(function(index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
  
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();
  
  slate.Variants = (function() {
  
    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
  
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
  
        return currentOptions;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
  
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant
          }
        }));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
  
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
  
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
  
    return Variants;
  })();
  
  slate.rte = {
    init: function() {
      slate.rte.wrapTable();
      slate.rte.wrapVideo();
      slate.rte.imageLinks();
    },
  
    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
  
    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
  
      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },
  
    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };
  

  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        bodyOpenClass: 'modal-open',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.$modal = $('#' + id);
  
      if (!this.$modal.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
  
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
  
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.$modal.addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
  
      setTimeout(function() {
        this.$modal.addClass('aos-animate');
      }.bind(this), 0);
  
      this.modalIsOpen = true;
  
      slate.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }
  
      $('body').trigger('modalOpen.' + this.id);
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$modal.removeClass(this.config.openClass).removeClass('aos-animate');
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
  
      this.modalIsOpen = false;
  
      slate.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }
  
      $('body').trigger('modalClose.' + this.id);
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
  
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.ProductScreen = (function() {
  
    var originalTitle = document.title;
    var namespace = 'productscreen';
    var windowPosition = 0;
    var $page = $('#MainContent');
  
    function ProductScreen(id, name, options) {
      var defaults = {
        close: '.js-screen-close',
        open: '.js-screen-open-' + name,
        openClass: 'screen-layer--is-active',
        closeSlideAnimate: 'screen-layer--is-sliding',
        bodyOpenClass: 'screen-layer-open',
        bodyClosingClass: 'screen-layer-closing',
        bodyCloseAnimate: 'screen-layer-closing screen-layer-animating',
        loaderStart: 200,
        pullToCloseThreshold: -100
      };
  
      this.id = id;
      this.$screen = $('#' + id);
      this.title = this.$screen.data('product-title');
  
      if (!this.$screen.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $body: $('body'),
        $loader: $('#OverscrollLoader').find('.icon-loader__path'),
        $screenContent: this.$screen.find('.screen-layer__inner'),
        $photoswipe: $('.pswp')
      };
  
      this.config = $.extend(defaults, options);
      this.initalized = false; // opened at least once
      this.isOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$screen;
  
      this.init();
    }
  
    ProductScreen.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$screen.find(this.config.close).on('click', { noAnimate: true, back: true }, this.close.bind(this));
  
      // Close screen if product added to sticky cart
      if (theme.settings.cartType === 'sticky') {
        this.nodes.$body.on('added.' + this.id, function() {
          theme.headerNav.toggleThumbMenu(false, true);
          var args = { back: true };
          this.close(false, args);
        }.bind(this));
  
        this.nodes.$body.on('error.' + this.id, function() {
          if (this.initalized) {
            this.open();
          }
        }.bind(this));
      }
    };
  
    ProductScreen.prototype.open = function(evt, data) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
      var args = {
        updateCurrentPath: data ? data.updateCurrentPath : true
      };
  
      if (this.isOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }
  
      if (this.isOpen && !externalCall) {
        this.close();
      }
  
      windowPosition = window.scrollY;
  
      this.$screen
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
      this.nodes.$screenContent.scrollTop(0);
      window.scrollTo(0,0);
  
      slate.a11y.trapFocus({
        $container: this.$screen,
        $elementToFocus: this.$focusOnOpen,
        namespace: namespace
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }
  
      var newUrl = this.$activeSource.data('url');
      this.nodes.$body
        .trigger('productModalOpen.' + this.id)
        .trigger('newPopstate', {screen: this, url: newUrl, updateCurrentPath: args.updateCurrentPath});
  
      this.initalized = true;
      this.isOpen = true;
      document.title = this.title;
  
      // Trigger Google Analytics page view if enabled
      if (window.ga) { ga('send', 'pageview', { page: newUrl }) }
  
      this.bindEvents();
    };
  
    ProductScreen.prototype.close = function(evt, args) {
      var evtData = args ? args : (evt ? evt.data : null);
      var goBack = evtData ? evtData.back : false;
      var noAnimate = (evtData && evtData.noAnimate) ? true : false;
      this.nodes.$body.removeAttr('style');
      this.nodes.$loader.css('stroke-dashoffset', this.config.loaderStart);
  
      if (goBack) {
        this.nodes.$body.trigger('newPopstate', {screen: this, back: true});
      }
  
      var closeClass = noAnimate ? '' : this.config.closeSlideAnimate;
      var bodyCloseClass = noAnimate ? this.config.bodyClosingClass : this.config.bodyCloseAnimate;
  
      // Don't close if already closed
      if (!this.isOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$screen
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(closeClass);
      this.nodes.$parent
        .removeClass(this.config.bodyOpenClass)
        .addClass(bodyCloseClass);
  
      window.setTimeout(function() {
        this.$screen.removeClass(closeClass);
        this.nodes.$parent.removeClass(bodyCloseClass);
        window.scrollTo(0, windowPosition);
      }.bind(this), 500); // duration of css animation
  
      slate.a11y.removeTrapFocus({
        $container: this.$screen,
        namespace: namespace
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }
  
      this.nodes.$body
        .trigger('productModalClose')
        .trigger('productModalClose.' + this.id);
  
      window.scrollTo(0, windowPosition);
  
      this.isOpen = false;
      document.title = originalTitle;
  
      if (window.ga) { ga('send', 'pageview') }
  
      this.unbindEvents();
    };
  
    ProductScreen.prototype.bindEvents = function() {
      // Pressing escape closes modal, unless the photoswipe screen is open
      this.nodes.$body.on('keyup.' + namespace, function(evt) {
        if (evt.keyCode === 27) {
          if (this.nodes.$photoswipe.hasClass('pswp--open')) {
            return;
          }
          if (this.nodes.$body.hasClass('js-drawer-open')) {
            return;
          }
          var args = { back: true };
          this.close(false, args);
        }
      }.bind(this));
  
      // If scrolling up while at top, close modal
      var bgAmount = 0;
      var loaderAmount = 0;
      $(document).on('touchmove.' + namespace, $.throttle(15, function(evt) {
        var pos = window.scrollY;
  
        if (pos >= 0) {
          return;
        }
  
        bgAmount = -(pos/100);
        this.nodes.$body.css('background', 'rgba(0,0,0,' + bgAmount + ')');
  
        // stroke fills from 200-0 (0 = full)
        loaderAmount = this.config.loaderStart + (pos * 2); // pos is negative number
  
        if (pos <= this.config.pullToCloseThreshold) {
          loaderAmount = 0;
        }
  
        this.nodes.$loader.css('stroke-dashoffset', loaderAmount);
      }.bind(this)));
  
      $(document).on('touchend.' + namespace, function(evt) {
        totalLoader = this.config.loaderStart; // reset to starting point
        var pos = window.scrollY;
        if (pos < this.config.pullToCloseThreshold) {
          var args = { back: true };
          this.close(false, args);
        }
      }.bind(this));
    };
  
    ProductScreen.prototype.unbindEvents = function() {
      this.nodes.$body.off('.' + namespace);
      $(document).off('.' + namespace);
    };
  
    return ProductScreen;
  })();
  
  theme.Drawers = (function() {
    function Drawer(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('body')
      };
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.isOpen = false;
      this.init();
    };
  
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);
  
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
  
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
      },
  
      open: function(evt) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget);
        }
  
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
  
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
  
        slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        $('body').trigger('drawerOpen.' + this.config.id);
  
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'true');
        }
  
        this.bindEvents();
      },
  
      close: function() {
        if (!this.isOpen) {
          return;
        }
  
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
  
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
  
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        var o = this;
        window.setTimeout(function() {
          o.$nodes.parent.removeClass(o.config.closingClass);
        }, 500);
  
        this.isOpen = false;
  
        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false');
        }
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
  
        // Clicking body closes drawer
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          if (evt.target === this.$nodes.page[0]) {
            this.close();
            return false;
          }
        }.bind(this));
  
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
  
      unbindEvents: function() {
        slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      }
    });
  
    return Drawer;
  })();
  
  theme.cart = {
    getCart: function() {
      return $.getJSON('/cart.js');
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
  
    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
  
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          $('body').trigger('updateCart', cart);
          return cart;
        }.bind(this))
    },
  
    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };
  
      $.ajax(params);
    },
  
    updateCurrency: function(code) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'currency=' + code,
        dataType: 'json',
        success: function(cart) {
          location.reload(); // required for multi-currency feature to update
        },
        error: function(XMLHttpRequest, textStatus) {}
      };
  
      $.ajax(params);
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }
  
  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function() {
      $(this).addClass('btn--loading');
    });
  
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
  
  
    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  
    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });
  
  theme.AjaxCart = (function() {
    var config = {
      namespace: '.ajaxcart'
    };
  
    var data = {
      itemId: 'data-cart-item-id'
    };
  
    var selectors = {
      form: 'form.cart',
      cartCount: '.cart-link__count',
      updateBtn: '.update-cart',
  
      itemList: '[data-cart-item-list]',
      item: '[data-cart-item]',
      itemId: '[data-cart-item-id]',
      itemHref: '[data-cart-item-href]',
      itemBackgroundImage: '[data-cart-item-background-image]',
      itemTitle: '[data-cart-item-title]',
      itemVariantTitle: '[data-cart-item-variant-title]',
      itemPropertyList: '[data-cart-item-property-list]',
      itemProperty: '[data-cart-item-property]',
      itemDiscountList: '[data-cart-item-discount-list]',
      itemDiscount: '[data-cart-item-discount]',
      itemDiscountTitle: '[data-cart-item-discount-title]',
      itemDiscountAmount: '[data-cart-item-discount-amount]',
      itemLabelQuantity: '[data-cart-item-label-quantity]',
      itemInputQuantity: '[data-cart-item-input-quantity]',
      itemDelete: '[data-cart-item-delete]',
      itemPriceContainer: '[data-cart-item-price-container]',
      itemLinePriceContainer: '[data-cart-item-line-price-container]',
      itemUnitPrice: '[data-cart-item-unit-price]',
      itemMessage: '[data-item-message]',
      cartDiscountContainer: '[data-cart-discount-container]',
      cartDiscountContent: '[data-cart-discount-content]',
      cartDiscount: '[data-cart-discount]',
      cartDiscountTitle: '[data-cart-discount-title]',
      cartDiscountAmount: '[data-cart-discount-amount]',
      cartNoteContainer: '[data-cart-note-container]',
      cartNoteInput: '[data-cart-note]',
      cartMessage: '[data-cart-message]',
      cartSubtotal: '[data-cart-subtotal]',
      cartSubmit: '[data-cart-submit]',
  
      fixedFooter: '.drawer__footer--fixed',
      fixedInnerContent: '.drawer__inner--has-fixed-footer'
    };
  
    var classes = {
      cartHasItems: 'cart-has-items',
      cartTemplate: 'ajax-cart__template',
      cartItemRemove: 'cart__item--remove',
      staticDrawerElement: 'drawer--cart--static'
    };
  
    function AjaxCart(id) {
      this.id = id;
      var $container = this.$container = $('#' + id);
  
      this.status = {
        loaded: false,
        loading: false,
        isDrawer: $container.attr('data-drawer')
      };
  
      if (this.status.isDrawer) {
        this.drawer = new theme.Drawers(id, 'cart');
      }
  
      this.init();
      this.initEventListeners();
    };
  
    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {
      init: function() {
        this.$form = $(selectors.form, this.$container);
        $(selectors.updateBtn, this.$form).addClass('hide');
        this.$itemTemplate = $(selectors.item, this.$form).first().clone();
        this.$propertyTemplate = $(selectors.itemProperty, this.$form).first().clone();
        this.$discountTemplate = $(selectors.itemDiscount, this.$form).first().clone();
        this.$cartDiscountTemplate = $(selectors.cartDiscount, this.$container).first().clone();
      },
  
      initEventListeners: function() {
        $('body').on('updateCart', function(evt, cart) {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart);
            this.updateCartNotification(cart);
  
            // Open cart once updated
            var openDrawer = false;
            if (this.status.isDrawer) {
              this.drawer.open();
              openDrawer = true;
            }
          }.bind(this));
        }.bind(this));
  
        this.$container.on('click', selectors.itemDelete, this._onItemDelete.bind(this));
        this.$container.on('input', selectors.itemInputQuantity, $.debounce(500, this._onItemQuantityChange.bind(this)));
        this.$container.on('blur', selectors.itemInputQuantity, this._onItemQuantityEmptyBlur.bind(this));
        this.$container.on('focus', selectors.itemInputQuantity, this._highlightText);
  
        if (this.status.isDrawer) {
          $('body')
            .on('updateCart' + config.namespace, this.sizeCart.bind(this))
            .on('drawerOpen.' + this.id, function() {
              this.sizeCart();
              setTimeout(function() {
                this.sizeCart();
              }.bind(this), 500);
            }.bind(this));
  
          $(window).on('resize' + config.namespace, $.debounce(150, this.sizeCart.bind(this)));
        }
      },
  
      buildCart: function(cart, openDrawer) {
        this.loading(true);
  
        this.$form.removeClass('cart--empty');
  
        if (cart.item_count === 0) {
          this.$form.addClass('cart--empty');
          this.status.loaded = true;
          this.loading(false);
          return;
        }
  
        // If 3+ items, remove static class for a 100% height cart drawer
        if (cart.items.length > 2) {
          this.$container.removeClass(classes.staticDrawerElement);
        } else {
          this.$container.addClass(classes.staticDrawerElement);
        }
  
        var $cart = this._createCart(cart);
        morphdom(this.$form[0], $cart[0]);
  
        if (theme.settings.currenciesEnabled) {
          theme.currencySwitcher.ajaxrefresh();
        }
  
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
  
          // Resize footer after arbitrary delay to account for checkout buttons
          if (this.status.isDrawer) {
            setTimeout(function() {
              this.sizeCart();
            }.bind(this), 1000);
          }
        }
  
        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (this.status.isDrawer) {
          if (openDrawer === true) {
            this.drawer.open();
          }
        }
  
        this.status.loaded = true;
        this.loading(false);
  
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
      },
  
      _createCart: function(cart) {
        var $form = this.$form.clone();
  
        $(selectors.item, $form)
          .not(selectors.cartNoteContainer)
          .remove();
  
        $(selectors.itemList, $form)
          .prepend(this._createItemList(cart));
  
        $(selectors.cartNoteInput, $form)
          .val(cart.note);
  
        $(selectors.cartDiscountContainer, $form)
          .toggleClass('hide', cart.cart_level_discount_applications.length === 0);
  
        $(selectors.cartDiscountContent, $form).html(
          this._createCartDiscountList(cart));
  
        $(selectors.cartSubtotal, $form)
          .html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));

        //console.log("_createCart", selectors.cartSubmit);  
  
        $(selectors.cartSubmit, $form).attr('disabled', true);
        //$(selectors.cartSubmit, $form).attr('disabled', 
        // cart.items.length === 0true);
  
        return $form;
      },
  
      _createItemList: function(cart) {
        return $.map(cart.items, function(item) {
          var $item = this.$itemTemplate.clone().removeClass(classes.cartTemplate);
          var propertyList = this._createPropertyList(item);
          var discountList = this._createDiscountList(item);
          var unitPrice = this._createUnitPrice(item);
  
          var itemPrice = this._createItemPrice(
            item.original_price,
            item.final_price
          );
  
          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price
          );
  
          $item.find(selectors.itemId)
            .addBack(selectors.itemId)
            .attr(data.itemId, item.key);
  
          $(selectors.itemHref, $item)
            .attr('href', item.url);
  
          $(selectors.itemBackgroundImage, $item)
            .removeAttr('data-bgset')
            .css('background-image', item.image ? 'url(' + theme.Images.getSizedImageUrl(item.image, '200x') + ')' : 'none')
            .addClass('lazyload');
  
          $(selectors.itemTitle, $item).text(item.product_title);
  
          $(selectors.itemVariantTitle, $item).text(item.variant_title);
  
          $(selectors.itemPriceContainer, $item).html(itemPrice);
  
          $(selectors.itemLinePriceContainer, $item).html(itemLinePrice);
  
          $(selectors.itemLinePrice, $item)
            .html(theme.Currency.formatMoney(item.line_price, theme.settings.moneyFormat));
  
          $(selectors.itemLabelQuantity, $item)
            .attr('for', 'quantity_' + item.key);
  
          $(selectors.itemInputQuantity, $item)
            .attr('name', 'updates[' + item.key + ']')
            .attr('id', 'quantity_' + item.key)
            .val(item.quantity);
  
          $(selectors.itemPropertyList, $item)
            .html(propertyList);
  
          $(selectors.itemDiscountList, $item)
            .html(discountList);
  
          $(selectors.itemUnitPrice, $item)
            .html(unitPrice);
  
          return $item[0];
        }.bind(this));
      },
  
      _createItemPrice: function(original_price, final_price) {
        if (original_price !== final_price) {
          return (
            '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>' +
            '<del class="cart__item-price--original">' +
            theme.Currency.formatMoney(original_price, theme.settings.moneyFormat) +
            '</del>' +
            '<span class="visually-hidden">' + theme.strings.salePrice + '</span>' +
            '<span class="cart__item-price cart__item-price--bold">' +
            theme.Currency.formatMoney(final_price, theme.settings.moneyFormat) +
            '</span>'
          );
        } else {
          return (
            '<span class="cart__item-price">' + theme.Currency.formatMoney(original_price, theme.settings.moneyFormat) + '</span>'
          );
        }
      },
  
      _createPropertyList: function(item) {
        return $.map(item.properties, function(value, key) {
          var $property = this.$propertyTemplate.clone().removeClass(classes.cartTemplate);
  
          // Line item properties prefixed with an underscore are not to be displayed
          if (key.charAt(0) === '_') return;
  
          // Line item properties with no value are not to be displayed
          if (value === '') return;
  
          if (value.indexOf('/uploads/') === -1) {
            $property
              .text(key + ': ' + value);
          } else {
            $property
              .html(key + ': <a href="' + value + '">' + value.split('/').pop() + '</a>');
          }
  
          return $property[0];
        }.bind(this));
      },
  
      _createDiscountList: function(item) {
        return $.map(item.line_level_discount_allocations, function(discount) {
          var $discount = this.$discountTemplate.clone().removeClass(classes.cartTemplate);
  
          $discount
            .find(selectors.itemDiscountTitle)
            .text(discount.discount_application.title);
          $discount
            .find(selectors.itemDiscountAmount)
            .html(theme.Currency.formatMoney(discount.amount, theme.settings.moneyFormat));
  
          return $discount[0];
        }.bind(this));
      },
  
      _createCartDiscountList: function(cart) {
        return $.map(
          cart.cart_level_discount_applications,
          function(discount) {
            var $discount = this.$cartDiscountTemplate.clone().removeClass(classes.cartTemplate);
  
            $discount.find(selectors.cartDiscountTitle)
              .text(discount.title);
            $discount
              .find(selectors.cartDiscountAmount)
              .html(theme.Currency.formatMoney(discount.total_allocated_amount, theme.settings.moneyFormat));
  
            return $discount[0];
          }.bind(this)
        );
      },
  
      _createUnitPrice: function(item) {
        var price = theme.Currency.formatMoney(item.unit_price, theme.settings.moneyFormat);
        var base = theme.Currency.getBaseUnit(item);
  
        return price + '/' + base;
      },
  
      _onItemQuantityChange: function(evt) {
        this.loading(true);
  
        var $input = $(evt.target);
        var id = $input.closest(selectors.item).attr(data.itemId);
        var quantity = $input.val();
  
        // Don't update the cart when a input is empty. Also make sure an input
        // does not remain empty by checking blur event
        if (quantity === '') { return; }
  
        if (quantity == 0) {
          var response = confirm(theme.strings.cartConfirmDelete);
          if (response === false) {
            $input.val(1);
            this.loading(false);
            return;
          }
        }
  
        theme.cart.changeItem(id, quantity);
      },
  
      _onItemQuantityEmptyBlur: function(evt) {
        var $input = $(evt.target);
        var id = $input.closest(selectors.item).attr(data.itemId);
        var value = $input.val();
  
        if (value !== '') { return; }
  
        theme.cart.getCart().then(function(cart) {
          this.buildCart(cart);
        }.bind(this));
      },
  
      _onItemDelete: function(evt) {
        evt.preventDefault();
  
        var $deleteButton = $(evt.target);
        var $items = $(selectors.item, this.$container);
        var $item = $deleteButton.closest(selectors.item);
        var $note = $(selectors.cartNoteContainer, this.$container);
        var id = $item.attr(data.itemId);
  
        if ($items.length === 2 && $items.last().is($note)) {
          $note.addClass(classes.cartItemRemove);
  
          slate.a11y.promiseTransitionEnd($(selectors.itemList, this.$container)).then(function() {
            $note.removeClass(classes.cartItemRemove);
          });
        }
  
        $item.addClass(classes.cartItemRemove);
  
        slate.a11y.promiseAnimationEnd($item).then(function() {
          theme.cart.changeItem(id, 0);
        }.bind(this));
      },
  
      loading: function(state) {
        this.status.loading = state;
  
        if (state) {
          $(selectors.itemList, this.$form).addClass('loading');
        } else {
          $(selectors.itemList, this.$form).removeClass('loading');
        }
      },
  
      sizeCart: function() {
        // If drawer cart is set to static, measure to make sure it should
        // stay that way
        if (this.$container.hasClass(classes.staticDrawerElement)) {
          // Add static class, measure, and decide if we need to add it back
          this.$container.addClass(classes.staticDrawerElement);
  
          // If cart is taller than window, remove static class so
          // elements become absolute and items scrollable
          if (this.$container.height() >= window.innerHeight) {
            this.$container.removeClass(classes.staticDrawerElement);
          }
        }
  
        // Stop if our drawer doesn't have a fixed footer
        if (!this.$container.hasClass('drawer--has-fixed-footer')) {
          return;
        }
  
        // Elements are reprinted regularly so selectors are not cached
        var $cartFooter = this.$container.find(selectors.fixedFooter).removeAttr('style');
        var $cartInner = this.$container.find(selectors.fixedInnerContent).removeAttr('style');
        var cartFooterHeight = $cartFooter.outerHeight();
  
        $cartInner.css('bottom', cartFooterHeight);
        $cartFooter.css('height', cartFooterHeight);
      },
  
      updateCartNotification: function(cart) {
        $(selectors.cartCount).text(cart.item_count);
        $('body').toggleClass(classes.cartHasItems, cart.item_count > 0);
      },
  
      _highlightText: function(evt) {
        // Don't want the mobile tooltip to pop up
        if (!theme.config.isTouch) {
          $(evt.target).select();
        }
      }
    });
  
    return AjaxCart;
  })();
  
  theme.StickyCart = (function() {
    var config = {
      namespace: '.ajaxcart'
    };
  
    var selectors = {
      cart: '#StickyCart',
      items: '#StickyItems',
      subtotal: '#StickySubtotal',
      submit: '#StickySubmit'
    };
  
    var classes = {
      cartTemplate: 'template-cart',
      active: 'sticky-cart--open',
      activeBodyClass: 'body--sticky-cart-open'
    };
  
    function StickyCart() {
      this.status = {
        loaded: false,
        loading: false,
        open: $('body').hasClass(classes.activeBodyClass)
      };
  
      this.initEventListeners();
    };
  
    function refresh(cart) {
      if ($('body').hasClass(classes.cartTemplate)) {
        return;
      }
  
      if (cart.item_count > 0) {
        $('body').addClass(classes.activeBodyClass);
        $(selectors.cart).addClass(classes.active);
      } else {
        $('body').removeClass(classes.activeBodyClass);
        $(selectors.cart).removeClass(classes.active);
      }
  
      $(selectors.items).text(theme.strings.cartItems.replace('[count]', cart.item_count));
      $(selectors.subtotal).html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));
  
      if (theme.settings.currenciesEnabled) {
        theme.currencySwitcher.ajaxrefresh();
      }
    };
  
    StickyCart.prototype = $.extend({}, StickyCart.prototype, {
      initEventListeners: function() {
        $(selectors.submit).on('click', function() {
          $(this).addClass('btn--loading');
        });
  
        $('body').on('added.ajaxProduct', function() {
          this.hideCart();
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, true);
          }.bind(this));
        }.bind(this));
      },
  
      hideCart: function() {
        $('body').removeClass(classes.activeBodyClass);
        $(selectors.cart).removeClass(classes.active);
      },
  
      showCart: function(count, subtotal) {
        if (count) {
          $(selectors.items).text(theme.strings.cartItems.replace('[count]', count));
        }
        if (subtotal) {
          $(selectors.subtotal).html(theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat));
        }
  
        $('body').addClass(classes.activeBodyClass);
        $(selectors.cart).addClass(classes.active);
  
        this.status.open = true;
  
        if (theme.settings.currenciesEnabled) {
          theme.currencySwitcher.ajaxrefresh();
        }
      },
  
      buildCart: function(cart, open) {
        this.loading(true);
  
        this.status.loaded = true;
        this.loading(false);
  
        // If specifically asked, open the cart (only happens after product added from form)
        if (open === true) {
          this.showCart(cart.item_count, cart.total_price);
        }
      },
  
      loading: function(state) {
        this.status.loading = state;
  
        if (state) {
          $(selectors.cart).addClass('is-loading');
        } else {
          $(selectors.cart).removeClass('is-loading');
        }
      },
  
      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
        }
      }
    });
  
    return {
      init: StickyCart,
      refresh: refresh
    }
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');
      this.productId = $form.find('[name="data-product-id"]').val();
  
      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();
  
        if (status.loading) {
          return;
        }
  
        this.$form.find('[data-add-to-cart]').addClass('btn--loading');
  
        status.loading = true;
  
        var data = this.$form.serialize();
  
        $('body').trigger('added.ProductScreen-' + this.productId);
  
        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.success(product);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$form.find('[data-add-to-cart]').removeClass('btn--loading');
          }.bind(this));
      },
  
      success: function(product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct');
        document.dispatchEvent(new CustomEvent('added:ajaxProduct', {
          detail: {
            product: product
          }
        }));
      },
  
      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();
  
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
  
          $('body').trigger('error.ProductScreen-' + this.productId);
  
          document.dispatchEvent(new CustomEvent('error:ajaxProduct', {
            detail: {
              errorMessage: XMLHttpRequest.responseJSON.description
            }
          }));
  
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });
  
    return ProductForm;
  })();
  
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
  
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
  
      $('body')
        .off(namespace)
        .on('click' + namespace, selectors.trigger, function() {
        if (isTransitioning) {
          return;
        }
  
        isTransitioning = true;
  
        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var isTab = $el.hasClass(classes.tabs);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);
  
        if (isTab) {
          if (isOpen) {
            isTransitioning = false;
            return;
          }
  
          var $newModule;
          // If tab, close all other tabs with same ID before opening
          $(selectors.tabs + '[data-id=' + $el.data('id') + ']').each(function() {
            $(this).removeClass(classes.open);
            $newModule = $('#' + $(this).attr('aria-controls'));
            setTransitionHeight($newModule, 0, true);
          });
        }
  
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }
  
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
  
        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);
  
        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }
  
    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
  
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 0);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  theme.headerNav = (function() {
  
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      thumbMenu: '.site-nav__thumb-menu'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
      stickyCartActive: 'body--sticky-cart-open',
      overlayEnabledClass: 'header-wrapper--overlay',
      overlayedClass: 'is-light',
      thumbMenuInactive: 'site-nav__thumb-menu--inactive',
      stickyClass: 'site-header--sticky',
      overlayStickyClass: 'header-wrapper--sticky',
      openTransitionClass: 'site-header--opening'
    };
  
    var config = {
      namespace: '.siteNav',
      overlayHeader: false,
      stickyActive: false,
      forceStickyOnMobile: false,
      forceCloseThumbNav: false
    };
  
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;
  
    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
  
      config.overlayHeader = theme.settings.overlayHeader = $siteHeader.data('overlay');
  
      accessibleDropdowns();
      var searchModal = new theme.Modals('SearchModal', 'search-modal', {
        closeOffContentClick: false,
        focusOnOpen: '#SearchModalInput'
      });
  
      // One listener for all header-related resize and load functions
      $window
        .on('resize' + config.namespace, $.debounce(150, headerResize))
        .on('load' + config.namespace, headerLoad);
  
      // Determine type of header:
        // desktop: sticky bar | sticky button | top only
        // mobile: always sticky button
      setHeaderStyle();
  
      // Sticky menu (bar or thumb) on scroll
      $window.on('scroll' + config.namespace, $.throttle(150, stickyMenuOnScroll));
  
      // Make sure sticky nav appears after header is reloaded in editor
      if (Shopify.designMode) {
        $window.trigger('resize');
      }
    }
  
    function headerLoad() {
      resizeLogo();
      initStickyThumbMenu();
  
      if (config.headerStyle === 'bar') {
        initStickyBarMenu();
      }
    }
  
    function headerResize() {
      resizeLogo();
      setHeaderStyle();
  
      if (config.headerStyle === 'bar') {
        initStickyBarMenu();
      }
    }
  
    function setHeaderStyle() {
      if (theme.config.bpSmall) {
        config.headerStyle = 'button';
      } else {
        config.headerStyle = $wrapper.data('header-style');
      }
  
      config.stickyThreshold = config.headerStyle === 'button' ? 100 : 250;
  
      if (config.headerStyle !== 'button') {
        toggleThumbMenu(false);
      }
    }
  
    function unload() {
      $(window).off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }
  
    function resizeLogo() {
      // Using .each() because of possible reversed color logo
      $(selectors.logo).each(function() {
        var $el = $(this),
            logoWidthOnScreen = $el.width(),
            containerWidth = $el.closest('.grid__item').width();
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          $el.css('maxWidth', containerWidth);
        }
        else {
          $el.removeAttr('style');
        }
      });
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
  
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
  
          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
      }
  
      // Open/hide top level dropdowns
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown($(this));
      });
  
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeDropdowns();
      });
  
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        closeThirdLevelDropdown();
        openSecondLevelDropdown($(this), true);
      });
  
      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }
  
      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }
  
      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }
  
    function initStickyBarMenu() {
      $siteHeader.wrap('<div class="site-header-sticky"></div>');
  
      // No need to set a height on wrapper if positioned absolutely already
      if (config.overlayHeader) {
        return;
      }
  
      stickyHeaderHeight();
      setTimeout(function() {
        stickyHeaderHeight();
  
        // Don't let height get stuck on 0
        if ($('.site-header-sticky').outerHeight() === 0) {
          setTimeout(function() {
            $window.trigger('resize');
          }, 500);
        }
      }, 200);
  
      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
    }
  
    function stickyHeaderHeight() {
      $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
    }
  
    function initStickyThumbMenu() {
      if ($('body').hasClass(classes.stickyCartActive)) {
        return;
      }
  
      if (theme.config.bpSmall && theme.template !== 'product') {
        setTimeout(function() {
          config.forceStickyOnMobile = true;
          toggleThumbMenu(true);
        }, 25);
      }
    }
  
    function stickyMenuOnScroll(evt) {
      var scroll = $window.scrollTop();
  
      if (scroll > config.stickyThreshold) {
        if (config.forceStickyOnMobile) {
          config.forceStickyOnMobile = false;
        }
  
        if (config.stickyActive) {
          return;
        }
  
        if (config.headerStyle === 'button') {
          toggleThumbMenu(true);
        } else if (config.headerStyle === 'bar') {
          toggleBarMenu(true);
        }
      } else {
        // If menu is shown on mobile page load, do not
        // automatically hide it when you start scrolling
        if (config.forceStickyOnMobile) {
          return;
        }
  
        if (!config.stickyActive) {
          return;
        }
  
        if (config.headerStyle === 'button') {
          if (!theme.config.bpSmall) {
            toggleThumbMenu(false);
          }
        } else if (config.headerStyle === 'bar') {
          toggleBarMenu(false);
        }
      }
    }
  
    function toggleThumbMenu(active, forceClose) {
      // If forced close, will not open again until page refreshes
      // because sticky nav is open
      if (config.forceCloseThumbNav) {
        return;
      }
  
      // If thumb menu is open, do not hide menu button
      if ($('.slide-nav__overflow--thumb').hasClass('js-menu--is-open')) {
        return;
      }
  
      $(selectors.thumbMenu).toggleClass(classes.thumbMenuInactive, !active);
      config.stickyActive = active;
  
      config.forceCloseThumbNav = forceClose;
    }
  
    function toggleBarMenu(active) {
      if (config.headerStyle !== 'bar') {
        return;
      }
  
      if (active) {
        $siteHeader.addClass(classes.stickyClass);
        if (config.overlayHeader) {
          $wrapper
            .removeClass(classes.overlayedClass)
            .addClass(classes.overlayStickyClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          $siteHeader.addClass(classes.openTransitionClass);
        }, 100);
      } else {
        $siteHeader.removeClass(classes.openTransitionClass).removeClass(classes.stickyClass);
  
        if (config.overlayHeader) {
          $wrapper
            .addClass(classes.overlayedClass)
            .removeClass(classes.overlayStickyClass);
        }
      }
  
      config.stickyActive = active;
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(classes.overlayEnabledClass)
        .removeClass(classes.overlayedClass);
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      toggleThumbMenu: toggleThumbMenu,
      unload: unload
    };
  })();
  
  theme.slideNav = (function() {
  
    var selectors = {
      container: '#PageContainer',
      navWrapper: '.slide-nav__overflow',
      nav: '#SlideNav',
      toggleBtn: '.js-toggle-slide-nav',
      subNavToggleBtn: '.js-toggle-submenu',
      thumbNavToggle: '.site-nav__thumb-button'
    };
  
    var classes = {
      subNavLink: 'slide-nav__sublist-link',
      return: 'slide-nav__return-btn',
      isActive: 'is-active',
      isOpen: 'js-menu--is-open',
      subNavShowing: 'sub-nav--is-open',
      thirdNavShowing: 'third-nav--is-open'
    };
  
    var namespace = '.slideNav';
  
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var pageSlide = true;
    var menuLevel = 1;
  
    function init() {
      if ($(selectors.thumbNavToggle).length) {
        pageSlide = false;
      }
  
      $(selectors.toggleBtn).on('click' + namespace, toggleNav);
      $(selectors.subNavToggleBtn).on('click' + namespace, toggleSubNav);
    }
  
    function toggleNav() {
      if ($(selectors.toggleBtn).hasClass(classes.isActive)) {
        closeNav();
      } else {
        openNav();
      }
    }
  
    function openNav() {
      $(selectors.toggleBtn).addClass(classes.isActive);
  
      $(selectors.navWrapper).prepareTransition().addClass(classes.isOpen);
  
      if (pageSlide) {
        $(selectors.container).css({
          transform:
            'translate3d(0, ' + $(selectors.navWrapper).height() + 'px, 0)'
        });
      }
  
      $(selectors.navWrapper).attr('tabindex', '-1').focus();
  
      // close on escape
      $(window).on('keyup' + namespace, function(evt) {
        if (evt.which === 27) {
          closeNav();
        }
      });
    }
  
    function closeNav() {
      $(selectors.toggleBtn).removeClass(classes.isActive);
      $(selectors.navWrapper).prepareTransition().removeClass(classes.isOpen);
  
      if (pageSlide) {
        $(selectors.container).removeAttr('style');
      }
  
      $(selectors.toggleBtn).focus();
  
      $(window).off('keyup' + namespace);
    }
  
    function toggleSubNav(evt) {
      if (isTransitioning) {
        return;
      }
  
      var $toggleBtn = $(evt.currentTarget);
      var isReturn = $toggleBtn.hasClass(classes.return);
      isTransitioning = true;
  
      if (isReturn) {
        // Close all subnavs by removing active class on buttons
        $(
          classes.toggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
        ).removeClass(classes.isActive);
        $('.slide-nav__dropdown[data-level="' + (menuLevel) + '"]').prepareTransition().removeClass(classes.isActive);
  
        if ($activeTrigger && $activeTrigger.length) {
          $activeTrigger.removeClass(classes.isActive);
        }
      } else {
        $toggleBtn.addClass(classes.isActive);
        $toggleBtn.next('.slide-nav__dropdown').prepareTransition().addClass(classes.isActive);
      }
  
      $activeTrigger = $toggleBtn;
  
      goToSubnav($toggleBtn.data('target'));
    }
  
    function goToSubnav(target) {
      var $targetMenu = target
        ? $('.slide-nav__dropdown[data-parent="' + target + '"]')
        : $(selectors.nav);
  
      menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;
  
      $activeSubNav = $targetMenu;
  
      var $elementToFocus = target
        ? $targetMenu.find('.' + classes.subNavLink + ':first')
        : $activeTrigger;
  
      var translateMenuHeight = $targetMenu.outerHeight();
  
      var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
  
      $(selectors.navWrapper)
        .css('height', translateMenuHeight)
        .removeClass(classes.thirdNavShowing)
        .addClass(openNavClass);
  
      if (!target) {
        // Show top level nav
        $(selectors.navWrapper)
          .removeClass(classes.thirdNavShowing)
          .removeClass(classes.subNavShowing);
      }
  
      isTransitioning = false;
  
      // Match height of subnav
      if (pageSlide) {
        $(selectors.container).css({
          transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)'
        });
      }
    }
  
    function unload() {
      $(window).off(namespace);
      $(selectors.toggleBtn).off(namespace);
      $(selectors.subNavToggleBtn).off(namespace);
    }
  
    return {
      init: init,
      unload: unload
    };
  })();
  
  theme.articleImages = (function() {
  
    var cache = {};
  
    function init() {
      cache.$rteImages = $('.rte--indented-images');
  
      if (!cache.$rteImages.length) {
        return;
      }
  
      $(window).on('load', setImages);
    }
  
    function setImages() {
      cache.$rteImages.find('img').each(function() {
        var $el = $(this);
        var attr = $el.attr('style');
  
        // Check if undefined or float: none
        if (!attr || attr == 'float: none;') {
          // Remove grid-breaking styles if image isn't wider than parent
          if ($el.width() < cache.$rteImages.width()) {
            $el.addClass('rte__no-indent');
          }
        }
      });
    }
  
    return {
      init: init
    };
  })();
  
  theme.Slideshow = (function() {
    this.$slideshow = null;
  
    var classes = {
      next: 'is-next',
      init: 'is-init',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };
  
    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
  
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        draggable: true,
        touchThreshold: 8,
        speed: 300,
        pauseOnHover: args.pauseOnHover ? true : false,
        autoplay: this.$slideshow.data('autoplay'),
        autoplaySpeed: this.$slideshow.data('speed')
      };
  
      this.$slideshow.on('init', this.init.bind(this));
  
      // Refresh main page slideshow
      if ($('.root').find(this.$slideshow).length) {
        $('body').on('productModalClose', function() {
          this.$slideshow.addClass('slideshow-refresh');
          this.$slideshow.slick('refresh');
        }.bind(this));
      }
  
      this.$slideshow.slick(this.settings);
  
      this.$pause.on('click', this._togglePause.bind(this));
    }
  
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
  
        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },
  
      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
  
      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
  
      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
  
        if (!$list) {
          return;
        }
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
  
        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
  
      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;
  
        $slideshow.find('.slick-slide').each(function(index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
  
            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');
  
              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
  
            }, this.settings.autoplaySpeed / 1.5);
  
          }
        }.bind(this));
      }
    });
  
    return slideshow;
  })();
  
  theme.currencySwitcher = (function() {
  
    var selectors = {
      dataDiv: '#CurrencyData',
      currencyOptions: '.currency-options__btn',
      pickerFlag: '#CurrencyFlag',
      pickerLabel: '#CurrencyLabel'
    };
  
    var data = {};
    var modal;
  
    function init() {
      var $dataDiv = $(selectors.dataDiv);
  
      if (!$dataDiv.length) {
        return;
      }
  
      modal = new theme.Modals('CurrencyModal', 'currency-modal', {
        closeOffContentClick: false
      });
  
      $(selectors.currencyOptions).on('click', setNewCurrency);
  
      data = {
        currency: $dataDiv.data('shop-currency'),
        format: $dataDiv.data('format'),
        moneyFormat: $dataDiv.data('money-format'),
        moneyCurrencyFormat: $dataDiv.data('money-currency-format')
      };
  
      if (!theme.settings.nativeMultiCurrency) {
        Currency.format = data.format;
  
        // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
        Currency.money_format[data.currency] = data.moneyFormat;
        Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;
  
        // Fix for customer account page
        $('span.money span.money').each(function() {
          $(this).parents('span.money').removeClass('money');
        });
  
        // Save current price
        $('span.money').each(function() {
          $(this).attr('data-currency-' + data.currency, $(this).html());
        });
  
        checkCookie();
      }
    }
  
    function setNewCurrency() {
      var newCurrency = $(this).data('value');
  
      if (theme.settings.nativeMultiCurrency) {
        $(this).addClass('is-active');
        theme.cart.updateCurrency(newCurrency);
        return;
      }
  
      if (newCurrency !== data.currency) {
        data.currency = newCurrency;
        $(selectors.dataDiv).data('current-currency', newCurrency);
        updatePicker(newCurrency);
  
        refresh();
      }
  
      modal.close();
    }
  
    function updatePicker(currency) {
      $(selectors.pickerFlag).attr('data-flag', currency);
      $(selectors.pickerLabel).text(currency);
  
      // Update modal options active states
      $(selectors.currencyOptions).removeClass('is-active');
      $(selectors.currencyOptions + '[data-value=' + currency + ']').addClass('is-active');
    }
  
    // Refresh functions only needed when not using native multi-currency
    function refresh() {
      if (theme.settings.nativeMultiCurrency) {
        return;
      }
  
      var newCurrency = $(selectors.dataDiv).data('current-currency');
      Currency.convertAll(Currency.currentCurrency, newCurrency);
    }
  
    function ajaxrefresh() {
      if (theme.settings.nativeMultiCurrency) {
        return;
      }
  
      var shopCurrency = $(selectors.dataDiv).data('shop-currency');
      var newCurrency = $(selectors.dataDiv).data('current-currency');
      // Ajax cart always returns shop's currency, not what theme settings defines
      Currency.convertAll(shopCurrency, newCurrency);
    }
  
    function checkCookie() {
      var cookieCurrency = Currency.cookie.read();
  
      if (cookieCurrency == null) {
        Currency.currentCurrency = cookieCurrency = data.currency;
      } else if ($(selectors.currencyOptions).length && $(selectors.currencyOptions + '[data-value=' + cookieCurrency + ']').length === 0) {
        // If the cookie value does not correspond to any value in the currency dropdown
        Currency.currentCurrency = data.currency;
        Currency.cookie.write(data.currency);
      } else if (cookieCurrency === data.currency) {
        Currency.currentCurrency = data.currency;
      } else {
        Currency.convertAll(data.currency, cookieCurrency);
      }
  
      // Update current currency with cookie value
      $(selectors.dataDiv).data('current-currency', cookieCurrency);
      data.currency = cookieCurrency;
      updatePicker(cookieCurrency);
    }
  
    return {
      init: init,
      refresh: refresh,
      ajaxrefresh: ajaxrefresh
    };
  })();
  
  /*
    Quick shop modals, or product screens, live inside
    product-grid-item markup until page load, where they're
    moved to #ProductScreens at the bottom of the page
   */
  
  theme.QuickShopScreens = (function() {
  
    var startingUrl = window.location.pathname;
    var currentPath = startingUrl;
    var prevPath = null;
    var currentScreen = null;
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  
    var selectors = {
      screensWrap: '#ProductScreens',
      screens: '[data-product-id]',
      trigger: '.quick-product__btn'
    };
  
    var activeIds = [];
  
    function init(container) {
      if (!theme.settings.quickView) {
        return;
      }
  
      var productIds = getProductIds();
      initProductScreens(productIds);
      initHistoryWatcher();
    }
  
    function initHistoryWatcher() {
      // No need to adjust URL in the editor since it handles the navigation
      if (Shopify.designMode) {
        return;
      }
  
      // Listen for product screens opening
      $(window).on('newPopstate', function(evt, data) {
        currentScreen = data.screen;
        // Manually trigger back, comes from esc key or close btns
        if (data.back) {
          prevPath = location.pathname;
          currentPath = startingUrl;
          history.pushState({}, '', startingUrl);
        }
  
        if (data.url) {
          if (data.updateCurrentPath) {
            prevPath = location.pathname;
            currentPath = data.url;
            history.pushState({}, '', data.url);
          }
        }
      });
  
      $(window).on('popstate', function(evt) {
        var goToUrl = false;
        prevPath = currentPath;
  
        // Hash change or no change, let browser take over
        if (location.pathname === currentPath) {
          return;
        }
  
        prevPath = currentPath;
        currentPath = location.pathname;
  
        // Back to where we started. Close existing screen if open
        if (location.pathname === startingUrl) {
          if (currentScreen && currentScreen.isOpen) {
            closeScreen(currentScreen);
          }
          return;
        }
  
        // Opening product
        if (location.pathname.indexOf('/products/') !== -1) {
          if (currentScreen) {
            currentScreen.open();
          } else {
            // No screen sent to function, trigger new click
            $('.quick-product__btn[href="'+ location.pathname +'"]').first().trigger('click', { updateCurrentPath: false });
          }
  
          return;
        }
  
        if (evt.originalEvent.state) {
          if (currentScreen && currentScreen.isOpen) {
            closeScreen(currentScreen);
            history.replaceState({}, '', startingUrl);
            return;
          }
  
          goToUrl = true;
        } else {
          if (currentScreen) {
            if (currentScreen.isOpen) {
              closeScreen(currentScreen);
              return;
            }
          } else {
            // No state/modal. Navigate to where browser wants
            goToUrl = true;
          }
        }
  
        // Fallback if none of our conditions are met
        if (goToUrl) {
          window.location.href = location.href;
        }
      }.bind(this));
    }
  
    function closeScreen(screen) {
      screen.close();
      currentScreen = null;
      $(window).trigger('resize');
    }
  
    function getProductIds($scope) {
      var ids = [];
  
      var $triggers = $scope ? $(selectors.trigger, $scope) : $(selectors.trigger);
  
      $triggers.each(function() {
        var id = $(this).data('product-id');
  
        // If another identical modal exists, remove from DOM
        if (ids.indexOf(id) > -1) {
          $('.screen-layer--product[data-product-id="' + id + '"]').slice(1).remove();
          return;
        }
  
        ids.push(id);
      });
  
      return ids;
    }
  
    function getIdsFromTriggers($triggers) {
      var ids = [];
  
      $triggers.each(function() {
        var id = $(this).data('product-id');
        ids.push(id);
      });
  
      return ids;
    }
  
    function initProductScreens(ids) {
      var screenId;
      var $screenLayer;
      var screens = [];
  
      // Init screens if they're not duplicates
      for (var i = 0; i < ids.length; i++) {
        if (activeIds.indexOf(ids[i]) === -1) {
          screenId = 'ProductScreen-' + ids[i];
          $screenLayer = $('#' + screenId);
  
          screens.push($screenLayer);
          activeIds.push(ids[i]);
          new theme.ProductScreen(screenId, 'product-' + ids[i]);
        }
      }
  
      // Append screens to bottom of page
      $(selectors.screensWrap).append(screens);
    }
  
    // Section unloaded in theme editor.
    // Check if product exists in any other area
    // of the page, remove other's section.instance
    function unload($container) {
      if (!theme.settings.quickView) {
        return;
      }
  
      var removeIds = [];
      var productIds = getProductIds($container);
  
      // Get ids from buttons not in removed section
      var $activeButtons = $(selectors.trigger).not($(selectors.trigger, $container));
      var stillActiveIds = getIdsFromTriggers($activeButtons);
  
      // If ID exists on active button, do not add to IDs to remove
      for (var i = 0; i < productIds.length; i++) {
        var id = productIds[i];
        if (stillActiveIds.indexOf(id) === -1) {
          removeIds.push(id);
        }
      }
  
      for (var i = 0; i < removeIds.length; i++) {
        sections._removeInstance(removeIds[i]);
      }
    }
  
    // Section container is sent, so must re-scrape for product IDs
    function reInit($container) {
      if (!theme.settings.quickView) {
        return;
      }
  
      var newProductIds = getProductIds($container);
      initProductScreens(newProductIds);
      removeDuplicateModals(newProductIds, $container);
  
      // Re-register product templates in quick view modals.
      // Will not double-register.
      sections.register('product-template', theme.Product, $('#ProductScreens'));
    }
  
    function removeDuplicateModals(ids, $container) {
      for (var i = 0; i < ids.length; i++) {
        $('.screen-layer--product[data-product-id="' + ids[i] + '"]', $container).remove();
      }
    }
  
    return {
      init: init,
      unload: unload,
      reInit: reInit
    };
  })();
  
  /*
    Hover to enable slideshow of product images.
    On mobile slideshow starts as item is in view.
    Destroy on mouseout/out of view.
   */
  
  theme.HoverProductGrid = (function() {
    var selectors = {
      product: '.grid-product',
      slider: '.product-slider',
    };
  
    function HoverProductGrid($container) {
      this.$container = $container;
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.product-image-slider-' + this.sectionId;
      this.activeIds = [];
  
      if (!theme.settings.hoverProductGrid) {
        return;
      }
  
      this.$products = $container.find(selectors.product);
      this.slidersMobile = $container.data('product-sliders-mobile');
  
      // No products means no sliders
      if (this.$products.length === 0) {
        return;
      }
  
      slate.utils.promiseStylesheet().then(function() {
        this.init();
      }.bind(this));
    }
  
    HoverProductGrid.prototype = $.extend({}, HoverProductGrid.prototype, {
      init: function() {
        this.destroyAllSliders();
        this.setupEventType();
        this.listnerSetup();
      },
  
      setupEventType: function() {
        this.$products.off('mouseenter mouseout');
        $(window).off('scroll' + this.namespace);
  
        if (theme.config.bpSmall) {
          if (this.slidersMobile) {
            $(window).on('scroll' + this.namespace, $.throttle(120, this.inViewSliderInit.bind(this)));
            $(window).trigger('scroll' + this.namespace);
          }
        } else {
          this.mouseSliderInit();
        }
      },
  
      listnerSetup: function() {
        $('body').on('matchSmall matchLarge', function() {
          this.destroyAllSliders();
          this.setupEventType();
        }.bind(this));
      },
  
      inViewSliderInit: function() {
        this.$products.find(selectors.slider).each(function(i, el) {
          if(theme.isElementVisible($(el), -400)) {
            this.initSlider($(el));
          } else {
            this.destroySlider($(el));
          }
        }.bind(this));
      },
  
      mouseSliderInit: function() {
        this.$products.on('mouseenter', function(evt) {
          var $slider = $(evt.currentTarget).find(selectors.slider);
          this.initSlider($slider);
        }.bind(this));
  
        this.$products.on('mouseleave', function(evt) {
          var $slider = $(evt.currentTarget).find(selectors.slider);
          this.destroySlider($slider);
        }.bind(this));
      },
  
      initSlider: function($slider) {
        if ($slider.data('image-count') < 2) {
          return;
        }
  
        if (this.activeIds.indexOf($slider.data('id')) !== -1) {
          return;
        }
  
        this.activeIds.push($slider.data('id'));
  
        $slider
          .addClass('product-slider--init')
          .slick({
            autoplay: true,
            infinite: true,
            arrows: false,
            speed: 300,
            fade: true,
            pauseOnHover: false,
            autoplaySpeed: 1050
          });
      },
  
      destroySlider: function($slider) {
        if ($slider.data('image-count') < 2) {
          return;
        }
  
        var alreadyActive = this.activeIds.indexOf($slider.data('id'));
        if (alreadyActive !== -1) {
          this.activeIds.splice(alreadyActive, 1);
          $slider.slick('unslick');
        }
      },
  
      destroyAllSliders: function() {
        this.$products.find(selectors.slider).each(function(i, el) {
          this.destroySlider($(el));
        }.bind(this));
      }
    });
  
    return HoverProductGrid;
  })();
  
  theme.videoModal = function() {
    var videoModalPlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    var selectors = {
      triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
    };
  
    if (!$(selectors.triggers).length) {
      return;
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true
    });
  
    $(selectors.triggers).on('click', triggerYouTubeModal);
  
    function triggerYouTubeModal(evt) {
      evt.preventDefault();
      window.loadYouTube();
  
      if (theme.config.youTubeReady) {
        startVideoOnClick(evt);
      } else {
        $('body').on('youTubeReady', function() {
          startVideoOnClick(evt);
        });
      }
    }
  
    function startVideoOnClick(evt) {
      var $el = $(evt.target);
  
      // get video ID from URL
      var videoId = getYoutubeVideoId($el.attr('href'));
  
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
  
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
  
      var videoModalPlayer = new YT.Player('VideoHolder', args);
      modal.open();
  
      $('body').on('modalClose.VideoModal', function() {
        // Slight timeout so it is destroyed after the modal closes
        setTimeout(function() {
          videoModalPlayer.destroy();
        }, 500); // modal close css transition
      });
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  };
  
  

  theme.customerTemplates = (function() {
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
  

  theme.Product = (function() {
  
    var classes = {
      onSale: 'sale-price',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      thumbActive: 'thumb--current'
    };
  
    var selectors = {
      variantsJson: '[data-variant-json]',
      currentVariantJson: '[data-current-variant-json]',
  
      imageContainer: '[data-product-images]',
      mainSlider: '[data-product-photos]',
      thumbSlider: '[data-product-thumbs]',
      photo: '[data-product-photo]',
      photoThumbs: '[data-product-thumb]',
      photoThumbItem: '[data-product-thumb-item]',
  
      priceWrapper: '[data-price-wrapper]',
      price: '[data-product-price]',
      comparePrice: '[data-product-price-compare]',
      priceA11y: '[data-price-a11y]',
      comparePriceA11y: '[data-compare-a11y]',
      sku: '[data-sku]',
      inventory: '[data-product-inventory]',
      incomingInventory: '[data-product-incoming-inventory]',
      unitWrapper: '[data-product-unit-wrapper]',
  
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
  
      originalSelectorId: '[data-product-select]',
      singleOptionSelector: '[data-variant-input]',
      variantColorSwatch: '[data-color-swatch]',
  
      productImageMain: '.product-image-main',
      productVideo: '[data-product-video]',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
  
      modalFormHolder: '#ProductFormPlaceholder-',
      formContainer: '.product-single__form'
    };
  
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
  
    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }
  
    function initCheckVisibility(playerId) {
      if (!playerId) {
        return;
      }
  
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (!id) {
        return;
      }
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.inModal = $container.closest('.screen-layer').length;
      this.$modal;
  
      this.namespace = '.product-' + sectionId;
      this.namespaceImages = '.product-image-' + sectionId;
  
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        variantType: $container.data('variant-type'),
        inventory: $container.data('inventory') || false,
        inventoryThreshold: $container.data('inventory-threshold') || false,
        incomingInventory: $container.data('incoming-inventory') || false,
        modalInit: false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        hasImages: true,
        hasVideos: $container.find(selectors.productVideo).length || false,
        hasMultipleImages: false,
        stackedImages: $container.data('images-stacked') || false,
        stackedCurrent: 0,
        stackedImagePositions: [],
        imagesAnimating: false,
        imageSize: '620x'
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#ProductScreen-' + sectionId);
      }
  
      this.init();
    }
  
    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        this.$mainSlider = $(selectors.mainSlider, this.$container);
        this.$thumbSlider = $(selectors.thumbSlider, this.$container);
        this.$firstProductImage = this.$mainSlider.find('img').first();
        this.$formHolder = $(selectors.modalFormHolder + this.sectionId);
  
        if (!this.$firstProductImage.length) {
          this.settings.hasImages = false;
        }
  
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('productModalOpen.ProductScreen-' + this.sectionId)
            .off('productModalClose.ProductScreen-' + this.sectionId);
          $('body').on('productModalOpen.ProductScreen-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('productModalClose.ProductScreen-' + this.sectionId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.preImageSetup();
  
          this.checkIfVideos();
          this.imageSetup(true);
        }
      },
  
      formSetup: function() {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(selectors.formContainer, this.$container).find(selectors.singleOptionSelector);
        }
  
        this.initAjaxProductForm();
        this.initVariants();
      },
  
      preImageSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
      },
  
      imageSetup: function(needStylesheet) {
        if (!this.$thumbSlider.length || $(selectors.photoThumbs, this.$container).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(selectors.productImageMain, this.$container).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
  
          return;
        }
  
        this.settings.hasMultipleImages = true;
  
        if (needStylesheet) {
          slate.utils.promiseStylesheet().then(function() {
            this.createImageCarousels();
          }.bind(this));
        } else {
          this.createImageCarousels();
        }
      },
  
      initImageZoom: function() {
        var $container = $(selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container, this.sectionId);
      },
  
      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      initVariants: function() {
        var $variantJson = $(selectors.variantsJson, this.$container);
        if (!$variantJson.length) {
          return;
        }
  
        this.variantsObject = JSON.parse($variantJson[0].innerHTML);
  
        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: selectors.singleOptionSelector,
          originalSelectorId: selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        if ($(selectors.variantColorSwatch, this.$container).length) {
          $(selectors.variantColorSwatch, this.$container).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }
  
        this.variants = new slate.Variants(options);
  
        this.$container
          .on('variantChange' + this.namespace, this.updateCartButton.bind(this))
          .on('variantImageChange' + this.namespace, this.updateVariantImage.bind(this))
          .on('variantPriceChange' + this.namespace, this.updatePrice.bind(this))
          .on('variantUnitPriceChange' + this.namespace, this.updateUnitPrice.bind(this));
  
        if ($(selectors.sku, this.$container).length) {
          this.$container.on('variantSKUChange' + this.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory || this.settings.incomingInventory) {
          this.$container.on('variantChange' + this.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        var $currentVariantJson = $(selectors.currentVariantJson, this.$container);
  
        if (theme.settings.dynamicVariantsEnable && $currentVariantJson.length) {
          this.currentVariantObject = JSON.parse($currentVariantJson[0].innerHTML);
  
          this.$variantSelectors.on('change' + this.namespace, this.updateVariantAvailability.bind(this));
  
          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject, true);
        }
      },
  
      // Variant change functions
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },
  
      updateCartButton: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            $(selectors.addToCart, this.$container).removeClass(classes.disabled).prop('disabled', false);
            $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
          } else {
            // Sold out, disable the submit button and change text
            $(selectors.addToCart, this.$container).addClass(classes.disabled).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(selectors.addToCart, this.$container).addClass(classes.disabled).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          // Regular price
          $(selectors.price, this.$container).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(selectors.comparePrice, this.$container).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(selectors.priceWrapper, this.$container).removeClass('hide');
            $(selectors.price, this.$container).addClass(classes.onSale);
            $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'false');
            $(selectors.priceA11y, this.$container).attr('aria-hidden', 'false');
          } else {
            $(selectors.priceWrapper, this.$container).addClass('hide');
            $(selectors.price, this.$container).removeClass(classes.onSale);
            $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'true');
            $(selectors.priceA11y, this.$container).attr('aria-hidden', 'true');
          }
  
          if (theme.settings.currenciesEnabled) {
            theme.currencySwitcher.ajaxrefresh();
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.variant;
  
        if (variant && variant.unit_price) {
          var price = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          var base = theme.Currency.getBaseUnit(variant);
  
          $(selectors.unitWrapper, this.$container)
            .html(price + '/' + base)
            .removeClass('hide').removeClass(classes.visuallyHide);
        } else {
          $(selectors.unitWrapper, this.$container).addClass(classes.visuallyHide);
        }
      },
  
      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          $(selectors.sku, this.$container).html(newSku);
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.variant;
  
        // If we don't track variant inventory, hide stock
        if (!variant || !variant.inventory_management) {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
          variantInventoryObject = window.inventories[this.sectionId][variant.id];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(showInventory, quantity);
  
          if (!showInventory && variantInventoryObject.incoming) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      toggleInventoryQuantity: function(show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        if (show) {
          $(selectors.inventory, this.$container)
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]', qty));
        } else {
          $(selectors.inventory, this.$container).addClass('hide');
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false;
        }
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          $(selectors.incomingInventory, this.$container)
            .removeClass('hide')
            .text(string);
        } else {
          $(selectors.incomingInventory, this.$container).addClass('hide');
        }
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
  
        var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));
  
        // No image, bail
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        if (!theme.config.bpSmall && this.settings.stackedImages) {
          this.stackedScrollTo(imageIndex);
        } else {
          this.$mainSlider.slick('slickGoTo', imageIndex);
        }
      },
  
      setCurrentVariantAvailability: function(variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };
  
        // Disable all options to start
        this.disableVariantGroup($(selectors.formContainer, this.$container).find('.variant-input-wrap'));
  
        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
          if (variant.id === el.id) {
            return false;
          }
  
          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });
  
  
        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };
  
        availableVariants = Object.assign({}, variantObject, availableVariants);
  
        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;
  
            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }
  
        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
      },
  
      updateVariantAvailability: function(evt, value, index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }
  
        var variants = this.variantsObject.filter(function(el) {
          return el[optionIndex] === newVal;
        });
  
        // Disable all buttons/dropdown options that aren't the current index
        $(selectors.formContainer, this.$container).find('.variant-input-wrap').each(function(index, el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');
  
          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);
  
            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              this.enableVariantOption($group, variants[i][currentOptionIndex]);
            }
          }
        }.bind(this));
      },
  
      disableVariantGroup: function($group) {
        if (this.settings.variantType === 'dropdown') {
          $group.find('option').prop('disabled', true)
        } else {
          $group.find('input').prop('disabled', true);
          $group.find('label').toggleClass('disabled', true);
        }
      },
  
      enableVariantOptionByValue: function(array, index) {
        var $group = $(selectors.formContainer, this.$container).find('.variant-input-wrap[data-index="'+ index +'"]');
  
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption($group, array[i]);
        }
      },
  
      enableVariantOption: function($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (this.settings.variantType === 'dropdown') {
          $group.find('option[value="'+ value +'"]').prop('disabled', false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="'+ value +'"]');
          $buttonGroup.find('input').prop('disabled', false);
          $buttonGroup.find('label').toggleClass('disabled', false);
        }
      },
  
      // Image/thumbnail toggling
      initImageSwitch: function() {
        if (!$(selectors.photoThumbs, this.$container).length) {
          return;
        }
  
        var self = this;
  
        $(selectors.photoThumbs, this.$container).on('click', function(evt) {
          evt.preventDefault();
          if (!theme.config.bpSmall && this.settings.stackedImages) {
            var index = $(evt.currentTarget).data('index');
            this.stackedScrollTo(index);
          }
        }.bind(this));
      },
  
      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);
  
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
  
        var videoTypes = [];
  
        $productVideos.each(function() {
          var type = $(this).data('video-type');
  
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
  
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            window.loadYouTube();
            $('body').on('youTubeReady' + this.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
  
        // Load Vimeo API if not already loaded
        if (videoTypes.indexOf('vimeo') > -1) {
          if (!vimeoReady) {
            window.loadVimeo();
            $('body').on('vimeoReady' + this.namespace, function() {
              this.loadVimeoVideos($productVideos);
            }.bind(this))
          } else {
            this.loadVimeoVideos($productVideos);
          }
        }
  
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
  
        return videoTypes;
      },
  
      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[this.id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
  
      loadVimeoVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'vimeo') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[this.id] = {
            type: 'vimeo',
            divId: id,
            id: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height')
          };
        });
  
        // Create a new player for each Vimeo video
        for (var key in videos) {
          if (videos[key].type != 'vimeo') {
            continue;
          }
  
          var args = $.extend({}, vimeoVideoOptions, videos[key]);
          vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
        }
  
        vimeoReady = true;
      },
  
      autoplayVimeoVideo: function(id) {
        // Do not autoplay on mobile though
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(id);
        } else {
          // Set as loaded on mobile so you can see the image
          var $player = $('#' + id);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        vimeoPlayers[id].play();
  
        if (videos[id].style === 'muted') {
          vimeoPlayers[id].setVolume(0);
        }
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      stopVimeoVideo: function(id) {
        if (!theme.config.vimeoReady) {
          return;
        }
  
        if (id) {
          vimeoPlayers[id].pause();
        } else {
          for (key in vimeoPlayers) {
            if (typeof vimeoPlayers[key].pause === 'function') {
              vimeoPlayers[key].pause();
            }
          }
        }
      },
  
      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
  
          videos[this.id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height'),
            attemptedToPlay: false
          };
        });
  
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
  
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }
  
              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
  
        youtubeReady = true;
      },
  
      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          var o = this;
          setTimeout(function() {
            o.playYoutubeVideo(id, forcePlay);
          }, 1000);
          return;
        }
  
        this.playYoutubeVideo(id, forcePlay);
      },
  
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
  
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
  
      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            if (typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
  
      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
  
        $player[0].play();
      },
  
      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            if (videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
  
      stackedImagesInit: function() {
        $(window).off(this.namespaceImages);
        this.stackedImagePositions();
  
        if (this.inModal) {
          // Slight delay in modal to accommodate loading videos
          setTimeout(function() {
            this.stackedActive(this.settings.stackedCurrent);
          }.bind(this), 1000);
        } else {
          this.stackedActive(this.settings.stackedCurrent);
        }
  
  
        // update image positions on resize
        $(window).on('resize' + this.namespaceImages, $.debounce(200, this.stackedImagePositions.bind(this)));
  
        // scroll listener to mark active thumbnail
        $(window).on('scroll' + this.namespaceImages, $.throttle(200, function() {
          var goal = window.scrollY;
          var closest = this.settings.stackedImagePositions.reduce(function(prev, curr) {
            return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
          });
          var index = this.settings.stackedImagePositions.indexOf(closest)
          if (this.settings.stackedCurrent !== index) {
            this.stackedActive(index);
          }
        }.bind(this)));
      },
  
      stackedImagePositions: function() {
        var positions = [];
        $(selectors.photo, this.$container).each(function() {
          positions.push(Math.round($(this).offset().top));
        });
        this.settings.stackedImagePositions = positions;
      },
  
      stackedScrollTo: function(index) {
        // Scroll to top of large image
        var pos = $(selectors.photo, this.$container).eq(index).offset().top;
        $('html, body').animate({
          scrollTop: pos
        }, 400, 'swing');
      },
  
      stackedActive: function(index) {
        $(selectors.photoThumbItem, this.$container)
          .removeClass(classes.thumbActive)
          .eq(index).addClass(classes.thumbActive);
  
        if (this.settings.hasVideos) {
          this.stopVideo();
  
          var $video = $(selectors.photo, this.$container).eq(index).find(selectors.productVideo);
  
          if ($video.length) {
            this.initVideo($video);
          }
        }
  
        this.settings.stackedCurrent = index;
      },
  
      createImageCarousels: function() {
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
  
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));
  
        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: true,
          arrows: false,
          dots: true,
          touchThreshold: 10,
          speed: 300,
          adaptiveHeight: true,
          initialSlide: startIndex
        };
  
        this.thumbSliderArgs = {
          initialSlide: startIndex
        };
  
        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);
  
        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall matchLarge', function() {
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
        }.bind(this));
  
        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },
  
      initSliders: function(args) {
        this.destroyImageCarousels();
  
        if (!theme.config.bpSmall && this.settings.stackedImages) {
          this.stackedImagesInit();
        } else {
          this.$mainSlider.not('.slick-initialized').slick(args.main);
        }
  
        if (!theme.config.bpSmall && !this.settings.stackedImages) {
          if (this.$thumbSlider.length) {
            this.$thumbSlider.not('.slick-initialized').slick(args.thumbs);
          }
        }
      },
  
      setSliderArgs: function() {
        var args = {};
        var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
  
        if (theme.config.bpSmall) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: '#' + this.$thumbSlider.attr('id'),
            adaptiveHeight: thumbnailsVertical ? false : true,
            dots: false,
            infinite: false,
            fade: true
          });
  
          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: '#' + this.$mainSlider.attr('id'),
            slidesToShow: thumbnailsVertical ? 3 : 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbnailsVertical,
            customSlideAdvancement: true
          });
        }
  
        return args;
      },
  
      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }
  
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
  
        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },
  
      mainSlideInit: function(event, slick) {
        var $currentSlide = slick.$slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);
  
        this.settings.slickMainInitialized = true;
  
        if (!$video.length) {
          return;
        }
  
        this.initVideo($video);
      },
  
      thumbSlideInit: function(event, slick) {
        this.settings.slickThumbInitialized = true;
      },
  
      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        if (videoType === 'vimeo') {
          if (vimeoReady) {
            this.playOrShowVimeo(divId);
          } else {
            $('body').on('vimeoReady' + this.namespace, function() {
              this.playOrShowVimeo(divId);
            }.bind(this))
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
  
      stopVideo: function(id, type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopVimeoVideo();
          this.stopMp4Video();
        }
  
        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }
  
        if (type === 'mp4') {
          this.stopMp4Video(id);
        }
  
        if (type === 'vimeo') {
          this.stopVimeoVideo(id);
        }
      },
  
      playOrShowVimeo: function(id) {
        if (videos[id] && videos[id].style === 'muted') {
          this.autoplayVimeoVideo(id);
        } else if (videos[id] && videos[id].style === 'unmuted') {
          setParentAsLoaded($('#' + id));
        }
      },
  
      getVideoType: function($video) {
        return $video.data('video-type');
      },
  
      getVideoId: function($video) {
        return $video.attr('id');
      },
  
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');
  
        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
  
          if (prevVideoId) {
            this.stopVideo(prevVideoId, prevVideoType);
          }
        }
  
        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
  
          // Prep Vimeo with a backup in case the API isn't ready
          if (nextVideoId && nextVideoType === 'vimeo') {
            if (vimeoReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            } else {
              $('body').on('vimeoReady' + this.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.autoplayVimeoVideo(nextVideoId);
                }
              }.bind(this))
            }
          }
  
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
  
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
  
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
      },
  
      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }
  
        // Necessary to make slider visible again
        $(window).trigger('resize.slick');
        setTimeout(function() {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this), 500); // same timing as modal open transition
      },
  
      _slideIndex: function($el) {
        return $el.data('index');
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer' || theme.settings.cartType === 'sticky') {
          new theme.AjaxProduct($(selectors.formContainer, this.$container));
        }
      },
  
      openModalProduct: function() {
        var initialized = false;
        if (!this.settings.modalInit) {
          var url = this.$formHolder.data('url');
          var template = this.$formHolder.data('template');
  
          // If not template, product uses default product template
          // which has sections. Ajax view is a slimmed down version to
          // load only essentials
          if (!template) {
            url = url + '?view=ajax';
          }
  
          $.get(url, function(data) {
            var $template = $(data);
            var $newForm = $template.find('#AddToCartForm-' + this.sectionId);
            this.replaceModalFormHolder(this.$formHolder, $newForm);
  
            var $sectionDiv = $template.find('#ProductSections-' + this.sectionId);
            if ($sectionDiv.length) {
              this.loadProductSections($sectionDiv);
            }
  
            var $relatedDiv = $template.find('#Recommendations-' + this.sectionId);
            if ($relatedDiv.length) {
              this.loadRelatedProducts($relatedDiv);
            }
  
            var $socialDiv = $template.find('.index-section.instagram-section');
            if ($socialDiv.length) {
              this.loadSocialSection($socialDiv);
            }
  
            if (window.SPR) {
              SPR.initDomEls();SPR.loadBadges();
            }
  
            sections.loadSubSections(this.$modal);
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));
  
          this.preImageSetup();
          this.loadModalContent();
          this.imageSetup(false);
          this.settings.modalInit = true;
        } else {
          initialized = true;
          if (!theme.config.bpSmall && this.settings.stackedImages) {
            this.stackedActive(0);
          }
        }
  
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
  
        this.resizeSlides();
      },
  
      closeModalProduct: function() {
        this.stopVideo();
        $('body').off(this.namespace);
        $(window).off(this.namespace);
      },
  
      replaceModalFormHolder: function($holder, $form) {
        $holder.replaceWith($form);
        this.formSetup();
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      },
  
      loadProductSections: function($content) {
        $('#ProductSectionsHolder-' + this.sectionId).replaceWith($content);
      },
  
      loadRelatedProducts: function($content) {
        // Remove any quick view modals as they cause conflicts.
        // These are not output with product.ajax templates,
        // but are in our custom product.sections ones and any custom ones
        // developers create.
        $content.find('.screen-layer--product').remove();
  
        $('#ProductRelatedHolder-' + this.sectionId).replaceWith($content);
      },
  
      loadSocialSection: function($content) {
        $('#SocialSectionHolder-' + this.sectionId).replaceWith($content);
      },
  
      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
  
        // Lazyload mp4 videos similar to images
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
            var $el = $(video);
            var src = $el.data('video-src');
            var source = document.createElement('source');
            source.setAttribute('src', src);
            $el.append(source);
          }.bind(this));
        }
      },
  
      onUnload: function() {
        this.$container.off(this.namespace);
        $('body').off(this.namespace);
        $(window).off(this.namespace).off(this.namespaceImages);;
        this.destroyImageCarousels();
  
        if (AOS) {
          AOS.refresh();
        }
      }
    });
  
    return Product;
  })();
  
  theme.Recommendations = (function() {
  
    function Recommendations(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.selectors = {
        recommendations: '#Recommendations-' + sectionId,
        placeholder: '.product-recommendations-placeholder',
        sectionClass: ' .product-recommendations',
        productResults: '.grid-product'
      };
  
      this.init();
    }
  
    Recommendations.prototype = $.extend({}, Recommendations.prototype, {
      init: function() {
        var $section = $(this.selectors.recommendations);
  
        if (!$section.length || $section.data('enable') === false) {
          return;
        }
  
        var $placeholder = $section.find(this.selectors.placeholder);
        var id = $section.data('product-id');
        var limit = $section.data('limit');
  
        var url = '/recommendations/products?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        $placeholder.load(url + this.selectors.sectionClass, function(data) {
          theme.reinitProductGridItem($section);
  
          // If no results, hide the entire section
          if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
            $section.addClass('hide');
          }
        }.bind(this));
      }
    });
  
    return Recommendations;
  })();
  
  // Handles multiple section interactions:
  //  - Featured collection slider
  //  - Featured collection grid (hover product sliders only)
  //  - Related products
  //  - Social reviews
  //
  // Options:
  //  - scrollable: overflow div with arrows
  //  - infinite pagination: only in slider format
  
  theme.FeaturedCollection = (function() {
    var selectors = {
      scrollWrap: '[data-pagination-wrapper]',
      scrollAnimation: '[data-aos="overflow__animation"]',
      productContainer: '[data-product-container]',
      collectionProductContainer: '[data-collection-container]',
      product: '[data-product-grid]',
      arrows: '[data-arrow]'
    };
  
    var classes = {
      loading: 'collection-loading',
      arrowLeft: 'overflow-scroller__arrow--left',
      disableScrollLeft: 'overflow-scroller--disable-left',
      disableScrollRight: 'overflow-scroller--disable-right'
    };
  
    var config = {
      instagramLoaded: false
    };
  
    function FeaturedCollection(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.$scrollWrap = $(selectors.scrollWrap, this.$container);
      this.$scrollArrows = $(selectors.arrows, this.$container);
      this.namespace = '.featured-collection-' + this.sectionId;
  
      this.options = {
        scrollable: this.$container.data('scrollable'),
        paginate: this.$container.data('paginate'),
        instagram: this.$container.data('instagram')
      };
  
      var paginateBy = this.$container.data('paginate-by');
      var productCount = this.$container.data('collection-count');
  
      this.settings = {
        url: this.$container.data('collection-url'),
        page: 1,
        pageCount: this.options.paginate ? Math.ceil(productCount / paginateBy) : 0,
        itemsToScroll: 3
      };
  
      this.state = {
        isInit: false,
        loading: false,
        scrollerEnabled: false,
        loadedAllProducts: false,
        scrollable: this.options.scrollable,
        scrollInterval: null,
        scrollSpeed: 3 // smaller is faster
      };
  
      this.sizing = {
        scroller: 0,
        itemWidth: 0
      };
  
      slate.utils.promiseStylesheet().then(function() {
        this.checkVisibility();
        $(window).on('scroll' + this.namespace, $.debounce(200, this.checkVisibility.bind(this)));
      }.bind(this));
    }
  
    FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
      checkVisibility: function() {
        if (this.state.isInit) {
          // If a value is 0, we need to recalculate starting points
          if (this.sizing.scrollSize === 0) {
            this.$scrollWrap.trigger('scroll' + this.namespace);
          }
          $(window).off('scroll' + this.namespace);
          return;
        }
  
        var visibleThreshold = this.options.instagram ? 500 : 0;
  
        if (theme.isElementVisible(this.$container, visibleThreshold)) {
          if (this.options.instagram) {
            this.initInstagram();
          }
          this.init();
          this.state.isInit = true;
        }
      },
  
      init: function() {
        new theme.HoverProductGrid(this.$container);
  
        if (!this.state.scrollable) {
          return;
        }
  
        this.sizing = this.getScrollWidths();
  
        $(window).on('resize' + this.namespace, $.debounce(200, this.handleResize.bind(this)));
  
        this.toggleScrollListener(this.state.scrollable);
        this.arrowListeners(this.state.scrollable);
      },
  
      reInit: function() {
        new theme.HoverProductGrid(this.$container);
  
        if (this.state.scrollable) {
          this.sizing = this.getScrollWidths();
          this.toggleScrollListener(this.state.scrollable);
        }
  
        theme.reinitProductGridItem();
      },
  
      initInstagram: function() {
        $('.instagram-image', this.$container).each(function(i, el) {
          if ($(el).is('[data-url]')){
            this.getInstagramImage($(el));
          }
        }.bind(this));
      },
  
      getInstagramImage: function($el) {
        var instagramLink = $el.attr('data-url')
        var regex = /(instagram.com|instagr.am)\/p\/([^\/\s\?\#]+)/;
        if ( regex.test(instagramLink) ){
          var found = regex.exec(instagramLink);
          var shortcode = found.slice(-1).pop();
          var oembed_url = 'https://www.instagram.com/p/' + encodeURIComponent( shortcode ) + '/media/?size=l';
          var request = new XMLHttpRequest();
          request.open('GET', oembed_url, true);
          request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
              $el.css('background-image', 'url(' + request.responseURL + ')' );
  
              // Remove min-height now that some content is loaded
              if (!config.instagramLoaded) {
                $('.instagram-section__grid').css('min-height', '0');
                config.instagramLoaded = true;
              }
            } else {
              console.warn('Instagram request failed');
            }
          };
          request.onerror = function() {
            console.warn('Instagram request failed');
          };
          request.send();
        } else {
          $el
            .html('Invalid Instagram link. Use this format:<small>https://instagram.com/p/BeQb_V9jyDr</small>')
            .addClass('instagram-image--error');
        }
      },
  
      loadingState: function(loading) {
        this.state.loading = loading;
        this.$container.toggleClass(classes.loading, loading);
      },
  
      getScrollWidths: function() {
        var container = this.$scrollWrap.width();
        var scroller = this.$scrollWrap[0].scrollWidth;
        var itemWidth = this.$scrollWrap.find('.grid__item').first().outerWidth();
  
        // First time this runs there is a 200px CSS animation that JS doesn't
        // take into account, so manually subtract from the scroller width
        if (!this.state.isInit) {
          scroller = scroller - 200;
        }
  
        if (scroller <= container) {
          this.disableArrow(null, true);
        }
  
        return {
          scroller: scroller,
          scrollSize: scroller - container,
          itemWidth: itemWidth
        };
      },
  
      handleResize: function() {
        if (this.state.scrollable) {
          this.sizing = this.getScrollWidths();
        }
        this.toggleScrollListener(this.state.scrollable);
        this.arrowListeners(this.state.scrollable);
      },
  
      toggleScrollListener: function(enable) {
        if (enable) {
          if (this.state.scrollerEnabled) { return; }
          this.$scrollWrap.on('scroll' + this.namespace, $.throttle(250, this.scrollCheck.bind(this)));
          this.state.scrollerEnabled = true;
        } else {
          this.$scrollWrap.off('scroll' + this.namespace);
          this.state.scrollerEnabled = false;
        }
      },
  
      scrollCheck: function(evt) {
        if (this.state.loading) {
          this.toggleScrollListener(false);
          return;
        }
  
        // If a value is 0, we need to recalculate starting points
        if (this.sizing.scrollSize === 0) {
          this.sizing = this.getScrollWidths();
        }
  
        var scrollLeft = evt.currentTarget.scrollLeft ? evt.currentTarget.scrollLeft : 0;
        var percent = Math.floor(scrollLeft / this.sizing.scrollSize * 100);
        var fromEnd = this.sizing.scrollSize - scrollLeft;
  
        if (this.options.paginate) {
          if (!this.state.loadedAllProducts && percent > 50) {
            this.getNewProducts();
          }
        }
  
        if (!percent) {
          percent = 0;
        }
  
        this.disableArrow(percent);
      },
  
      arrowListeners: function(enable) {
        if (enable) {
          this.$scrollArrows
            .removeClass('hide')
            .off(this.namespace)
            .on('click' + this.namespace, this.arrowScroll.bind(this));
        } else {
          this.$scrollArrows
            .addClass('hide')
            .off(this.namespace);
        }
      },
  
      arrowScroll: function(evt) {
        var direction = $(evt.currentTarget).hasClass(classes.arrowLeft) ? 'left' : 'right';
        var iteration = theme.config.bpSmall ? 1 : 2;
  
        if (evt.type === 'mouseenter') {
          this.state.scrollInterval = setInterval(function(){
            var currentPos = this.$scrollWrap.scrollLeft();
            var newPos = direction === 'left' ? (currentPos - iteration) : (currentPos + iteration);
            this.$scrollWrap.scrollLeft(newPos);
          }.bind(this), this.state.scrollSpeed);
        } else if (evt.type === 'mouseleave') {
          clearInterval(this.state.scrollInterval);
        } else if (evt.type === 'click') {
          clearInterval(this.state.scrollInterval);
  
          var currentPos = this.$scrollWrap.scrollLeft();
          var scrollAmount = this.sizing.itemWidth * this.settings.itemsToScroll;
          var newPos = direction === 'left' ? (currentPos - scrollAmount) : (currentPos + scrollAmount);
  
          this.$scrollWrap.stop().animate({
            scrollLeft: newPos
          }, 400, 'swing');
        }
  
        if (newPos <= 0) {
          this.disableArrow(newPos);
        }
      },
  
      disableArrow: function(pos, all) {
        this.$scrollArrows
          .removeClass(classes.disableScrollRight)
          .removeClass(classes.disableScrollLeft);
  
        if (all) {
          this.$scrollArrows
            .addClass(classes.disableScrollRight)
            .addClass(classes.disableScrollLeft);
          return;
        }
  
        // Max left scroll
        if (pos <= 0) {
          this.$scrollArrows.addClass(classes.disableScrollLeft);
          return;
        }
  
        // Max right scroll
        if (pos >= 96) {
          this.$scrollArrows.addClass(classes.disableScrollRight);
          return;
        }
      },
  
      getNewProducts: function() {
        this.loadingState(true);
        var newPage = this.settings.page + 1;
  
        // No more pages, disable features
        if (newPage > this.settings.pageCount) {
          this.loadingState(false);
          this.state.loadedAllProducts = true;
          return;
        }
  
        var newUrl = this.settings.url + '?page=' + (newPage);
  
        $.get(newUrl, function(data) {
          var $template = $(data);
          var $newProducts = $template.find(selectors.collectionProductContainer + ' .grid-product');
  
          $(selectors.productContainer, this.$container).append($newProducts);
          this.ajaxSuccess();
        }.bind(this));
      },
  
      ajaxSuccess: function() {
        this.loadingState(false);
        this.settings.page = this.settings.page + 1;
        this.reInit();
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      // Only runs in the editor while a user is activating.
      // Rearranges quick shop modals to fix potentially broken layout
      onLoad: function() {
        theme.QuickShopScreens.reInit(this.$container);
      },
  
      onUnload: function() {
        $(window).off(this.namespace).trigger('resize');
        this.$scrollWrap.off(this.namespace);
        theme.QuickShopScreens.unload(this.$container);
      }
  
    });
  
    return FeaturedCollection;
  })();
  
  theme.Collection = (function() {
    var isAnimating = false;
  
    var classes = {
      tags: '.tags',
      activeTag: 'tag--active'
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      var hasHeroImage = $(container).find('.collection-hero').length;
  
      if (hasHeroImage) {
        this.checkIfNeedReload();
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {
  
          // Bail if it's a hash link
          if(location.href.indexOf(location.pathname) >= 0) {
            return true;
          }
  
          this.getNewCollectionContent(location.href);
        }
      }.bind(this));
  
      this.init();
    }
  
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        this.sectionId = this.$container.attr('data-section-id');
  
        new theme.HoverProductGrid(this.$container);
        this.sortBy();
        this.sortTags();
        this.initTagAjax();
      },
  
      initTagAjax: function() {
        this.$container.on('click' + this.namespace, '.tags a', function(evt) {
          var $el = $(evt.currentTarget);
          if ($el.hasClass('no-ajax')) {
            return;
          }
  
          evt.preventDefault();
  
          if (isAnimating) {
            return;
          }
  
          isAnimating = true;
  
          var newUrl = $el.attr('href');
          $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
          $el.parent().addClass(classes.activeTag);
          history.pushState({}, '', newUrl);
          $('.grid-product').addClass('unload');
          this.getNewCollectionContent(newUrl);
        }.bind(this));
      },
  
      getNewCollectionContent: function(url) {
        url = url + '?view=ajax';
        $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
          isAnimating = false;
          this.reInit();
        }.bind(this));
      },
  
      sortBy: function() {
        var $sortBy = $('#SortBy');
  
        if (!$sortBy.length) {
          return;
        }
  
        $sortBy.on('change', function() {
          location.href = '?sort_by=' + $(this).val();
        });
      },
  
      sortTags: function() {
        var $sortTags = $('#SortTags');
  
        if (!$sortTags.length) {
          return;
        }
  
        $sortTags.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (!theme.settings.overlayHeader) {
          return;
        }
  
        if (!$('.header-wrapper').hasClass('header-wrapper--overlay')) {
          location.reload();
        }
      },
  
      reInit: function() {
        sections.reinitSection('collection-template');
  
        theme.reinitProductGridItem();
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
      }
  
    });
  
    return Collection;
  })();
  
  theme.HeaderSection = (function() {
  
    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.initDrawers();
      theme.headerNav.init();
      theme.slideNav.init();
  
      // Reload any slideshow when the header is reloaded to make sure the
      // sticky header works as expected (it can be anywhere in the sections.instance array)
      sections.reinitSection('slideshow-section');
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      initDrawers: function() {
        if ($(document.body).hasClass('template-cart')) {
          new theme.AjaxCart('CartPage');
        } else if (theme.settings.cartType === 'drawer') {
          new theme.AjaxCart('CartDrawer');
        }
      },
  
      onUnload: function() {
        theme.headerNav.unload();
        theme.slideNav.unload();
      }
    });
  
    return Header;
  
  })();
  
  theme.FeaturedContentSection = (function() {
  
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
  
    return FeaturedContent;
  })();
  
  theme.slideshows = {};
  
  theme.SlideshowSection = (function() {
  
    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
  
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
  
      this.init();
    }
  
    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function() {
        var args = {
          arrows: $(this.slideshow).data('arrows'),
          dots: $(this.slideshow).data('dots'),
          pauseOnHover: true
        };
  
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        theme.slideshows[this.slideshow].destroy();
        delete theme.slideshows[this.slideshow];
      },
  
      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },
  
      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },
  
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
  
        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
  
      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.HeroAnimated = (function() {
  
    var classes = {
      active: 'animated__slide--active',
      inactive: 'animated__slide--inactive'
    }
  
    function HeroAnimated(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var imageCount = $container.data('count');
      var namespace = '.hero-animated-' + sectionId;
  
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
      this.$allImages = $container.find('.animated__slide');
  
      this.state = {
        active: false,
        activeIndex: 0
      };
  
      if (imageCount === 1) {
        this.setFades(true);
        return;
      }
  
      this.interval;
      this.intervalSpeed = $container.data('interval');
      this.maxIndex = imageCount - 1;
  
      slate.utils.promiseStylesheet().then(function() {
        this.checkVisibility();
        $(window).on('scroll' + namespace, $.throttle(300, this.checkVisibility.bind(this)));
      }.bind(this));
    }
  
    HeroAnimated.prototype = $.extend({}, HeroAnimated.prototype, {
      checkVisibility: function() {
        if (!theme.isElementVisible(this.$container)) {
          this.state.active = false;
          clearInterval(this.interval);
          return;
        }
  
        if (this.state.active) {
          return;
        }
  
        this.initInterval();
      },
  
      initInterval: function() {
        this.state.active = true;
  
        this.setFades(true);
        this.interval = setInterval(function() {
          this.setFades();
        }.bind(this), this.intervalSpeed);
      },
  
      setFades: function(first) {
        // Get next image index
        var nextIndex = this.state.activeIndex === this.maxIndex ? 0 : this.state.activeIndex + 1;
  
        if (first) {
          nextIndex = this.state.activeIndex;
        }
  
        // Unset existing image
        if (!first) {
          this.$allImages.eq(this.state.activeIndex)
            .removeClass(classes.active)
            .addClass(classes.inactive);
        }
  
        // Set next image as active
        this.$allImages.eq(nextIndex)
          .removeClass(classes.inactive)
          .addClass(classes.active);
  
        this.state.activeIndex = nextIndex;
      },
  
      onUnload: function() {
        clearInterval(this.interval);
      }
    });
  
    return HeroAnimated;
  })();
  
  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
  
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };
  
    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
  
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
  
      this.vimeoPlayer = [];
  
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
  
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
  
      if ($mp4Div.length) {
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected
          setParentAsLoaded($mp4Div);
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          setParentAsLoaded($mp4Div);
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }
  
    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }
  
    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Play video if in view
      slate.utils.promiseStylesheet().then(function() {
        videoVisibilityCheck(playerId);
  
        // Add out of view pausing
        $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
      });
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (!id) {
        return;
      }
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (id && id.data) {
          playerId = id.data.id;
        } else {
          return;
        }
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false
        };
  
        if (!youtubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
  
      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
  
        youtubeReady = true;
      },
  
      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
  
      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        if (youtubePlayers[playerId]) {
          youtubePlayers[playerId].destroy();
        }
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
  
    return videoSection;
  })();
  
  theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
  
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
  
      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        this.init($slider, defaults);
      }.bind(this));
    }
  
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
  
        obj.slick(args);
        this.sliderActive = true;
  
        if (AOS) {
          AOS.refresh();
        }
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Testimonials;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: $container.data('test-mode')
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }
  
      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
  
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      },
  
      onUnload: function() {}
    });
  
    return NewsletterPopup;
  })();
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
  
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };
  
    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
  
      if (!this.key) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }
  
    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
  
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
  
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
  
        deferred.resolve(results);
      });
  
      return deferred;
    }
  
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
  
      createMap: function() {
        var $map = this.$map;
  
        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
  
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
  
    return Map;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');
  
        if (!$filterBy.length) {
          return;
        }
  
        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      onUnload: function() {
  
      }
    });
  
    return Blog;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.product__photo-zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };
  
    function Photoswipe($container, sectionId) {
      this.$container = $container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;
  
      if ($container.attr('data-zoom') === 'false') {
        return;
      }
  
      if ($container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var $trigger = this.$container.find(selectors.trigger);
        this.$images = this.$container.find(selectors.images);
        var items = [];
  
        // Init gallery on active image
        $trigger.on('click' + this.namespace, function(evt) {
          items = this.getImageData();
          if (this.inSlideshow || theme.config.bpSmall) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items, index);
        }.bind(this));
      },
  
      getImageData: function() {
        var haveImages = false;
        var items = [];
        var options = {};
  
        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  
        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
  
        // If need to destroy it
        // this.gallery.destroy();
      },
  
      afterChange: function() {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo', newIndex);
          }
        }
      }
    });
  
    return Photoswipe;
  })();
  
  

  // Breakpoint values are used throughout many templates.
  // We strongly suggest not changing them globally.
  theme.bp = {};
  theme.bp.smallUp = 769;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    cssLoaded: false,
    bpSmall: false,
    hasSessionStorage: true,
    mediaQuerySmall: 'screen and (max-width: '+ theme.bp.small +'px)',
    mediaQuerySmallUp: 'screen and (min-width: '+ theme.bp.smallUp +'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false
  };

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  };

  window.loadYouTube = function() {
    if (theme.config.youtubeReady) {
      return;
    }

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  };

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  };

  theme.init = function() {
    theme.setGlobals();
    theme.pageTransitions();
    theme.QuickShopScreens.init();
    theme.articleImages.init();
    theme.collapsibles.init();
    if (theme.settings.cartType === 'sticky') {
      new theme.StickyCart.init();
    }
    theme.customerTemplates.init();
    if (theme.settings.currenciesEnabled) {
      theme.currencySwitcher.init();
    }
    theme.videoModal();
    slate.rte.init();

    $(document.documentElement).on('keyup.tab', function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });

    // Two ways to determine if page was loaded from cache from back button
    // Most use `pageshow` + evt.persisted, Chrome uses `performance.navigation.type`
    window.addEventListener('pageshow', function(evt) {
      if (evt.persisted) {
        theme.refreshCart();
      }
    });

    if (performance && performance.navigation.type === 2) {
      theme.refreshCart();
    }
  };

  theme.refreshCart = function() {
    if (theme.settings.cartType === 'sticky' && theme.StickyCart) {
      $.getJSON('/cart.js').then(function(cart) {
        theme.StickyCart.refresh(cart);
      })
    }
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isSessionStorageSupported();

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });

    enquire.register(theme.config.mediaQuerySmallUp, {
      match: function() {
        $('body').trigger('matchLarge');
      },
      unmatch: function() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  }

  theme.isSessionStorageSupported = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= (0 - (threshold / 1.5)) &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.pageTransitions = function() {
    if ($('body').data('transitions') == true) {

      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (theme.config.isSafari) {
        $('a').on('click', function() {
          window.setTimeout(function() {
            $('body').removeClass('unloading');
          }, 1200);
        });
      }

      // Add disable transition class to malito, anchor, and YouTube links
      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
        $(this).addClass('js-no-transition');
      });

      $('a:not(.js-no-transition)').on('click', function(evt) {
        if (evt.metaKey) return true;

        var src = $(this).attr('href');

        // Bail if it's a hash link
        if(src.indexOf(location.pathname) >= 0 && src.indexOf('#') >= 0) {
          return true;
        }

        evt.preventDefault();
        $('body').addClass('unloading');
        window.setTimeout(function() {
          location.href = src;
        }, 50);
      });
    }
  };

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  theme.initSecondary = function() {
    document.body.classList.add('js-animate');
    AOS.init({
      easing: 'ease-out-quad',
      once: false,
      mirror: true,
      offset: 100,
      disableMutationObserver: true
    });

    document.addEventListener('lazyloaded', function(evt) {
      var $img = $(evt.target);
      if ($img.length) {
        $img.parent().addClass('loaded');
      }
    });

    document.dispatchEvent(new CustomEvent('page:loaded'));

    theme.reviewAppLinkListener();
    theme.checkForAnchorLink();
  };

  theme.reviewAppLinkListener = function() {
    $('body').on('click', '.spr-pagination', function() {
      var $scroller = $(this).closest('.spr-reviews').scrollLeft(0);
    });
  };

  theme.checkForAnchorLink = function() {
    if(window.location.hash) {
      var $el = $(window.location.hash);
      if ($el.length) {
        var top = $el.offset().top - 100;
        if (top > 0) {
          window.scroll(0, top);
        }
      }
    }
  };

  theme.reinitProductGridItem = function($scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    // Refresh currency
    if (theme.settings.currenciesEnabled) {
      theme.currencySwitcher.ajaxrefresh();
    }

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();SPR.loadBadges();
    }

    // Re-register product templates in quick view modals.
    // Will not double-register.
    // theme.initQuickShop(true);
    // sections.register('product-template', theme.Product, $scope);

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  $(document).ready(function() {
    theme.init();

    // Init CSS-dependent scripts
    slate.utils.promiseStylesheet().then(function() {
      theme.initSecondary();
    });

    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('hero-animated', theme.HeroAnimated);
    sections.register('video-section', theme.VideoSection);
    sections.register('product', theme.Product);
    sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template', theme.Product);
    sections.register('featured-collection', theme.FeaturedCollection);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('testimonials', theme.Testimonials);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
  });

})(theme.jQuery);
